import { jsx as at, jsxs as Ne, Fragment as ze } from "react/jsx-runtime";
import { T as C9, f as Pe, C as N9, V as P9, c as L9, e as T9 } from "./command-ClHioAv1.js";
import { useState as jt, useEffect as se, forwardRef as N1, useRef as bn, useImperativeHandle as w9, useCallback as Le, useMemo as R9 } from "react";
import { $ as Et } from "./utils-CTvPli9r.js";
import { Badge as D9 } from "./badge.js";
import { X as An } from "./x-Bns8qHU3.js";
function B9(e, t) {
  const [r, n] = jt(e);
  return se(() => {
    const d = setTimeout(() => {
      n(e);
    }, t);
    return () => {
      clearTimeout(d);
    };
  }, [e, t]), r;
}
function j(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function j9(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var d = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, d.get ? d : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Ht = {}, Vt = {}, J = {}, X = {}, _n;
function ke() {
  if (_n) return X;
  _n = 1, Object.defineProperty(X, "__esModule", { value: !0 }), X.PropValueProvider = X.IdentityProvider = X.ValueProvider = void 0, X.nullIfEmpty = e, X.trimBlank = t, X.trimStrings = r, X.nvl = n, X.isBlank = d, X.isBlankObject = a, X.isEmpty = o, X.omit = u, X.omitUntyped = i, X.pick = s, X.pickAndSkipUndefined = c, X.pickUntyped = l, X.isPrimitiveValue = $, X.mapObject = b, X.assignOwnProps = m, X.prop = f, X.deepSortObject = O;
  function e(y) {
    return y && Object.entries(y).find(([M, N]) => !d(N)) ? y : null;
  }
  function t(y) {
    if (d(y))
      return;
    if (typeof y != "object" || y instanceof Date)
      return y;
    if (Array.isArray(y))
      return y.map((x) => t(x)).filter((x) => !d(x));
    let M = !1, N = !1;
    const D = Object.entries(y).reduce((x, [A, S]) => {
      const P = t(S);
      return Array.isArray(P) ? (x[A] = P, P.length && (N = !0)) : d(P) || (x[A] = P, M = !0), x;
    }, {});
    return M || N ? D : void 0;
  }
  function r(y) {
    return typeof y == "string" ? y.trim() : typeof y == "object" ? Object.entries(y).reduce((M, [N, D]) => (M[N] = r(D), M), {}) : Array.isArray(y) ? y.map((M) => r(M)) : y;
  }
  function n(y, M) {
    return d(y) ? M : y;
  }
  function d(y) {
    return y == null;
  }
  function a(y) {
    return y == null ? !0 : !Object.entries(y).find(([M, N]) => !d(N));
  }
  function o(y) {
    return y == null || y === "";
  }
  function u(y, ...M) {
    const N = Object.assign({}, y);
    return M.forEach((D) => delete N[D]), N;
  }
  function i(y, ...M) {
    const N = Object.assign({}, y);
    return M.forEach((D) => delete N[D]), N;
  }
  function s(y, ...M) {
    return M.reduce((N, D) => (N[D] = y[D], N), {});
  }
  function c(y, ...M) {
    return M.reduce((N, D) => (y[D] !== void 0 && (N[D] = y[D]), N), {});
  }
  function l(y, ...M) {
    return M.reduce((N, D) => (N[D] = y[D], N), {});
  }
  function $(y) {
    const M = typeof y;
    return y == null || M === "string" || M === "number" || M === "boolean" || M === "undefined" || M === "bigint" || M === "symbol" || y instanceof Date;
  }
  function b(y, M) {
    return y && Object.fromEntries(Object.entries(y).map(M));
  }
  function m(y, M) {
    Object.getOwnPropertyNames(y).forEach((N) => {
      y[N] = M[N];
    });
  }
  function f(y, M) {
    if (d(y) || o(M))
      return y;
    let N = y;
    const D = M.split(".");
    for (const x of D)
      if (N = N[x.trim()], d(N))
        return N;
    return N;
  }
  class v {
    // noinspection TypeScriptAbstractClassConstructorCanBeMadeProtected
    constructor(M) {
      this.obj = M;
    }
  }
  X.ValueProvider = v;
  class h extends v {
    get value() {
      return "getId" in this.obj ? { id: this.obj.getId() } : { id: this.obj.id };
    }
  }
  X.IdentityProvider = h;
  class _ extends v {
    constructor(M, N) {
      super(M), this.prop = N;
    }
    get value() {
      return f(this.obj, this.prop);
    }
  }
  X.PropValueProvider = _;
  function O(y) {
    const M = y;
    if (typeof M != "object" || M === null)
      return M;
    if (Array.isArray(M))
      return M.map(O);
    const N = Object.keys(M).sort(), D = {};
    return N.forEach((x) => {
      const A = M[x];
      D[x] = typeof A == "object" && A !== null && !(A instanceof Date) ? O(A) : A;
    }), D;
  }
  return X;
}
var q = {}, Mn;
function ce() {
  if (Mn) return q;
  Mn = 1, Object.defineProperty(q, "__esModule", { value: !0 }), q.split = t, q.camel2snake = r, q.camel2spine = n, q.pascal2camel = d, q.pascal2snake = a, q.pascal2spine = o, q.toPascal = u, q.toSpine = i, q.toSnake = s, q.toCamel = c, q.circularDepsReplacer = l, q.json = $, q.jsonStable = b, q.stringifySafe = m, q.lpad = h, q.rpad = _, q.replaceAll = O, q.randomString = y, q.randomCode = M, q.randomDigits = N, q.reverse = D, q.hashCode = x;
  const e = ke();
  function t(A, S) {
    return [A.slice(0, S), A.slice(S)];
  }
  function r(A) {
    return A.replace(/[A-Z]/g, (S) => "_" + S.toLowerCase());
  }
  function n(A) {
    return A.replace(/[A-Z]/g, (S) => "-" + S.toLowerCase());
  }
  function d(A) {
    return A.charAt(0).toLowerCase() + A.slice(1);
  }
  function a(A) {
    return A.charAt(0).toLowerCase() + r(A.slice(1));
  }
  function o(A) {
    return A.charAt(0).toLowerCase() + n(A.slice(1));
  }
  function u(A, S = !1) {
    let P = A.split(/([_-]\w)/g).map((Z) => Z.startsWith("_") || Z.startsWith("-") ? Z.slice(1).toUpperCase() : Z).join("");
    return S && (P = P.split(/([A-Z]+)/g).map((Z) => Z.length > 1 && Z.match(/[A-Z]+/) ? Z.charAt(0) + Z.slice(1).toLowerCase() : Z).join("")), P.charAt(0).toUpperCase() + P.slice(1);
  }
  function i(A) {
    return o(u(A, !0).replace(/ +/, "-"));
  }
  function s(A) {
    return a(u(A, !0).replace(/ +/, "_"));
  }
  function c(A) {
    return d(u(A, !0).replace(/ +/, ""));
  }
  function l() {
    const A = [];
    return function(S, P) {
      if (typeof P == "object" && P !== null) {
        if (A.indexOf(P) !== -1)
          return;
        A.push(P);
      }
      return typeof P == "bigint" ? "big:" + P.toString() : P;
    };
  }
  function $(A, S = " ", P) {
    return JSON.stringify(A, P ?? l(), S === !1 ? "" : S);
  }
  function b(A, S = !1, P) {
    return $((0, e.deepSortObject)(A), S, P);
  }
  function m(A, S, P = "*****") {
    return $(f(A, S ?? [/password/gi, /secret/gi, /key/gi, /token/gi], P));
  }
  function f(A, S, P) {
    return (0, e.isPrimitiveValue)(A) ? A : Object.entries(A).reduce((Z, [G, K]) => (S.some((Y) => Y.test(G)) && (0, e.isPrimitiveValue)(K) ? Z[G] = P : (0, e.isPrimitiveValue)(K) ? Z[G] = K : Array.isArray(K) ? Z[G] = K.map((Y) => f(Y, S, P)) : Z[G] = f(K, S, P), Z), {});
  }
  function v(A, S) {
    return A > 0 ? S.repeat(A / S.length + 1).slice(0, A) : "";
  }
  function h(A, S, P = " ") {
    return v(S - `${A}`.length, P) + A;
  }
  function _(A, S, P = " ") {
    return A + v(S - `${A}`.length, P);
  }
  function O(A, S, P) {
    return A.replace(
      // eslint-disable-next-line security/detect-non-literal-regexp
      typeof S == "string" ? new RegExp(S, "g") : S,
      P
    );
  }
  function y(A, S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789") {
    return new Array(A).fill(null).map(() => S.charAt(Math.floor(Math.random() * S.length))).join("");
  }
  function M(A, S = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789") {
    return y(A, S);
  }
  function N(A) {
    return y(A, "0123456789");
  }
  function D(A) {
    return A.split("").reverse().join("");
  }
  function x(A, S = Number.MAX_SAFE_INTEGER, P = !0) {
    A = P ? D(A) : A;
    const Z = 37;
    let G = 17;
    if (A.length === 0)
      return G;
    for (let K = 0; K < A.length; K++) {
      const Y = A.charCodeAt(K) + (7 ^ K);
      G = Z * G + Y;
    }
    return Math.abs(G) % S;
  }
  return q;
}
var Sn;
function F9() {
  if (Sn) return J;
  Sn = 1, Object.defineProperty(J, "__esModule", { value: !0 }), J.ConcurrentUpdateError = J.DataValidationError = J.ValidationError = J.NotFoundError = J.UnauthorizedImpersonationError = J.AuthorizationError = J.AuthenticationError = J.AppError = J.HttpError = J.TimeoutError = J.Exception = void 0;
  const e = ke(), t = ce();
  class r extends Error {
    constructor(m, f) {
      var v, h, _, O;
      super(typeof m == "string" ? m : (v = m == null ? void 0 : m.message) !== null && v !== void 0 ? v : (0, t.json)(m, !1)), this.body = m, this.root = f, this.stack = ((h = this.stack) !== null && h !== void 0 ? h : "") + (f ? `
Root: ` + ((O = (_ = f.stack) !== null && _ !== void 0 ? _ : f.message) !== null && O !== void 0 ? O : f) : ""), Object.setPrototypeOf(this, r.prototype);
    }
  }
  J.Exception = r;
  class n extends r {
    constructor(m, f) {
      super(m ?? "Timeout happened", f), Object.setPrototypeOf(this, n.prototype);
    }
  }
  J.TimeoutError = n;
  class d extends r {
    constructor(m, f, v = 400) {
      super(m, f), this.status = v, Object.setPrototypeOf(this, d.prototype);
    }
  }
  J.HttpError = d;
  class a extends d {
    constructor(m, f, v, h, _ = 409) {
      super({ message: m, code: f, args: h }, v, _), this.message = m, this.code = f, this.args = h, Object.setPrototypeOf(this, a.prototype);
    }
  }
  J.AppError = a;
  class o extends a {
    constructor(m, f, v) {
      super(m ?? "Authentication failed.", f ?? "authentication-failed", v, void 0, 401), Object.setPrototypeOf(this, o.prototype);
    }
  }
  J.AuthenticationError = o;
  class u extends a {
    constructor(m, f, v) {
      super(m ?? "Authorization failed.", f ?? "unauthorized", v, void 0, 403), Object.setPrototypeOf(this, u.prototype);
    }
  }
  J.AuthorizationError = u;
  class i extends u {
    constructor(m, f, v) {
      super(m ?? "Unauthorized impersonation.", f ?? "unauthorized-impersonation", v), Object.setPrototypeOf(this, i.prototype);
    }
  }
  J.UnauthorizedImpersonationError = i;
  class s extends d {
    constructor(m, f) {
      super((0, e.nullIfEmpty)({ message: m }), f, 404), Object.setPrototypeOf(this, s.prototype);
    }
  }
  J.NotFoundError = s;
  class c extends d {
    constructor(m, f) {
      super((0, e.nullIfEmpty)({ message: m }), f, 400), Object.setPrototypeOf(this, c.prototype);
    }
  }
  J.ValidationError = c;
  class l extends d {
    constructor(m) {
      super({ errors: m }, 400), Object.setPrototypeOf(this, l.prototype), this.errors = m;
    }
  }
  J.DataValidationError = l;
  class $ extends r {
    constructor(m, f) {
      super(m ?? "Concurrent update happened", f), Object.setPrototypeOf(this, $.prototype);
    }
  }
  return J.ConcurrentUpdateError = $, J;
}
var In = {}, On;
function Z9() {
  return On || (On = 1, Object.defineProperty(In, "__esModule", { value: !0 })), In;
}
var xn;
function U9() {
  return xn || (xn = 1, function(e) {
    var t = Vt && Vt.__createBinding || (Object.create ? function(n, d, a, o) {
      o === void 0 && (o = a);
      var u = Object.getOwnPropertyDescriptor(d, a);
      (!u || ("get" in u ? !d.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return d[a];
      } }), Object.defineProperty(n, o, u);
    } : function(n, d, a, o) {
      o === void 0 && (o = a), n[o] = d[a];
    }), r = Vt && Vt.__exportStar || function(n, d) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(d, a) && t(d, n, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(F9(), e), r(Z9(), e);
  }(Vt)), Vt;
}
var me = {}, En;
function P1() {
  if (En) return me;
  En = 1, Object.defineProperty(me, "__esModule", { value: !0 }), me.grow = e, me.flatten = t;
  function e(o, u = "", i = "_") {
    return Array.isArray(o) ? o.map((s) => n(s, u, i)) : n(o, u, i);
  }
  function t(o, u = "", i = "_") {
    return Array.isArray(o) ? o.map((s) => a(s, i)).map((s) => r(s, u)) : r(a(o, i), u);
  }
  function r(o, u) {
    const i = {};
    return Object.entries(o).forEach(([s, c]) => {
      i[u + s] = c;
    }), i;
  }
  function n(o, u, i) {
    if (o == null)
      return o;
    const s = {};
    return Object.entries(o).filter(([c]) => c.startsWith(u)).map(([c, l]) => [c.replace(u, ""), l]).forEach(([c, l]) => {
      const $ = c.split(i), b = $.splice(-1, 1);
      let m = s;
      $.forEach((f) => {
        m = d(m, f);
      }), m[b] = l;
    }), s;
  }
  function d(o, u, i) {
    return o[u] === void 0 && (i === void 0 && (i = {}), o[u] = i), o[u];
  }
  function a(o, u, i = [], s = {}) {
    let c = Object.assign({}, s);
    for (const l in o) {
      const $ = [...i, l];
      if (Array.isArray(o[l]))
        c[$.join(u)] = o[l];
      else if (typeof o[l] == "object") {
        const b = a(o[l], u, $, {});
        c = Object.assign(Object.assign({}, c), b);
      } else
        c[$.join(u)] = o[l];
    }
    return c;
  }
  return me;
}
var Cn = {}, ge = {}, Nn;
function L1() {
  if (Nn) return ge;
  Nn = 1, Object.defineProperty(ge, "__esModule", { value: !0 }), ge.inTimezone = t, ge.msToDuration = d;
  const e = ce();
  function t(a, o, u) {
    return new Date(a.toLocaleString(u, {
      timeZone: o
    }));
  }
  const r = {
    ms: 0,
    s: 1,
    m: 2,
    h: 3,
    d: 4
  };
  function n(a, o) {
    return r[a] > r[o];
  }
  function d(a, o = "d") {
    const u = Math.floor(a % (n(o, "ms") ? 1e3 : Number.MAX_SAFE_INTEGER)), i = Math.floor(a / 1e3 % (n(o, "s") ? 60 : o === "s" ? Number.MAX_SAFE_INTEGER : 1)), s = Math.floor(a / 1e3 / 60 % (n(o, "m") ? 60 : o === "m" ? Number.MAX_SAFE_INTEGER : 1)), c = Math.floor(a / 1e3 / 60 / 60 % (n(o, "h") ? 24 : o === "h" ? Number.MAX_SAFE_INTEGER : 1)), l = o === "d" ? Math.floor(a / 1e3 / 60 / 60 / 24 % 24) : 0;
    let $ = "";
    if (l || $.length) {
      const b = `${l}`;
      $ += `${b}d `;
    }
    if (c || $.length) {
      const b = n(o, "h") && $.length ? (0, e.lpad)(c, 2, "0") : `${c}`;
      $ += `${b}h `;
    }
    if (s || $.length) {
      const b = n(o, "m") && $.length ? (0, e.lpad)(s, 2, "0") : `${s}`;
      $ += `${b}m `;
    }
    if (i || $.length) {
      const b = n(o, "s") && $.length ? (0, e.lpad)(i, 2, "0") : `${i}`;
      $ += `${b}s `;
    }
    if (u || $.length) {
      const b = n(o, "ms") && $.length ? (0, e.lpad)(u, 3, "0") : `${u}`;
      $ += `${b}ms`;
    }
    return $;
  }
  return ge;
}
var Pn;
function G9() {
  return Pn || (Pn = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.noopLogger = e.NoopLogger = e.SimpleConsoleLogger = e.BareConsoleLogger = e.BaseLogger = e.ContextHolder = e.logLevelWeights = e.LogLevel = void 0, e.utcTimeString = c, e.localTimeString = l, e.getMessageText = b;
    const t = L1(), r = ke(), n = ce();
    var d;
    (function(m) {
      m.off = "off", m.fatal = "fatal", m.error = "error", m.warn = "warn", m.info = "info", m.trace = "trace", m.debug = "debug";
    })(d || (e.LogLevel = d = {})), e.logLevelWeights = {
      [d.off]: 0,
      [d.fatal]: 1,
      [d.error]: 2,
      [d.warn]: 3,
      [d.info]: 4,
      [d.trace]: 5,
      [d.debug]: 6
    };
    class a {
      constructor(f) {
        this.name = f;
      }
    }
    e.ContextHolder = a;
    class o {
      constructor(f, v) {
        var h, _;
        this.config = f, this.ctx = v, this._context = (_ = (h = this.config) === null || h === void 0 ? void 0 : h.format) === null || _ === void 0 ? void 0 : _.context;
      }
      log(f, ...v) {
        var h, _, O, y, M, N;
        if (!this.isEnabled(f))
          return;
        const D = /* @__PURE__ */ new Date(), x = !((_ = (h = this.config) === null || h === void 0 ? void 0 : h.format) === null || _ === void 0) && _.timezone ? `${l(D, this.config.format.timezone)} in ${this.config.format.timezone}` : "", A = c(D) + (x ? ` (${x})` : "");
        let S = (N = (O = this.getContext()) !== null && O !== void 0 ? O : (M = (y = this.config) === null || y === void 0 ? void 0 : y.format) === null || M === void 0 ? void 0 : M.context) !== null && N !== void 0 ? N : "MAIN";
        const P = v[v.length - 1];
        P instanceof a && (S = P.name, v = v.slice(0, -1));
        const Z = {
          timestamp: A,
          context: S
        }, G = v.map((K) => (typeof K == "function" && (K = K()), K)).map((K) => {
          var Y, it;
          return b(K, !1, (it = (Y = this.config) === null || Y === void 0 ? void 0 : Y.format) === null || it === void 0 ? void 0 : it.objectFormat);
        });
        this.logMessages(f, Z, ...G);
      }
      debug(...f) {
        this.log(d.debug, ...f);
      }
      info(...f) {
        this.log(d.info, ...f);
      }
      trace(...f) {
        this.log(d.trace, ...f);
      }
      warn(...f) {
        this.log(d.warn, ...f);
      }
      error(...f) {
        this.log(d.error, ...f);
      }
      fatal(...f) {
        this.log(d.fatal, ...f);
      }
      isEnabled(f) {
        var v, h;
        return e.logLevelWeights[(h = (v = this.config) === null || v === void 0 ? void 0 : v.level) !== null && h !== void 0 ? h : d.debug] >= e.logLevelWeights[f];
      }
      setContext(f) {
        this._context = f;
      }
      getContext() {
        return this._context;
      }
    }
    e.BaseLogger = o;
    class u extends o {
      constructor(f = d.debug) {
        super({
          level: f
        }), this.level = f;
      }
      clone() {
        return new u(this.level);
      }
      logMessages(f, v, ...h) {
        const _ = `${h.join(`
`)}`;
        switch (f) {
          case d.fatal:
          case d.error:
            console.error(_);
            break;
          case d.warn:
            console.warn(_);
            break;
          case d.info:
          case d.trace:
            console.info(_);
            break;
          case d.debug:
            console.debug(_);
            break;
          default:
            console.log(_);
        }
      }
    }
    e.BareConsoleLogger = u;
    class i extends o {
      constructor(f, v) {
        super(typeof f == "string" ? void 0 : f), typeof f == "string" ? this.setContext(f) : (this.config = f, this.ctx = v);
      }
      clone() {
        return new i(this.config, this.ctx);
      }
      logMessages(f, v, ...h) {
        var _, O, y, M;
        const N = !((_ = this.ctx) === null || _ === void 0) && _.getId() ? ` <${this.ctx.getId()}>` : "", D = `${v.timestamp} ${(0, n.lpad)(f.toUpperCase(), 5)}: [${(0, n.rpad)(v.context, (M = (y = (O = this.config) === null || O === void 0 ? void 0 : O.format) === null || y === void 0 ? void 0 : y.contextPadding) !== null && M !== void 0 ? M : 0)}]${N} ${h.join(`
`)}`;
        switch (f) {
          case d.fatal:
          case d.error:
            console.error(D);
            break;
          case d.warn:
            console.warn(D);
            break;
          case d.info:
          case d.trace:
            console.info(D);
            break;
          case d.debug:
            console.debug(D);
            break;
          default:
            console.log(D);
        }
      }
    }
    e.SimpleConsoleLogger = i;
    class s extends i {
      clone() {
        return new s(this.config, this.ctx);
      }
      isEnabled(f) {
        return !1;
      }
    }
    e.NoopLogger = s, e.noopLogger = new s();
    function c(m) {
      return `${m.getUTCFullYear()}-${(0, n.lpad)(m.getUTCMonth() + 1, 2, "0")}-${(0, n.lpad)(m.getUTCDate(), 2, "0")} ${(0, n.lpad)(m.getUTCHours(), 2, "0")}:${(0, n.lpad)(m.getUTCMinutes(), 2, "0")}:${(0, n.lpad)(m.getUTCSeconds(), 2, "0")}.${(0, n.lpad)(m.getUTCMilliseconds(), 3, "0")}`;
    }
    function l(m, f) {
      return m = (0, t.inTimezone)(m, f), `${m.getFullYear()}-${(0, n.lpad)(m.getMonth() + 1, 2, "0")}-${(0, n.lpad)(m.getDate(), 2, "0")} ${(0, n.lpad)(m.getHours(), 2, "0")}:${(0, n.lpad)(m.getMinutes(), 2, "0")}:${(0, n.lpad)(m.getSeconds(), 2, "0")}.${(0, n.lpad)(m.getMilliseconds(), 3, "0")}`;
    }
    function $(m, f) {
      var v;
      return m instanceof Error ? (v = m.stack) !== null && v !== void 0 ? v : m.message : m === null ? "NULL" : m === void 0 ? "UNDEFINED" : (0, r.isPrimitiveValue)(m) ? m : f === "text" ? m.toString() : f === "compact-json" ? (0, n.json)(m, !1) : (0, n.json)(m);
    }
    function b(m, f, v) {
      if (Array.isArray(m)) {
        const h = m.map((_) => $(_, "compact-json"));
        return f ? h.join(`
`) : (0, n.json)(h);
      }
      return m instanceof Map ? (0, n.json)(Object.fromEntries([...m])) : m instanceof Set ? (0, n.json)([...m]) : $(m, v);
    }
  }(Cn)), Cn;
}
var Q = {}, Ln;
function k9() {
  if (Ln) return Q;
  Ln = 1, Object.defineProperty(Q, "__esModule", { value: !0 }), Q.or = t, Q.and = r, Q.sum = n, Q.count = d, Q.avg = a, Q.unique = o, Q.array2Map = u, Q.array2ArrayMap = i, Q.zip = s, Q.last = c, Q.first = l, Q.range = $, Q.charRange = b, Q.splitArray = m, Q.chunkArray = f, Q.rotateLeft = v, Q.rotateRight = h, Q.diff = _, Q.intersect = O, Q.union = y, Q.hasAny = M, Q.hasAll = N, Q.hasNone = D;
  const e = ce();
  function t(x, A = (S) => !!S) {
    return x.reduce((S, P) => S || A(P), !1);
  }
  function r(x, A = (S) => !!S) {
    return x.reduce((S, P) => S && A(P), !0);
  }
  function n(x, A = (S) => S) {
    return x.reduce((S, P) => S + A(P), 0);
  }
  function d(x, A = (S) => S ? 1 : 0) {
    return x.reduce((S, P) => S + A(P), 0);
  }
  function a(x, A = (S) => S) {
    return x.length ? n(x, A) / x.length : 0;
  }
  function o(x, A, S) {
    if (!(x != null && x.length))
      return [];
    A || (A = (G) => (0, e.json)(G, !1));
    const P = {}, Z = [];
    for (const G of x) {
      const K = A(G), Y = P[K];
      Y === void 0 ? (P[K] = Z.length, Z.push(G)) : S && (Z[Y] = G);
    }
    return Z;
  }
  function u(x, A = (S) => (0, e.json)(S, !1)) {
    if (!(x != null && x.length))
      return {};
    const S = {};
    for (const P of x) {
      const Z = A(P);
      S[Z] = P;
    }
    return S;
  }
  function i(x, A = (S) => (0, e.json)(S, !1)) {
    var S;
    if (!(x != null && x.length))
      return {};
    const P = {};
    for (const Z of x) {
      const G = A(Z);
      ((S = P[G]) !== null && S !== void 0 ? S : P[G] = []).push(Z);
    }
    return P;
  }
  function s(...x) {
    return Array(Math.max(...x.map((A) => A.length))).fill(0).map((A, S) => x.map((P) => P[S]));
  }
  function c(x) {
    return x[x.length - 1];
  }
  function l(x) {
    return x[0];
  }
  function $(x, A = 0) {
    return [...Array(x).keys()].map((S) => S + A);
  }
  function b(x, A) {
    return $(A.charCodeAt(0) - x.charCodeAt(0) + 1, x.charCodeAt(0)).map((S) => String.fromCharCode(S));
  }
  function m(x, A) {
    const S = A >= 0 ? A : x.length + A;
    return [x.slice(0, S), x.slice(S)];
  }
  function f(x, A) {
    if (A <= 0)
      throw new Error("Chunk size must be greater than 0");
    const S = [];
    for (let P = 0; P < x.length; P += A)
      S.push(x.slice(P, P + A));
    return S;
  }
  function v(x) {
    const [A, S] = m(x, 1);
    return [...S, ...A];
  }
  function h(x) {
    const [A, S] = m(x, -1);
    return [...S, ...A];
  }
  function _(x, A, S = (P, Z) => P === Z) {
    const P = [];
    for (const Z of x)
      A.some((G) => S(Z, G)) || P.push(Z);
    return P;
  }
  function O(x, A, S = (P, Z) => P === Z) {
    const P = [];
    for (const Z of x)
      A.some((G) => S(Z, G)) && P.push(Z);
    return P;
  }
  function y(x, A, S = (P, Z) => P === Z) {
    const P = [...x];
    for (const Z of A)
      P.some((G) => S(Z, G)) || P.push(Z);
    return P;
  }
  function M(x, A) {
    return x.some((S) => A.includes(S));
  }
  function N(x, A) {
    return x.every((S) => A.includes(S));
  }
  function D(x, A) {
    return !M(x, A);
  }
  return Q;
}
var lt = {}, Tn;
function H9() {
  if (Tn) return lt;
  Tn = 1, Object.defineProperty(lt, "__esModule", { value: !0 }), lt.FixedBackoff = lt.ExponentialBackoff = lt.FibonacciBackoff = lt.LinearBackoff = lt.Backoff = void 0;
  class e {
    constructor(o) {
      var u, i;
      this.min = 10, this.max = 1e4, this.jitter = 0, this.cur = 0, this.min = (u = o == null ? void 0 : o.min) !== null && u !== void 0 ? u : 100, this.max = (i = o == null ? void 0 : o.max) !== null && i !== void 0 ? i : 1e4, this.jitter = (o == null ? void 0 : o.jitter) !== void 0 && o.jitter >= 0 && o.jitter <= 1 ? o.jitter : 0, this.reset();
    }
    next() {
      if (this.jitter) {
        const u = this.spread() * this.jitter;
        this.cur += Math.random() * u - u / 2;
      }
      this.cur = Math.max(0, Math.min(this.max, Math.floor(this.cur)));
      const o = this.cur;
      return this.step(), o;
    }
  }
  lt.Backoff = e;
  class t extends e {
    constructor(o) {
      var u;
      super(o), this._step = 50, this._step = (u = o == null ? void 0 : o.step) !== null && u !== void 0 ? u : 50;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this._step;
    }
    step() {
      this.cur = this.cur + this._step;
    }
  }
  lt.LinearBackoff = t;
  class r extends e {
    constructor() {
      super(...arguments), this.last = 0;
    }
    reset() {
      this.cur = this.min, this.last = 0;
    }
    spread() {
      return this.cur === this.last ? this.cur : this.cur - this.last;
    }
    step() {
      let o = this.last + this.cur;
      o === 0 && (o = 1), this.last = this.cur, this.cur = o;
    }
  }
  lt.FibonacciBackoff = r;
  class n extends e {
    constructor(o) {
      var u;
      super(o), this.factor = 2, this.factor = (u = o == null ? void 0 : o.factor) !== null && u !== void 0 ? u : 2;
    }
    reset() {
      this.cur = this.min;
    }
    spread() {
      return this.cur - this.cur / this.factor;
    }
    step() {
      this.cur === 0 ? this.cur = 1 : this.cur *= this.factor;
    }
  }
  lt.ExponentialBackoff = n;
  class d extends e {
    constructor(o) {
      super(), this.sequence = o.sequence, this.idx = 0, this.lastIdx = this.sequence.length - 1, this.reset();
    }
    reset() {
      var o;
      this.idx = 0, this.cur = (o = this.sequence) === null || o === void 0 ? void 0 : o[this.idx];
    }
    spread() {
      return this.idx === 0 ? this.sequence[this.idx] : Math.abs(this.sequence[this.idx] - this.sequence[this.idx - 1]);
    }
    step() {
      this.idx = Math.min(this.idx + 1, this.lastIdx), this.cur = this.sequence[this.idx];
    }
  }
  return lt.FixedBackoff = d, lt;
}
var Te = {}, wn;
function V9() {
  if (wn) return Te;
  wn = 1, Object.defineProperty(Te, "__esModule", { value: !0 }), Te.cached = e;
  async function e(t, r, n) {
    let d = t.get(r);
    return d === void 0 && (d = await n(), t.set(r, d)), d;
  }
  return Te;
}
var bt = {}, Nt = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.groups = [], this.each = !1, this.context = void 0, this.type = t.type, this.name = t.name, this.target = t.target, this.propertyName = t.propertyName, this.constraints = t == null ? void 0 : t.constraints, this.constraintCls = t.constraintCls, this.validationTypeOptions = t.validationTypeOptions, t.validationOptions && (this.message = t.validationOptions.message, this.groups = t.validationOptions.groups, this.always = t.validationOptions.always, this.each = t.validationOptions.each, this.context = t.validationOptions.context);
    }
    return e;
  }()
), K9 = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.transform = function(t) {
      var r = [];
      return Object.keys(t.properties).forEach(function(n) {
        t.properties[n].forEach(function(d) {
          var a = {
            message: d.message,
            groups: d.groups,
            always: d.always,
            each: d.each
          }, o = {
            type: d.type,
            name: d.name,
            target: t.name,
            propertyName: n,
            constraints: d.constraints,
            validationTypeOptions: d.options,
            validationOptions: a
          };
          r.push(new Nt(o));
        });
      }), r;
    }, e;
  }()
);
function W9(e) {
  return e instanceof Map ? Array.from(e.values()) : Array.isArray(e) ? e : Array.from(e);
}
function Y9() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof global < "u")
    return global;
  if (typeof window < "u")
    return window;
  if (typeof self < "u")
    return self;
}
function Xe(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var z9 = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Rn = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), d, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(d = n.next()).done; ) a.push(d.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      d && !d.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, X9 = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, d = t.length, a; n < d; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}, J0 = (
  /** @class */
  function() {
    function e() {
      this.validationMetadatas = /* @__PURE__ */ new Map(), this.constraintMetadatas = /* @__PURE__ */ new Map();
    }
    return Object.defineProperty(e.prototype, "hasValidationMetaData", {
      get: function() {
        return !!this.validationMetadatas.size;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.addValidationSchema = function(t) {
      var r = this, n = new K9().transform(t);
      n.forEach(function(d) {
        return r.addValidationMetadata(d);
      });
    }, e.prototype.addValidationMetadata = function(t) {
      var r = this.validationMetadatas.get(t.target);
      r ? r.push(t) : this.validationMetadatas.set(t.target, [t]);
    }, e.prototype.addConstraintMetadata = function(t) {
      var r = this.constraintMetadatas.get(t.target);
      r ? r.push(t) : this.constraintMetadatas.set(t.target, [t]);
    }, e.prototype.groupByPropertyName = function(t) {
      var r = {};
      return t.forEach(function(n) {
        r[n.propertyName] || (r[n.propertyName] = []), r[n.propertyName].push(n);
      }), r;
    }, e.prototype.getTargetValidationMetadatas = function(t, r, n, d, a) {
      var o, u, i = function(y) {
        return typeof y.always < "u" ? y.always : y.groups && y.groups.length ? !1 : n;
      }, s = function(y) {
        return !!(d && (!a || !a.length) && y.groups && y.groups.length);
      }, c = this.validationMetadatas.get(t) || [], l = c.filter(function(y) {
        return y.target !== t && y.target !== r ? !1 : i(y) ? !0 : s(y) ? !1 : a && a.length > 0 ? y.groups && !!y.groups.find(function(M) {
          return a.indexOf(M) !== -1;
        }) : !0;
      }), $ = [];
      try {
        for (var b = z9(this.validationMetadatas.entries()), m = b.next(); !m.done; m = b.next()) {
          var f = Rn(m.value, 2), v = f[0], h = f[1];
          t.prototype instanceof v && $.push.apply($, X9([], Rn(h), !1));
        }
      } catch (y) {
        o = { error: y };
      } finally {
        try {
          m && !m.done && (u = b.return) && u.call(b);
        } finally {
          if (o) throw o.error;
        }
      }
      var _ = $.filter(function(y) {
        return typeof y.target == "string" || y.target === t || y.target instanceof Function && !(t.prototype instanceof y.target) ? !1 : i(y) ? !0 : s(y) ? !1 : a && a.length > 0 ? y.groups && !!y.groups.find(function(M) {
          return a.indexOf(M) !== -1;
        }) : !0;
      }), O = _.filter(function(y) {
        return !l.find(function(M) {
          return M.propertyName === y.propertyName && M.type === y.type;
        });
      });
      return l.concat(O);
    }, e.prototype.getTargetValidatorConstraints = function(t) {
      return this.constraintMetadatas.get(t) || [];
    }, e;
  }()
);
function ft() {
  var e = Y9();
  return e.classValidatorMetadataStorage || (e.classValidatorMetadataStorage = new J0()), e.classValidatorMetadataStorage;
}
var U0 = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.toString = function(t, r, n, d) {
      var a = this;
      t === void 0 && (t = !1), r === void 0 && (r = !1), n === void 0 && (n = ""), d === void 0 && (d = !1);
      var o = t ? "\x1B[1m" : "", u = t ? "\x1B[22m" : "", i = function() {
        var l;
        return (d ? Object.values : Object.keys)((l = a.constraints) !== null && l !== void 0 ? l : {}).join(", ");
      }, s = function(l) {
        return " - property ".concat(o).concat(n).concat(l).concat(u, " has failed the following constraints: ").concat(o).concat(i()).concat(u, ` 
`);
      };
      if (r) {
        var c = Number.isInteger(+this.property) ? "[".concat(this.property, "]") : "".concat(n ? "." : "").concat(this.property);
        return this.constraints ? s(c) : this.children ? this.children.map(function(l) {
          return l.toString(t, !0, "".concat(n).concat(c), d);
        }).join("") : "";
      } else
        return "An instance of ".concat(o).concat(this.target ? this.target.constructor.name : "an object").concat(u, ` has failed the validation:
`) + (this.constraints ? s(this.property) : "") + (this.children ? this.children.map(function(l) {
          return l.toString(t, !0, a.property, d);
        }).join("") : "");
    }, e;
  }()
), nt = (
  /** @class */
  function() {
    function e() {
    }
    return e.isValid = function(t) {
      var r = this;
      return t !== "isValid" && t !== "getMessage" && Object.keys(this).map(function(n) {
        return r[n];
      }).indexOf(t) !== -1;
    }, e.CUSTOM_VALIDATION = "customValidation", e.NESTED_VALIDATION = "nestedValidation", e.PROMISE_VALIDATION = "promiseValidation", e.CONDITIONAL_VALIDATION = "conditionalValidation", e.WHITELIST = "whitelistValidation", e.IS_DEFINED = "isDefined", e;
  }()
);
function Q9(e) {
  return Array.isArray(e) ? e.join(", ") : (typeof e == "symbol" && (e = e.description), "".concat(e));
}
var J9 = (
  /** @class */
  function() {
    function e() {
    }
    return e.replaceMessageSpecialTokens = function(t, r) {
      var n;
      return t instanceof Function ? n = t(r) : typeof t == "string" && (n = t), n && Array.isArray(r.constraints) && r.constraints.forEach(function(d, a) {
        n = n.replace(new RegExp("\\$constraint".concat(a + 1), "g"), Q9(d));
      }), n && r.value !== void 0 && r.value !== null && ["string", "boolean", "number"].includes(typeof r.value) && (n = n.replace(/\$value/g, r.value)), n && (n = n.replace(/\$property/g, r.property)), n && (n = n.replace(/\$target/g, r.targetName)), n;
    }, e;
  }()
), ye = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), d, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(d = n.next()).done; ) a.push(d.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      d && !d.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Dn = (
  /** @class */
  function() {
    function e(t, r) {
      this.validator = t, this.validatorOptions = r, this.awaitingPromises = [], this.ignoreAsyncValidations = !1, this.metadataStorage = ft();
    }
    return e.prototype.execute = function(t, r, n) {
      var d = this, a, o;
      !this.metadataStorage.hasValidationMetaData && ((a = this.validatorOptions) === null || a === void 0 ? void 0 : a.enableDebugMessages) === !0 && console.warn(`No validation metadata found. No validation will be  performed. There are multiple possible reasons:
  - There may be multiple class-validator versions installed. You will need to flatten your dependencies to fix the issue.
  - This validation runs before any file with validation decorator was parsed by NodeJS.`);
      var u = this.validatorOptions ? this.validatorOptions.groups : void 0, i = this.validatorOptions && this.validatorOptions.strictGroups || !1, s = this.validatorOptions && this.validatorOptions.always || !1, c = ((o = this.validatorOptions) === null || o === void 0 ? void 0 : o.forbidUnknownValues) === void 0 || this.validatorOptions.forbidUnknownValues !== !1, l = this.metadataStorage.getTargetValidationMetadatas(t.constructor, r, s, i, u), $ = this.metadataStorage.groupByPropertyName(l);
      if (c && !l.length) {
        var b = new U0();
        (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (b.target = t), b.value = void 0, b.property = void 0, b.children = [], b.constraints = { unknownValue: "an unknown value was passed to the validate function" }, n.push(b);
        return;
      }
      this.validatorOptions && this.validatorOptions.whitelist && this.whitelist(t, $, n), Object.keys($).forEach(function(m) {
        var f = t[m], v = $[m].filter(function(_) {
          return _.type === nt.IS_DEFINED;
        }), h = $[m].filter(function(_) {
          return _.type !== nt.IS_DEFINED && _.type !== nt.WHITELIST;
        });
        f instanceof Promise && h.find(function(_) {
          return _.type === nt.PROMISE_VALIDATION;
        }) ? d.awaitingPromises.push(f.then(function(_) {
          d.performValidations(t, _, m, v, h, n);
        })) : d.performValidations(t, f, m, v, h, n);
      });
    }, e.prototype.whitelist = function(t, r, n) {
      var d = this, a = [];
      Object.keys(t).forEach(function(o) {
        (!r[o] || r[o].length === 0) && a.push(o);
      }), a.length > 0 && (this.validatorOptions && this.validatorOptions.forbidNonWhitelisted ? a.forEach(function(o) {
        var u, i = d.generateValidationError(t, t[o], o);
        i.constraints = (u = {}, u[nt.WHITELIST] = "property ".concat(o, " should not exist"), u), i.children = void 0, n.push(i);
      }) : a.forEach(function(o) {
        return delete t[o];
      }));
    }, e.prototype.stripEmptyErrors = function(t) {
      var r = this;
      return t.filter(function(n) {
        if (n.children && (n.children = r.stripEmptyErrors(n.children)), Object.keys(n.constraints).length === 0) {
          if (n.children.length === 0)
            return !1;
          delete n.constraints;
        }
        return !0;
      });
    }, e.prototype.performValidations = function(t, r, n, d, a, o) {
      var u = a.filter(function($) {
        return $.type === nt.CUSTOM_VALIDATION;
      }), i = a.filter(function($) {
        return $.type === nt.NESTED_VALIDATION;
      }), s = a.filter(function($) {
        return $.type === nt.CONDITIONAL_VALIDATION;
      }), c = this.generateValidationError(t, r, n);
      o.push(c);
      var l = this.conditionalValidations(t, r, s);
      l && (this.customValidations(t, r, d, c), this.mapContexts(t, r, d, c), !(r === void 0 && this.validatorOptions && this.validatorOptions.skipUndefinedProperties === !0) && (r === null && this.validatorOptions && this.validatorOptions.skipNullProperties === !0 || r == null && this.validatorOptions && this.validatorOptions.skipMissingProperties === !0 || (this.customValidations(t, r, u, c), this.nestedValidations(r, i, c), this.mapContexts(t, r, a, c), this.mapContexts(t, r, u, c))));
    }, e.prototype.generateValidationError = function(t, r, n) {
      var d = new U0();
      return (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.target === void 0 || this.validatorOptions.validationError.target === !0) && (d.target = t), (!this.validatorOptions || !this.validatorOptions.validationError || this.validatorOptions.validationError.value === void 0 || this.validatorOptions.validationError.value === !0) && (d.value = r), d.property = n, d.children = [], d.constraints = {}, d;
    }, e.prototype.conditionalValidations = function(t, r, n) {
      return n.map(function(d) {
        return d.constraints[0](t, r);
      }).reduce(function(d, a) {
        return d && a;
      }, !0);
    }, e.prototype.customValidations = function(t, r, n, d) {
      var a = this;
      n.forEach(function(o) {
        a.metadataStorage.getTargetValidatorConstraints(o.constraintCls).forEach(function(u) {
          if (!(u.async && a.ignoreAsyncValidations) && !(a.validatorOptions && a.validatorOptions.stopAtFirstError && Object.keys(d.constraints || {}).length > 0)) {
            var i = {
              targetName: t.constructor ? t.constructor.name : void 0,
              property: o.propertyName,
              object: t,
              value: r,
              constraints: o.constraints
            };
            if (!o.each || !(Array.isArray(r) || r instanceof Set || r instanceof Map)) {
              var s = u.instance.validate(r, i);
              if (Xe(s)) {
                var c = s.then(function(M) {
                  if (!M) {
                    var N = ye(a.createValidationError(t, r, o, u), 2), D = N[0], x = N[1];
                    d.constraints[D] = x, o.context && (d.contexts || (d.contexts = {}), d.contexts[D] = Object.assign(d.contexts[D] || {}, o.context));
                  }
                });
                a.awaitingPromises.push(c);
              } else if (!s) {
                var l = ye(a.createValidationError(t, r, o, u), 2), $ = l[0], b = l[1];
                d.constraints[$] = b;
              }
              return;
            }
            var m = W9(r), f = m.map(function(M) {
              return u.instance.validate(M, i);
            }), v = f.some(function(M) {
              return Xe(M);
            });
            if (v) {
              var h = f.map(function(M) {
                return Xe(M) ? M : Promise.resolve(M);
              }), _ = Promise.all(h).then(function(M) {
                var N = M.every(function(S) {
                  return S;
                });
                if (!N) {
                  var D = ye(a.createValidationError(t, r, o, u), 2), x = D[0], A = D[1];
                  d.constraints[x] = A, o.context && (d.contexts || (d.contexts = {}), d.contexts[x] = Object.assign(d.contexts[x] || {}, o.context));
                }
              });
              a.awaitingPromises.push(_);
              return;
            }
            var O = f.every(function(M) {
              return M;
            });
            if (!O) {
              var y = ye(a.createValidationError(t, r, o, u), 2), $ = y[0], b = y[1];
              d.constraints[$] = b;
            }
          }
        });
      });
    }, e.prototype.nestedValidations = function(t, r, n) {
      var d = this;
      t !== void 0 && r.forEach(function(a) {
        if (!(a.type !== nt.NESTED_VALIDATION && a.type !== nt.PROMISE_VALIDATION) && !(d.validatorOptions && d.validatorOptions.stopAtFirstError && Object.keys(n.constraints || {}).length > 0))
          if (Array.isArray(t) || t instanceof Set || t instanceof Map) {
            var o = t instanceof Set ? Array.from(t) : t;
            o.forEach(function(l, $) {
              d.performValidations(t, l, $.toString(), [], r, n.children);
            });
          } else if (t instanceof Object) {
            var u = typeof a.target == "string" ? a.target : a.target.name;
            d.execute(t, u, n.children);
          } else {
            var i = ye(d.createValidationError(a.target, t, a), 2), s = i[0], c = i[1];
            n.constraints[s] = c;
          }
      });
    }, e.prototype.mapContexts = function(t, r, n, d) {
      var a = this;
      return n.forEach(function(o) {
        if (o.context) {
          var u = void 0;
          if (o.type === nt.CUSTOM_VALIDATION) {
            var i = a.metadataStorage.getTargetValidatorConstraints(o.constraintCls);
            u = i[0];
          }
          var s = a.getConstraintType(o, u);
          d.constraints[s] && (d.contexts || (d.contexts = {}), d.contexts[s] = Object.assign(d.contexts[s] || {}, o.context));
        }
      });
    }, e.prototype.createValidationError = function(t, r, n, d) {
      var a = t.constructor ? t.constructor.name : void 0, o = this.getConstraintType(n, d), u = {
        targetName: a,
        property: n.propertyName,
        object: t,
        value: r,
        constraints: n.constraints
      }, i = n.message || "";
      !n.message && (!this.validatorOptions || this.validatorOptions && !this.validatorOptions.dismissDefaultMessages) && d && d.instance.defaultMessage instanceof Function && (i = d.instance.defaultMessage(u));
      var s = J9.replaceMessageSpecialTokens(i, u);
      return [o, s];
    }, e.prototype.getConstraintType = function(t, r) {
      var n = r && r.name ? r.name : t.type;
      return n;
    }, e;
  }()
), q9 = function(e, t, r, n) {
  function d(a) {
    return a instanceof r ? a : new r(function(o) {
      o(a);
    });
  }
  return new (r || (r = Promise))(function(a, o) {
    function u(c) {
      try {
        s(n.next(c));
      } catch (l) {
        o(l);
      }
    }
    function i(c) {
      try {
        s(n.throw(c));
      } catch (l) {
        o(l);
      }
    }
    function s(c) {
      c.done ? a(c.value) : d(c.value).then(u, i);
    }
    s((n = n.apply(e, [])).next());
  });
}, t3 = function(e, t) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, d, a, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(s) {
    return function(c) {
      return i([s, c]);
    };
  }
  function i(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, s[0] && (r = 0)), r; ) try {
      if (n = 1, d && (a = s[0] & 2 ? d.return : s[0] ? d.throw || ((a = d.return) && a.call(d), 0) : d.next) && !(a = a.call(d, s[1])).done) return a;
      switch (d = 0, a && (s = [s[0] & 2, a.value]), s[0]) {
        case 0:
        case 1:
          a = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, d = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!a || s[1] > a[0] && s[1] < a[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < a[1]) {
            r.label = a[1], a = s;
            break;
          }
          if (a && r.label < a[2]) {
            r.label = a[2], r.ops.push(s);
            break;
          }
          a[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (c) {
      s = [6, c], d = 0;
    } finally {
      n = a = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ft = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.validate = function(t, r, n) {
      return this.coreValidate(t, r, n);
    }, e.prototype.validateOrReject = function(t, r, n) {
      return q9(this, void 0, void 0, function() {
        var d;
        return t3(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.coreValidate(t, r, n)];
            case 1:
              return d = a.sent(), d.length ? [2, Promise.reject(d)] : [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.validateSync = function(t, r, n) {
      var d = typeof t == "string" ? r : t, a = typeof t == "string" ? n : r, o = typeof t == "string" ? t : void 0, u = new Dn(this, a);
      u.ignoreAsyncValidations = !0;
      var i = [];
      return u.execute(d, o, i), u.stripEmptyErrors(i);
    }, e.prototype.coreValidate = function(t, r, n) {
      var d = typeof t == "string" ? r : t, a = typeof t == "string" ? n : r, o = typeof t == "string" ? t : void 0, u = new Dn(this, a), i = [];
      return u.execute(d, o, i), Promise.all(u.awaitingPromises).then(function() {
        return u.stripEmptyErrors(i);
      });
    }, e;
  }()
), e3 = new /** @class */
(function() {
  function e() {
    this.instances = [];
  }
  return e.prototype.get = function(t) {
    var r = this.instances.find(function(n) {
      return n.type === t;
    });
    return r || (r = { type: t, object: new t() }, this.instances.push(r)), r.object;
  }, e;
}())(), G0, Ae;
function r3(e, t) {
  G0 = e, Ae = t;
}
function Mt(e) {
  if (G0)
    try {
      var t = G0.get(e);
      if (t || !Ae || !Ae.fallback)
        return t;
    } catch (r) {
      if (!Ae || !Ae.fallbackOnErrors)
        throw r;
    }
  return e3.get(e);
}
function n3(e) {
  return function(t, r) {
    var n = {
      type: nt.WHITELIST,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    ft().addValidationMetadata(new Nt(n));
  };
}
var T1 = (
  /** @class */
  function() {
    function e(t, r, n) {
      n === void 0 && (n = !1), this.target = t, this.name = r, this.async = n;
    }
    return Object.defineProperty(e.prototype, "instance", {
      // -------------------------------------------------------------------------
      // Accessors
      // -------------------------------------------------------------------------
      /**
       * Instance of the target custom validation class which performs validation.
       */
      get: function() {
        return Mt(this.target);
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
);
function w1(e) {
  var t;
  if (e.validator instanceof Function) {
    t = e.validator;
    var r = Mt(J0).getTargetValidatorConstraints(e.validator);
    if (r.length > 1)
      throw "More than one implementation of ValidatorConstraintInterface found for validator on: ".concat(e.target.name, ":").concat(e.propertyName);
  } else {
    var n = e.validator;
    t = /** @class */
    function() {
      function a() {
      }
      return a.prototype.validate = function(o, u) {
        return n.validate(o, u);
      }, a.prototype.defaultMessage = function(o) {
        return n.defaultMessage ? n.defaultMessage(o) : "";
      }, a;
    }(), ft().addConstraintMetadata(new T1(t, e.name, e.async));
  }
  var d = {
    type: e.name && nt.isValid(e.name) ? e.name : nt.CUSTOM_VALIDATION,
    name: e.name,
    target: e.target,
    propertyName: e.propertyName,
    validationOptions: e.options,
    constraintCls: t,
    constraints: e.constraints
  };
  ft().addValidationMetadata(new Nt(d));
}
function E(e, t) {
  return function(r) {
    var n = t && t.each ? "each value in " : "";
    return e(n, r);
  };
}
function C(e, t) {
  return function(r, n) {
    w1({
      name: e.name,
      target: r.constructor,
      propertyName: n,
      options: t,
      constraints: e.constraints,
      validator: e.validator
    });
  };
}
var R1 = nt.IS_DEFINED;
function D1(e) {
  return e != null;
}
function d3(e) {
  return C({
    name: R1,
    validator: {
      validate: function(t) {
        return D1(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property should not be null or undefined";
      }, e)
    }
  }, e);
}
var B1 = "isOptional";
function a3(e) {
  return function(t, r) {
    var n = {
      type: nt.CONDITIONAL_VALIDATION,
      name: B1,
      target: t.constructor,
      propertyName: r,
      constraints: [
        function(d, a) {
          return d[r] !== null && d[r] !== void 0;
        }
      ],
      validationOptions: e
    };
    ft().addValidationMetadata(new Nt(n));
  };
}
function o3(e) {
  return function(t) {
    var r = e && e.async, n = e && e.name ? e.name : "";
    n || (n = t.name, n || (n = n.replace(/\.?([A-Z]+)/g, function(a, o) {
      return "_" + o.toLowerCase();
    }).replace(/^_/, "")));
    var d = new T1(t, n, r);
    ft().addConstraintMetadata(d);
  };
}
function u3(e, t, r) {
  return function(n, d) {
    var a = {
      type: nt.CUSTOM_VALIDATION,
      target: n.constructor,
      propertyName: d,
      constraintCls: e,
      constraints: Array.isArray(t) ? t : void 0,
      validationOptions: Array.isArray(t) ? r : t
    };
    ft().addValidationMetadata(new Nt(a));
  };
}
function i3(e, t) {
  return function(r, n) {
    var d = {
      type: nt.CONDITIONAL_VALIDATION,
      target: r.constructor,
      propertyName: n,
      constraints: [e],
      validationOptions: t
    };
    ft().addValidationMetadata(new Nt(d));
  };
}
var k0 = function() {
  return k0 = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var d in t) Object.prototype.hasOwnProperty.call(t, d) && (e[d] = t[d]);
    }
    return e;
  }, k0.apply(this, arguments);
};
function s3(e) {
  var t = k0({}, e), r = t.each ? "each value in " : "";
  return t.message = t.message || r + "nested property $property must be either object or array", function(n, d) {
    var a = {
      type: nt.NESTED_VALIDATION,
      target: n.constructor,
      propertyName: d,
      validationOptions: t
    };
    ft().addValidationMetadata(new Nt(a));
  };
}
function l3(e) {
  return function(t, r) {
    var n = {
      type: nt.PROMISE_VALIDATION,
      target: t.constructor,
      propertyName: r,
      validationOptions: e
    };
    ft().addValidationMetadata(new Nt(n));
  };
}
var Qe = { exports: {} }, Je = { exports: {} }, Bn;
function L() {
  return Bn || (Bn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(d) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(d);
    }
    function n(d) {
      var a = typeof d == "string" || d instanceof String;
      if (!a) {
        var o = r(d);
        throw d === null ? o = "null" : o === "object" && (o = d.constructor.name), new TypeError("Expected a string but received a ".concat(o));
      }
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Je, Je.exports)), Je.exports;
}
var qe = { exports: {} }, jn;
function ot() {
  return jn || (jn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = arguments.length > 1 ? arguments[1] : void 0;
      for (var a in d)
        typeof n[a] > "u" && (n[a] = d[a]);
      return n;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(qe, qe.exports)), qe.exports;
}
var Fn;
function j1() {
  return Fn || (Fn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ot());
    function d(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var a = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/, o = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/, u = /^(([1-8]?\d)\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|90\D+0\D+0)\D+[NSns]?$/i, i = /^\s*([1-7]?\d{1,2}\D+([1-5]?\d|60)\D+([1-5]?\d|60)(\.\d+)?|180\D+0\D+0)\D+[EWew]?$/i, s = {
      checkDMS: !1
    };
    function c(l, $) {
      if ((0, r.default)(l), $ = (0, n.default)($, s), !l.includes(",")) return !1;
      var b = l.split(",");
      return b[0].startsWith("(") && !b[1].endsWith(")") || b[1].endsWith(")") && !b[0].startsWith("(") ? !1 : $.checkDMS ? u.test(b[0]) && i.test(b[1]) : a.test(b[0]) && o.test(b[1]);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Qe, Qe.exports)), Qe.exports;
}
var c3 = /* @__PURE__ */ j1();
const f3 = /* @__PURE__ */ j(c3);
var F1 = "isLatLong";
function He(e) {
  return typeof e == "string" && f3(e);
}
function $3(e) {
  return C({
    name: F1,
    validator: {
      validate: function(t, r) {
        return He(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a latitude,longitude string";
      }, e)
    }
  }, e);
}
var Z1 = "isLatitude";
function U1(e) {
  return (typeof e == "number" || typeof e == "string") && He("".concat(e, ",0"));
}
function p3(e) {
  return C({
    name: Z1,
    validator: {
      validate: function(t, r) {
        return U1(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a latitude string or number";
      }, e)
    }
  }, e);
}
var G1 = "isLongitude";
function k1(e) {
  return (typeof e == "number" || typeof e == "string") && He("0,".concat(e));
}
function v3(e) {
  return C({
    name: G1,
    validator: {
      validate: function(t, r) {
        return k1(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a longitude string or number";
      }, e)
    }
  }, e);
}
var H1 = "equals";
function V1(e, t) {
  return e === t;
}
function h3(e, t) {
  return C({
    name: H1,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return V1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be equal to $constraint1";
      }, t)
    }
  }, t);
}
var K1 = "notEquals";
function W1(e, t) {
  return e !== t;
}
function m3(e, t) {
  return C({
    name: K1,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return W1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property should not be equal to $constraint1";
      }, t)
    }
  }, t);
}
var Y1 = "isEmpty";
function z1(e) {
  return e === "" || e === null || e === void 0;
}
function g3(e) {
  return C({
    name: Y1,
    validator: {
      validate: function(t, r) {
        return z1(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be empty";
      }, e)
    }
  }, e);
}
var X1 = "isNotEmpty";
function Q1(e) {
  return e !== "" && e !== null && e !== void 0;
}
function y3(e) {
  return C({
    name: X1,
    validator: {
      validate: function(t, r) {
        return Q1(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var J1 = "isIn";
function q1(e, t) {
  return Array.isArray(t) && t.some(function(r) {
    return r === e;
  });
}
function b3(e, t) {
  return C({
    name: J1,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return q1(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var to = "isNotIn";
function eo(e, t) {
  return !Array.isArray(t) || !t.some(function(r) {
    return r === e;
  });
}
function A3(e, t) {
  return C({
    name: to,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return eo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property should not be one of the following values: $constraint1";
      }, t)
    }
  }, t);
}
var tr = { exports: {} }, er = { exports: {} }, Kt = {}, rr = { exports: {} }, Zn;
function ro() {
  return Zn || (Zn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r(n) {
      return n == null;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(rr, rr.exports)), rr.exports;
}
var rt = {}, Un;
function Se() {
  if (Un) return rt;
  Un = 1, Object.defineProperty(rt, "__esModule", {
    value: !0
  }), rt.farsiLocales = rt.englishLocales = rt.dotDecimal = rt.decimal = rt.commaDecimal = rt.bengaliLocales = rt.arabicLocales = rt.alphanumeric = rt.alpha = void 0;
  for (var e = rt.alpha = {
    "en-US": /^[A-Z]+$/i,
    "az-AZ": /^[A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[А-Я]+$/i,
    "cs-CZ": /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[A-ZÆØÅ]+$/i,
    "de-DE": /^[A-ZÄÖÜß]+$/i,
    "el-GR": /^[Α-ώ]+$/i,
    "es-ES": /^[A-ZÁÉÍÑÓÚÜ]+$/i,
    "fa-IR": /^[ابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی]+$/i,
    "fi-FI": /^[A-ZÅÄÖ]+$/i,
    "fr-FR": /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "nb-NO": /^[A-ZÆØÅ]+$/i,
    "nl-NL": /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[A-ZÆØÅ]+$/i,
    "hu-HU": /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "pl-PL": /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[А-ЯЁ]+$/i,
    "kk-KZ": /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๐\s]+$/i,
    "tr-TR": /^[A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[А-ЩЬЮЯЄIЇҐі]+$/i,
    "vi-VN": /^[A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    "ko-KR": /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[א-ת]+$/,
    fa: /^['آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0961]+[\u0972-\u097F]*$/i,
    "si-LK": /^[\u0D80-\u0DFF]+$/
  }, t = rt.alphanumeric = {
    "en-US": /^[0-9A-Z]+$/i,
    "az-AZ": /^[0-9A-VXYZÇƏĞİıÖŞÜ]+$/i,
    "bg-BG": /^[0-9А-Я]+$/i,
    "cs-CZ": /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
    "da-DK": /^[0-9A-ZÆØÅ]+$/i,
    "de-DE": /^[0-9A-ZÄÖÜß]+$/i,
    "el-GR": /^[0-9Α-ω]+$/i,
    "es-ES": /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
    "fi-FI": /^[0-9A-ZÅÄÖ]+$/i,
    "fr-FR": /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
    "it-IT": /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
    "ja-JP": /^[0-9０-９ぁ-んァ-ヶｦ-ﾟ一-龠ー・。、]+$/i,
    "hu-HU": /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
    "nb-NO": /^[0-9A-ZÆØÅ]+$/i,
    "nl-NL": /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
    "nn-NO": /^[0-9A-ZÆØÅ]+$/i,
    "pl-PL": /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
    "pt-PT": /^[0-9A-ZÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜ]+$/i,
    "ru-RU": /^[0-9А-ЯЁ]+$/i,
    "kk-KZ": /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]+$/i,
    "sl-SI": /^[0-9A-ZČĆĐŠŽ]+$/i,
    "sk-SK": /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
    "sr-RS@latin": /^[0-9A-ZČĆŽŠĐ]+$/i,
    "sr-RS": /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
    "sv-SE": /^[0-9A-ZÅÄÖ]+$/i,
    "th-TH": /^[ก-๙\s]+$/i,
    "tr-TR": /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
    "uk-UA": /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
    "ko-KR": /^[0-9ㄱ-ㅎㅏ-ㅣ가-힣]*$/,
    "ku-IQ": /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
    "vi-VN": /^[0-9A-ZÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸ]+$/i,
    ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/,
    he: /^[0-9א-ת]+$/,
    fa: /^['0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+$/i,
    bn: /^['ঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻']+$/,
    eo: /^[0-9ABCĈD-GĜHĤIJĴK-PRSŜTUŬVZ]+$/i,
    "hi-IN": /^[\u0900-\u0963]+[\u0966-\u097F]*$/i,
    "si-LK": /^[0-9\u0D80-\u0DFF]+$/
  }, r = rt.decimal = {
    "en-US": ".",
    ar: "٫"
  }, n = rt.englishLocales = ["AU", "GB", "HK", "IN", "NZ", "ZA", "ZM"], d, a = 0; a < n.length; a++)
    d = "en-".concat(n[a]), e[d] = e["en-US"], t[d] = t["en-US"], r[d] = r["en-US"];
  for (var o = rt.arabicLocales = ["AE", "BH", "DZ", "EG", "IQ", "JO", "KW", "LB", "LY", "MA", "QM", "QA", "SA", "SD", "SY", "TN", "YE"], u, i = 0; i < o.length; i++)
    u = "ar-".concat(o[i]), e[u] = e.ar, t[u] = t.ar, r[u] = r.ar;
  for (var s = rt.farsiLocales = ["IR", "AF"], c, l = 0; l < s.length; l++)
    c = "fa-".concat(s[l]), t[c] = t.fa, r[c] = r.ar;
  for (var $ = rt.bengaliLocales = ["BD", "IN"], b, m = 0; m < $.length; m++)
    b = "bn-".concat($[m]), e[b] = e.bn, t[b] = t.bn, r[b] = r["en-US"];
  for (var f = rt.dotDecimal = ["ar-EG", "ar-LB", "ar-LY"], v = rt.commaDecimal = ["bg-BG", "cs-CZ", "da-DK", "de-DE", "el-GR", "en-ZM", "eo", "es-ES", "fr-CA", "fr-FR", "id-ID", "it-IT", "ku-IQ", "hi-IN", "hu-HU", "nb-NO", "nn-NO", "nl-NL", "pl-PL", "pt-PT", "ru-RU", "kk-KZ", "si-LK", "sl-SI", "sr-RS@latin", "sr-RS", "sv-SE", "tr-TR", "uk-UA", "vi-VN"], h = 0; h < f.length; h++)
    r[f[h]] = r["en-US"];
  for (var _ = 0; _ < v.length; _++)
    r[v[_]] = ",";
  return e["fr-CA"] = e["fr-FR"], t["fr-CA"] = t["fr-FR"], e["pt-BR"] = e["pt-PT"], t["pt-BR"] = t["pt-PT"], r["pt-BR"] = r["pt-PT"], e["pl-Pl"] = e["pl-PL"], t["pl-Pl"] = t["pl-PL"], r["pl-Pl"] = r["pl-PL"], e["fa-AF"] = e.fa, rt;
}
var Gn;
function no() {
  if (Gn) return Kt;
  Gn = 1, Object.defineProperty(Kt, "__esModule", {
    value: !0
  }), Kt.default = d, Kt.locales = void 0;
  var e = n(/* @__PURE__ */ L()), t = n(/* @__PURE__ */ ro()), r = /* @__PURE__ */ Se();
  function n(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function d(a, o) {
    (0, e.default)(a), o = o || {};
    var u = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(o.locale ? r.decimal[o.locale] : ".", "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));
    if (a === "" || a === "." || a === "," || a === "-" || a === "+")
      return !1;
    var i = parseFloat(a.replace(",", "."));
    return u.test(a) && (!o.hasOwnProperty("min") || (0, t.default)(o.min) || i >= o.min) && (!o.hasOwnProperty("max") || (0, t.default)(o.max) || i <= o.max) && (!o.hasOwnProperty("lt") || (0, t.default)(o.lt) || i < o.lt) && (!o.hasOwnProperty("gt") || (0, t.default)(o.gt) || i > o.gt);
  }
  return Kt.locales = Object.keys(r.decimal), Kt;
}
var kn;
function ao() {
  return kn || (kn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ no());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a) ? parseFloat(a) : NaN;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(er, er.exports)), er.exports;
}
var Hn;
function oo() {
  return Hn || (Hn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ao());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o, u) {
      return (0, r.default)(o), (0, n.default)(o) % parseInt(u, 10) === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(tr, tr.exports)), tr.exports;
}
var _3 = /* @__PURE__ */ oo();
const M3 = /* @__PURE__ */ j(_3);
var uo = "isDivisibleBy";
function io(e, t) {
  return typeof e == "number" && typeof t == "number" && M3(String(e), t);
}
function S3(e, t) {
  return C({
    name: uo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return io(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be divisible by $constraint1";
      }, t)
    }
  }, t);
}
var so = "isPositive";
function lo(e) {
  return typeof e == "number" && e > 0;
}
function I3(e) {
  return C({
    name: so,
    validator: {
      validate: function(t, r) {
        return lo(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a positive number";
      }, e)
    }
  }, e);
}
var co = "isNegative";
function fo(e) {
  return typeof e == "number" && e < 0;
}
function O3(e) {
  return C({
    name: co,
    validator: {
      validate: function(t, r) {
        return fo(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a negative number";
      }, e)
    }
  }, e);
}
var $o = "max";
function po(e, t) {
  return typeof e == "number" && typeof t == "number" && e <= t;
}
function x3(e, t) {
  return C({
    name: $o,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return po(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must not be greater than $constraint1";
      }, t)
    }
  }, t);
}
var vo = "min";
function ho(e, t) {
  return typeof e == "number" && typeof t == "number" && e >= t;
}
function E3(e, t) {
  return C({
    name: vo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ho(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must not be less than $constraint1";
      }, t)
    }
  }, t);
}
var mo = "minDate";
function go(e, t) {
  return e instanceof Date && e.getTime() >= (t instanceof Date ? t : t()).getTime();
}
function C3(e, t) {
  return C({
    name: mo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return go(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return "minimal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var yo = "maxDate";
function bo(e, t) {
  return e instanceof Date && e.getTime() <= (t instanceof Date ? t : t()).getTime();
}
function N3(e, t) {
  return C({
    name: yo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return bo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return "maximal allowed date for " + r + "$property is $constraint1";
      }, t)
    }
  }, t);
}
var nr = { exports: {} }, dr = { exports: {} }, Vn;
function Ao() {
  return Vn || (Vn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(d) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
        return typeof a;
      } : function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(d);
    }
    function n(d) {
      return r(d) === "object" && d !== null ? typeof d.toString == "function" ? d = d.toString() : d = "[object Object]" : (d === null || typeof d > "u" || isNaN(d) && !d.length) && (d = ""), String(d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(dr, dr.exports)), dr.exports;
}
var Kn;
function _o() {
  return Kn || (Kn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = a(/* @__PURE__ */ L()), n = a(/* @__PURE__ */ Ao()), d = a(/* @__PURE__ */ ot());
    function a(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var o = {
      ignoreCase: !1,
      minOccurrences: 1
    };
    function u(i, s, c) {
      return (0, r.default)(i), c = (0, d.default)(c, o), c.ignoreCase ? i.toLowerCase().split((0, n.default)(s).toLowerCase()).length > c.minOccurrences : i.split((0, n.default)(s)).length > c.minOccurrences;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(nr, nr.exports)), nr.exports;
}
var P3 = /* @__PURE__ */ _o();
const Mo = /* @__PURE__ */ j(P3);
var So = "contains";
function Io(e, t) {
  return typeof e == "string" && Mo(e, t);
}
function L3(e, t) {
  return C({
    name: So,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Io(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var Oo = "notContains";
function xo(e, t) {
  return typeof e == "string" && !Mo(e, t);
}
function T3(e, t) {
  return C({
    name: Oo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return xo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property should not contain a $constraint1 string";
      }, t)
    }
  }, t);
}
var Wt = {}, Wn;
function Eo() {
  if (Wn) return Wt;
  Wn = 1, Object.defineProperty(Wt, "__esModule", {
    value: !0
  }), Wt.default = n, Wt.locales = void 0;
  var e = r(/* @__PURE__ */ L()), t = /* @__PURE__ */ Se();
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function n(d) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, e.default)(d);
    var u = d, i = o.ignore;
    if (i)
      if (i instanceof RegExp)
        u = u.replace(i, "");
      else if (typeof i == "string")
        u = u.replace(new RegExp("[".concat(i.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in t.alpha)
      return t.alpha[a].test(u);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Wt.locales = Object.keys(t.alpha), Wt;
}
var w3 = /* @__PURE__ */ Eo();
const R3 = /* @__PURE__ */ j(w3);
var Co = "isAlpha";
function No(e, t) {
  return typeof e == "string" && R3(e, t);
}
function D3(e, t) {
  return C({
    name: Co,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return No(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must contain only letters (a-zA-Z)";
      }, t)
    }
  }, t);
}
var Yt = {}, Yn;
function Po() {
  if (Yn) return Yt;
  Yn = 1, Object.defineProperty(Yt, "__esModule", {
    value: !0
  }), Yt.default = n, Yt.locales = void 0;
  var e = r(/* @__PURE__ */ L()), t = /* @__PURE__ */ Se();
  function r(d) {
    return d && d.__esModule ? d : { default: d };
  }
  function n(d) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, e.default)(d);
    var u = d, i = o.ignore;
    if (i)
      if (i instanceof RegExp)
        u = u.replace(i, "");
      else if (typeof i == "string")
        u = u.replace(new RegExp("[".concat(i.replace(/[-[\]{}()*+?.,\\^$|#\\s]/g, "\\$&"), "]"), "g"), "");
      else
        throw new Error("ignore should be instance of a String or RegExp");
    if (a in t.alphanumeric)
      return t.alphanumeric[a].test(u);
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Yt.locales = Object.keys(t.alphanumeric), Yt;
}
var B3 = /* @__PURE__ */ Po();
const j3 = /* @__PURE__ */ j(B3);
var Lo = "isAlphanumeric";
function To(e, t) {
  return typeof e == "string" && j3(e, t);
}
function F3(e, t) {
  return C({
    name: Lo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return To(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must contain only letters and numbers";
      }, t)
    }
  }, t);
}
var ar = { exports: {} }, or = { exports: {} }, zn;
function Z3() {
  return zn || (zn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var r = function(n, d) {
      return n.some(function(a) {
        return d === a;
      });
    };
    t.default = r, e.exports = t.default, e.exports.default = t.default;
  }(or, or.exports)), or.exports;
}
var Xn;
function wo() {
  return Xn || (Xn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = o(/* @__PURE__ */ ot()), n = o(/* @__PURE__ */ L()), d = o(/* @__PURE__ */ Z3()), a = /* @__PURE__ */ Se();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function u(l) {
      var $ = new RegExp("^[-+]?([0-9]+)?(\\".concat(a.decimal[l.locale], "[0-9]{").concat(l.decimal_digits, "})").concat(l.force_decimal ? "" : "?", "$"));
      return $;
    }
    var i = {
      force_decimal: !1,
      decimal_digits: "1,",
      locale: "en-US"
    }, s = ["", "-", "+"];
    function c(l, $) {
      if ((0, n.default)(l), $ = (0, r.default)($, i), $.locale in a.decimal)
        return !(0, d.default)(s, l.replace(/ /g, "")) && u($).test(l);
      throw new Error("Invalid locale '".concat($.locale, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ar, ar.exports)), ar.exports;
}
var U3 = /* @__PURE__ */ wo();
const G3 = /* @__PURE__ */ j(U3);
var Ro = "isDecimal";
function Do(e, t) {
  return typeof e == "string" && G3(e, t);
}
function k3(e, t) {
  return C({
    name: Ro,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Do(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property is not a valid decimal number.";
      }, t)
    }
  }, t);
}
var ur = { exports: {} }, Qn;
function Bo() {
  return Qn || (Qn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[\x00-\x7F]+$/;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ur, ur.exports)), ur.exports;
}
var H3 = /* @__PURE__ */ Bo();
const V3 = /* @__PURE__ */ j(H3);
var jo = "isAscii";
function Fo(e) {
  return typeof e == "string" && V3(e);
}
function K3(e) {
  return C({
    name: jo,
    validator: {
      validate: function(t, r) {
        return Fo(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must contain only ASCII characters";
      }, e)
    }
  }, e);
}
var ir = { exports: {} }, Jn;
function q0() {
  return Jn || (Jn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ot());
    function d(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /[^A-Z0-9+\/=]/i, o = /^[A-Z0-9_\-]*$/i, u = {
      urlSafe: !1
    };
    function i(s, c) {
      (0, r.default)(s), c = (0, n.default)(c, u);
      var l = s.length;
      if (c.urlSafe)
        return o.test(s);
      if (l % 4 !== 0 || a.test(s))
        return !1;
      var $ = s.indexOf("=");
      return $ === -1 || $ === l - 1 || $ === l - 2 && s[l - 1] === "=";
    }
    e.exports = t.default, e.exports.default = t.default;
  }(ir, ir.exports)), ir.exports;
}
var W3 = /* @__PURE__ */ q0();
const Y3 = /* @__PURE__ */ j(W3);
var Zo = "isBase64";
function Uo(e, t) {
  return typeof e == "string" && Y3(e, t);
}
function z3(e, t) {
  return C({
    name: Zo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Uo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be base64 encoded";
      }, t)
    }
  }, t);
}
var sr = { exports: {} }, qn;
function tn() {
  return qn || (qn = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function d(o) {
      "@babel/helpers - typeof";
      return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, d(o);
    }
    function a(o, u) {
      (0, r.default)(o);
      var i, s;
      d(u) === "object" ? (i = u.min || 0, s = u.max) : (i = arguments[1], s = arguments[2]);
      var c = encodeURI(o).split(/%..|./).length - 1;
      return c >= i && (typeof s > "u" || c <= s);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(sr, sr.exports)), sr.exports;
}
var X3 = /* @__PURE__ */ tn();
const Q3 = /* @__PURE__ */ j(X3);
var Go = "isByteLength";
function ko(e, t, r) {
  return typeof e == "string" && Q3(e, { min: t, max: r });
}
function J3(e, t, r) {
  return C({
    name: Go,
    constraints: [e, t],
    validator: {
      validate: function(n, d) {
        return ko(n, d == null ? void 0 : d.constraints[0], d == null ? void 0 : d.constraints[1]);
      },
      defaultMessage: E(function(n) {
        return n + "$property's byte length must fall into ($constraint1, $constraint2) range";
      }, r)
    }
  }, r);
}
var lr = { exports: {} }, cr = { exports: {} }, td;
function Ho() {
  return td || (td = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      (0, r.default)(a);
      for (var o = a.replace(/[- ]+/g, ""), u = 0, i, s, c, l = o.length - 1; l >= 0; l--)
        i = o.substring(l, l + 1), s = parseInt(i, 10), c ? (s *= 2, s >= 10 ? u += s % 10 + 1 : u += s) : u += s, c = !c;
      return !!(u % 10 === 0 && o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(cr, cr.exports)), cr.exports;
}
var ed;
function Vo() {
  return ed || (ed = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ Ho());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = {
      amex: /^3[47][0-9]{13}$/,
      dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
      discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
      mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
      // /^[25][1-7][0-9]{14}$/;
      unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
      visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/
    }, o = function() {
      var i = [];
      for (var s in a)
        a.hasOwnProperty(s) && i.push(a[s]);
      return i;
    }();
    function u(i) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(i);
      var c = s.provider, l = i.replace(/[- ]+/g, "");
      if (c && c.toLowerCase() in a) {
        if (!a[c.toLowerCase()].test(l))
          return !1;
      } else {
        if (c && !(c.toLowerCase() in a))
          throw new Error("".concat(c, " is not a valid credit card provider."));
        if (!o.some(function($) {
          return $.test(l);
        }))
          return !1;
      }
      return (0, n.default)(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(lr, lr.exports)), lr.exports;
}
var q3 = /* @__PURE__ */ Vo();
const tl = /* @__PURE__ */ j(q3);
var Ko = "isCreditCard";
function Wo(e) {
  return typeof e == "string" && tl(e);
}
function el(e) {
  return C({
    name: Ko,
    validator: {
      validate: function(t, r) {
        return Wo(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a credit card";
      }, e)
    }
  }, e);
}
var fr = { exports: {} }, rd;
function Yo() {
  return rd || (rd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = d(/* @__PURE__ */ ot()), n = d(/* @__PURE__ */ L());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      var s = "\\d{".concat(i.digits_after_decimal[0], "}");
      i.digits_after_decimal.forEach(function(_, O) {
        O !== 0 && (s = "".concat(s, "|\\d{").concat(_, "}"));
      });
      var c = "(".concat(i.symbol.replace(/\W/, function(_) {
        return "\\".concat(_);
      }), ")").concat(i.require_symbol ? "" : "?"), l = "-?", $ = "[1-9]\\d*", b = "[1-9]\\d{0,2}(\\".concat(i.thousands_separator, "\\d{3})*"), m = ["0", $, b], f = "(".concat(m.join("|"), ")?"), v = "(\\".concat(i.decimal_separator, "(").concat(s, "))").concat(i.require_decimal ? "" : "?"), h = f + (i.allow_decimal || i.require_decimal ? v : "");
      return i.allow_negatives && !i.parens_for_negatives && (i.negative_sign_after_digits ? h += l : i.negative_sign_before_digits && (h = l + h)), i.allow_negative_sign_placeholder ? h = "( (?!\\-))?".concat(h) : i.allow_space_after_symbol ? h = " ?".concat(h) : i.allow_space_after_digits && (h += "( (?!$))?"), i.symbol_after_digits ? h += c : h = c + h, i.allow_negatives && (i.parens_for_negatives ? h = "(\\(".concat(h, "\\)|").concat(h, ")") : i.negative_sign_before_digits || i.negative_sign_after_digits || (h = l + h)), new RegExp("^(?!-? )(?=.*\\d)".concat(h, "$"));
    }
    var o = {
      symbol: "$",
      require_symbol: !1,
      allow_space_after_symbol: !1,
      symbol_after_digits: !1,
      allow_negatives: !0,
      parens_for_negatives: !1,
      negative_sign_before_digits: !1,
      negative_sign_after_digits: !1,
      allow_negative_sign_placeholder: !1,
      thousands_separator: ",",
      decimal_separator: ".",
      allow_decimal: !0,
      require_decimal: !1,
      digits_after_decimal: [2],
      allow_space_after_digits: !1
    };
    function u(i, s) {
      return (0, n.default)(i), s = (0, r.default)(s, o), a(s).test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(fr, fr.exports)), fr.exports;
}
var rl = /* @__PURE__ */ Yo();
const nl = /* @__PURE__ */ j(rl);
var zo = "isCurrency";
function Xo(e, t) {
  return typeof e == "string" && nl(e, t);
}
function dl(e, t) {
  return C({
    name: zo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Xo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a currency";
      }, t)
    }
  }, t);
}
var $r = { exports: {} }, pr = { exports: {} }, nd;
function Qo() {
  return nd || (nd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function r(d) {
      return Object.prototype.toString.call(d) === "[object RegExp]";
    }
    function n(d, a) {
      for (var o = 0; o < a.length; o++) {
        var u = a[o];
        if (d === u || r(u) && u.test(d))
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(pr, pr.exports)), pr.exports;
}
var vr = { exports: {} }, dd;
function Ve() {
  return dd || (dd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ot());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = {
      require_tld: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_numeric_tld: !1,
      allow_wildcard: !1,
      ignore_max_length: !1
    };
    function o(u, i) {
      (0, r.default)(u), i = (0, n.default)(i, a), i.allow_trailing_dot && u[u.length - 1] === "." && (u = u.substring(0, u.length - 1)), i.allow_wildcard === !0 && u.indexOf("*.") === 0 && (u = u.substring(2));
      var s = u.split("."), c = s[s.length - 1];
      return i.require_tld && (s.length < 2 || !i.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(c) || /\s/.test(c)) || !i.allow_numeric_tld && /^\d+$/.test(c) ? !1 : s.every(function(l) {
        return !(l.length > 63 && !i.ignore_max_length || !/^[a-z_\u00a1-\uffff0-9-]+$/i.test(l) || /[\uff01-\uff5e]/.test(l) || /^-|-$/.test(l) || !i.allow_underscores && /_/.test(l));
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(vr, vr.exports)), vr.exports;
}
var hr = { exports: {} }, ad;
function Ie() {
  return ad || (ad = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = n(/* @__PURE__ */ L());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var d = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])", a = "(".concat(d, "[.]){3}").concat(d), o = new RegExp("^".concat(a, "$")), u = "(?:[0-9a-fA-F]{1,4})", i = new RegExp("^(" + "(?:".concat(u, ":){7}(?:").concat(u, "|:)|") + "(?:".concat(u, ":){6}(?:").concat(a, "|:").concat(u, "|:)|") + "(?:".concat(u, ":){5}(?::").concat(a, "|(:").concat(u, "){1,2}|:)|") + "(?:".concat(u, ":){4}(?:(:").concat(u, "){0,1}:").concat(a, "|(:").concat(u, "){1,3}|:)|") + "(?:".concat(u, ":){3}(?:(:").concat(u, "){0,2}:").concat(a, "|(:").concat(u, "){1,4}|:)|") + "(?:".concat(u, ":){2}(?:(:").concat(u, "){0,3}:").concat(a, "|(:").concat(u, "){1,5}|:)|") + "(?:".concat(u, ":){1}(?:(:").concat(u, "){0,4}:").concat(a, "|(:").concat(u, "){1,6}|:)|") + "(?::((?::".concat(u, "){0,5}:").concat(a, "|(?::").concat(u, "){1,7}|:))") + ")(%[0-9a-zA-Z-.:]{1,})?$");
    function s(c) {
      var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      return (0, r.default)(c), l = String(l), l ? l === "4" ? o.test(c) : l === "6" ? i.test(c) : !1 : s(c, 4) || s(c, 6);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(hr, hr.exports)), hr.exports;
}
var od;
function en() {
  return od || (od = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = _;
    var r = i(/* @__PURE__ */ L()), n = i(/* @__PURE__ */ Qo()), d = i(/* @__PURE__ */ tn()), a = i(/* @__PURE__ */ Ve()), o = i(/* @__PURE__ */ Ie()), u = i(/* @__PURE__ */ ot());
    function i(O) {
      return O && O.__esModule ? O : { default: O };
    }
    var s = {
      allow_display_name: !1,
      allow_underscores: !1,
      require_display_name: !1,
      allow_utf8_local_part: !0,
      require_tld: !0,
      blacklisted_chars: "",
      ignore_max_length: !1,
      host_blacklist: [],
      host_whitelist: []
    }, c = /^([^\x00-\x1F\x7F-\x9F\cX]+)</i, l = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i, $ = /^[a-z\d]+$/, b = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i, m = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i, f = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i, v = 254;
    function h(O) {
      var y = O.replace(/^"(.+)"$/, "$1");
      if (!y.trim())
        return !1;
      var M = /[\.";<>]/.test(y);
      if (M) {
        if (y === O)
          return !1;
        var N = y.split('"').length === y.split('\\"').length;
        if (!N)
          return !1;
      }
      return !0;
    }
    function _(O, y) {
      if ((0, r.default)(O), y = (0, u.default)(y, s), y.require_display_name || y.allow_display_name) {
        var M = O.match(c);
        if (M) {
          var N = M[1];
          if (O = O.replace(N, "").replace(/(^<|>$)/g, ""), N.endsWith(" ") && (N = N.slice(0, -1)), !h(N))
            return !1;
        } else if (y.require_display_name)
          return !1;
      }
      if (!y.ignore_max_length && O.length > v)
        return !1;
      var D = O.split("@"), x = D.pop(), A = x.toLowerCase();
      if (y.host_blacklist.length > 0 && (0, n.default)(A, y.host_blacklist) || y.host_whitelist.length > 0 && !(0, n.default)(A, y.host_whitelist))
        return !1;
      var S = D.join("@");
      if (y.domain_specific_validation && (A === "gmail.com" || A === "googlemail.com")) {
        S = S.toLowerCase();
        var P = S.split("+")[0];
        if (!(0, d.default)(P.replace(/\./g, ""), {
          min: 6,
          max: 30
        }))
          return !1;
        for (var Z = P.split("."), G = 0; G < Z.length; G++)
          if (!$.test(Z[G]))
            return !1;
      }
      if (y.ignore_max_length === !1 && (!(0, d.default)(S, {
        max: 64
      }) || !(0, d.default)(x, {
        max: 254
      })))
        return !1;
      if (!(0, a.default)(x, {
        require_tld: y.require_tld,
        ignore_max_length: y.ignore_max_length,
        allow_underscores: y.allow_underscores
      })) {
        if (!y.allow_ip_domain)
          return !1;
        if (!(0, o.default)(x)) {
          if (!x.startsWith("[") || !x.endsWith("]"))
            return !1;
          var K = x.slice(1, -1);
          if (K.length === 0 || !(0, o.default)(K))
            return !1;
        }
      }
      if (y.blacklisted_chars && S.search(new RegExp("[".concat(y.blacklisted_chars, "]+"), "g")) !== -1)
        return !1;
      if (S[0] === '"' && S[S.length - 1] === '"')
        return S = S.slice(1, S.length - 1), y.allow_utf8_local_part ? f.test(S) : b.test(S);
      for (var Y = y.allow_utf8_local_part ? m : l, it = S.split("."), V = 0; V < it.length; V++)
        if (!Y.test(it[V]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }($r, $r.exports)), $r.exports;
}
var al = /* @__PURE__ */ en();
const ol = /* @__PURE__ */ j(al);
var Jo = "isEmail";
function qo(e, t) {
  return typeof e == "string" && ol(e, t);
}
function ul(e, t) {
  return C({
    name: Jo,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return qo(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be an email";
      }, t)
    }
  }, t);
}
var il = /* @__PURE__ */ Ve();
const sl = /* @__PURE__ */ j(il);
var t2 = "isFqdn";
function e2(e, t) {
  return typeof e == "string" && sl(e, t);
}
function ll(e, t) {
  return C({
    name: t2,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return e2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a valid domain name";
      }, t)
    }
  }, t);
}
var zt = {}, ud;
function rn() {
  if (ud) return zt;
  ud = 1, Object.defineProperty(zt, "__esModule", {
    value: !0
  }), zt.default = n, zt.fullWidth = void 0;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = zt.fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(d) {
    return (0, e.default)(d), r.test(d);
  }
  return zt;
}
var cl = /* @__PURE__ */ rn();
const fl = /* @__PURE__ */ j(cl);
var r2 = "isFullWidth";
function n2(e) {
  return typeof e == "string" && fl(e);
}
function $l(e) {
  return C({
    name: r2,
    validator: {
      validate: function(t, r) {
        return n2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must contain a full-width characters";
      }, e)
    }
  }, e);
}
var Xt = {}, id;
function nn() {
  if (id) return Xt;
  id = 1, Object.defineProperty(Xt, "__esModule", {
    value: !0
  }), Xt.default = n, Xt.halfWidth = void 0;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = Xt.halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
  function n(d) {
    return (0, e.default)(d), r.test(d);
  }
  return Xt;
}
var pl = /* @__PURE__ */ nn();
const vl = /* @__PURE__ */ j(pl);
var d2 = "isHalfWidth";
function a2(e) {
  return typeof e == "string" && vl(e);
}
function hl(e) {
  return C({
    name: d2,
    validator: {
      validate: function(t, r) {
        return a2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must contain a half-width characters";
      }, e)
    }
  }, e);
}
var mr = { exports: {} }, sd;
function o2() {
  return sd || (sd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = a(/* @__PURE__ */ L()), n = /* @__PURE__ */ rn(), d = /* @__PURE__ */ nn();
    function a(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function o(u) {
      return (0, r.default)(u), n.fullWidth.test(u) && d.halfWidth.test(u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(mr, mr.exports)), mr.exports;
}
var ml = /* @__PURE__ */ o2();
const gl = /* @__PURE__ */ j(ml);
var u2 = "isVariableWidth";
function i2(e) {
  return typeof e == "string" && gl(e);
}
function yl(e) {
  return C({
    name: u2,
    validator: {
      validate: function(t, r) {
        return i2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must contain a full-width and half-width characters";
      }, e)
    }
  }, e);
}
var gr = { exports: {} }, ld;
function s2() {
  return ld || (ld = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^#?([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(gr, gr.exports)), gr.exports;
}
var bl = /* @__PURE__ */ s2();
const Al = /* @__PURE__ */ j(bl);
var l2 = "isHexColor";
function c2(e) {
  return typeof e == "string" && Al(e);
}
function _l(e) {
  return C({
    name: l2,
    validator: {
      validate: function(t, r) {
        return c2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a hexadecimal color";
      }, e)
    }
  }, e);
}
var yr = { exports: {} }, cd;
function dn() {
  return cd || (cd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^(0x|0h)?[0-9A-F]+$/i;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(yr, yr.exports)), yr.exports;
}
var Ml = /* @__PURE__ */ dn();
const Sl = /* @__PURE__ */ j(Ml);
var f2 = "isHexadecimal";
function $2(e) {
  return typeof e == "string" && Sl(e);
}
function Il(e) {
  return C({
    name: f2,
    validator: {
      validate: function(t, r) {
        return $2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a hexadecimal number";
      }, e)
    }
  }, e);
}
function H0(e) {
  return e ? "each" in e || "message" in e || "groups" in e || "always" in e || "context" in e : !1;
}
var br = { exports: {} }, fd;
function p2() {
  return fd || (fd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ L());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var d = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){4}([0-9a-fA-F]{2})$/, a = /^([0-9a-fA-F]){12}$/, o = /^([0-9a-fA-F]{4}\.){2}([0-9a-fA-F]{4})$/, u = /^(?:[0-9a-fA-F]{2}([-:\s]))([0-9a-fA-F]{2}\1){6}([0-9a-fA-F]{2})$/, i = /^([0-9a-fA-F]){16}$/, s = /^([0-9a-fA-F]{4}\.){3}([0-9a-fA-F]{4})$/;
    function c(l, $) {
      return (0, r.default)(l), $ != null && $.eui && ($.eui = String($.eui)), $ != null && $.no_colons || $ != null && $.no_separators ? $.eui === "48" ? a.test(l) : $.eui === "64" ? i.test(l) : a.test(l) || i.test(l) : ($ == null ? void 0 : $.eui) === "48" ? d.test(l) || o.test(l) : ($ == null ? void 0 : $.eui) === "64" ? u.test(l) || s.test(l) : c(l, {
        eui: "48"
      }) || c(l, {
        eui: "64"
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(br, br.exports)), br.exports;
}
var Ol = /* @__PURE__ */ p2();
const xl = /* @__PURE__ */ j(Ol);
var v2 = "isMacAddress";
function h2(e, t) {
  return typeof e == "string" && xl(e, t);
}
function El(e, t) {
  var r = H0(e) ? void 0 : e, n = H0(e) ? e : t;
  return C({
    name: v2,
    constraints: [r],
    validator: {
      validate: function(d, a) {
        return h2(d, r);
      },
      defaultMessage: E(function(d) {
        return d + "$property must be a MAC Address";
      }, n)
    }
  }, n);
}
var Cl = /* @__PURE__ */ Ie();
const Nl = /* @__PURE__ */ j(Cl);
var m2 = "isIp";
function g2(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && Nl(e, r);
}
function Pl(e, t) {
  return C({
    name: m2,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return g2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be an ip address";
      }, t)
    }
  }, t);
}
var Ar = { exports: {} }, _r = { exports: {} }, $d;
function an() {
  return $d || ($d = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ro());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var a = /^(?:[-+]?(?:0|[1-9][0-9]*))$/, o = /^[-+]?[0-9]+$/;
    function u(i, s) {
      (0, r.default)(i), s = s || {};
      var c = s.allow_leading_zeroes === !1 ? a : o, l = !s.hasOwnProperty("min") || (0, n.default)(s.min) || i >= s.min, $ = !s.hasOwnProperty("max") || (0, n.default)(s.max) || i <= s.max, b = !s.hasOwnProperty("lt") || (0, n.default)(s.lt) || i < s.lt, m = !s.hasOwnProperty("gt") || (0, n.default)(s.gt) || i > s.gt;
      return c.test(i) && l && $ && b && m;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(_r, _r.exports)), _r.exports;
}
var pd;
function y2() {
  return pd || (pd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ an());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a, {
        allow_leading_zeroes: !1,
        min: 0,
        max: 65535
      });
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ar, Ar.exports)), Ar.exports;
}
var Ll = /* @__PURE__ */ y2();
const Tl = /* @__PURE__ */ j(Ll);
var b2 = "isPort";
function A2(e) {
  return typeof e == "string" && Tl(e);
}
function wl(e) {
  return C({
    name: b2,
    validator: {
      validate: function(t, r) {
        return A2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a port";
      }, e)
    }
  }, e);
}
var Mr = { exports: {} }, vd;
function _2() {
  return vd || (vd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ L());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^(?:[0-9]{9}X|[0-9]{10})$/, a = /^(?:[0-9]{13})$/, o = [1, 3];
    function u(i, s) {
      (0, r.default)(i);
      var c = String((s == null ? void 0 : s.version) || s);
      if (!(s != null && s.version || s))
        return u(i, {
          version: 10
        }) || u(i, {
          version: 13
        });
      var l = i.replace(/[\s-]+/g, ""), $ = 0;
      if (c === "10") {
        if (!d.test(l))
          return !1;
        for (var b = 0; b < c - 1; b++)
          $ += (b + 1) * l.charAt(b);
        if (l.charAt(9) === "X" ? $ += 10 * 10 : $ += 10 * l.charAt(9), $ % 11 === 0)
          return !0;
      } else if (c === "13") {
        if (!a.test(l))
          return !1;
        for (var m = 0; m < 12; m++)
          $ += o[m % 2] * l.charAt(m);
        if (l.charAt(12) - (10 - $ % 10) % 10 === 0)
          return !0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Mr, Mr.exports)), Mr.exports;
}
var Rl = /* @__PURE__ */ _2();
const Dl = /* @__PURE__ */ j(Rl);
var M2 = "isIsbn";
function S2(e, t) {
  var r = t ? "".concat(t) : void 0;
  return typeof e == "string" && Dl(e, r);
}
function Bl(e, t) {
  return C({
    name: M2,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return S2(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be an ISBN";
      }, t)
    }
  }, t);
}
var Sr = { exports: {} }, hd;
function I2() {
  return hd || (hd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;
    function a(o) {
      if ((0, r.default)(o), !d.test(o))
        return !1;
      for (var u = !0, i = 0, s = o.length - 2; s >= 0; s--)
        if (o[s] >= "A" && o[s] <= "Z")
          for (var c = o[s].charCodeAt(0) - 55, l = c % 10, $ = Math.trunc(c / 10), b = 0, m = [l, $]; b < m.length; b++) {
            var f = m[b];
            u ? f >= 5 ? i += 1 + (f - 5) * 2 : i += f * 2 : i += f, u = !u;
          }
        else {
          var v = o[s].charCodeAt(0) - 48;
          u ? v >= 5 ? i += 1 + (v - 5) * 2 : i += v * 2 : i += v, u = !u;
        }
      var h = Math.trunc((i + 9) / 10) * 10 - i;
      return +o[o.length - 1] === h;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Sr, Sr.exports)), Sr.exports;
}
var jl = /* @__PURE__ */ I2();
const Fl = /* @__PURE__ */ j(jl);
var O2 = "isIsin";
function x2(e) {
  return typeof e == "string" && Fl(e);
}
function Zl(e) {
  return C({
    name: O2,
    validator: {
      validate: function(t, r) {
        return x2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an ISIN (stock/security identifier)";
      }, e)
    }
  }, e);
}
var Ir = { exports: {} }, md;
function E2() {
  return md || (md = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ L());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, a = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/, o = function(i) {
      var s = i.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);
      if (s) {
        var c = Number(s[1]), l = Number(s[2]);
        return c % 4 === 0 && c % 100 !== 0 || c % 400 === 0 ? l <= 366 : l <= 365;
      }
      var $ = i.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number), b = $[1], m = $[2], f = $[3], v = m && "0".concat(m).slice(-2), h = f && "0".concat(f).slice(-2), _ = new Date("".concat(b, "-").concat(v || "01", "-").concat(h || "01"));
      return m && f ? _.getUTCFullYear() === b && _.getUTCMonth() + 1 === m && _.getUTCDate() === f : !0;
    };
    function u(i) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(i);
      var c = s.strictSeparator ? a.test(i) : d.test(i);
      return c && s.strict ? o(i) : c;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ir, Ir.exports)), Ir.exports;
}
var Ul = /* @__PURE__ */ E2();
const Gl = /* @__PURE__ */ j(Ul);
var C2 = "isIso8601";
function on(e, t) {
  return typeof e == "string" && Gl(e, t);
}
function kl(e, t) {
  return C({
    name: C2,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return on(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var Or = { exports: {} }, gd;
function N2() {
  return gd || (gd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ot());
    function d(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function a(i) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
        return typeof s;
      } : function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, a(i);
    }
    var o = {
      allow_primitives: !1
    };
    function u(i, s) {
      (0, r.default)(i);
      try {
        s = (0, n.default)(s, o);
        var c = [];
        s.allow_primitives && (c = [null, !1, !0]);
        var l = JSON.parse(i);
        return c.includes(l) || !!l && a(l) === "object";
      } catch {
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Or, Or.exports)), Or.exports;
}
var Hl = /* @__PURE__ */ N2();
const Vl = /* @__PURE__ */ j(Hl);
var P2 = "isJson";
function L2(e) {
  return typeof e == "string" && Vl(e);
}
function Kl(e) {
  return C({
    name: P2,
    validator: {
      validate: function(t, r) {
        return L2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a json string";
      }, e)
    }
  }, e);
}
var xr = { exports: {} }, yd;
function T2() {
  return yd || (yd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ q0());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o) {
      (0, r.default)(o);
      var u = o.split("."), i = u.length;
      return i !== 3 ? !1 : u.reduce(function(s, c) {
        return s && (0, n.default)(c, {
          urlSafe: !0
        });
      }, !0);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(xr, xr.exports)), xr.exports;
}
var Wl = /* @__PURE__ */ T2();
const Yl = /* @__PURE__ */ j(Wl);
var w2 = "isJwt";
function R2(e) {
  return typeof e == "string" && Yl(e);
}
function zl(e) {
  return C({
    name: w2,
    validator: {
      validate: function(t, r) {
        return R2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a jwt string";
      }, e)
    }
  }, e);
}
var Er = { exports: {} }, bd;
function D2() {
  return bd || (bd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a === a.toLowerCase();
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Er, Er.exports)), Er.exports;
}
var Xl = /* @__PURE__ */ D2();
const Ql = /* @__PURE__ */ j(Xl);
var B2 = "isLowercase";
function j2(e) {
  return typeof e == "string" && Ql(e);
}
function Jl(e) {
  return C({
    name: B2,
    validator: {
      validate: function(t, r) {
        return j2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a lowercase string";
      }, e)
    }
  }, e);
}
var Qt = {}, Ad;
function F2() {
  if (Ad) return Qt;
  Ad = 1, Object.defineProperty(Qt, "__esModule", {
    value: !0
  }), Qt.default = n, Qt.locales = void 0;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = {
    "am-AM": /^(\+?374|0)(33|4[134]|55|77|88|9[13-689])\d{6}$/,
    "ar-AE": /^((\+?971)|0)?5[024568]\d{7}$/,
    "ar-BH": /^(\+?973)?(3|6)\d{7}$/,
    "ar-DZ": /^(\+?213|0)(5|6|7)\d{8}$/,
    "ar-LB": /^(\+?961)?((3|81)\d{6}|7\d{7})$/,
    "ar-EG": /^((\+?20)|0)?1[0125]\d{8}$/,
    "ar-IQ": /^(\+?964|0)?7[0-9]\d{8}$/,
    "ar-JO": /^(\+?962|0)?7[789]\d{7}$/,
    "ar-KW": /^(\+?965)([569]\d{7}|41\d{6})$/,
    "ar-LY": /^((\+?218)|0)?(9[1-6]\d{7}|[1-8]\d{7,9})$/,
    "ar-MA": /^(?:(?:\+|00)212|0)[5-7]\d{8}$/,
    "ar-OM": /^((\+|00)968)?(9[1-9])\d{6}$/,
    "ar-PS": /^(\+?970|0)5[6|9](\d{7})$/,
    "ar-SA": /^(!?(\+?966)|0)?5\d{8}$/,
    "ar-SD": /^((\+?249)|0)?(9[012369]|1[012])\d{7}$/,
    "ar-SY": /^(!?(\+?963)|0)?9\d{8}$/,
    "ar-TN": /^(\+?216)?[2459]\d{7}$/,
    "az-AZ": /^(\+994|0)(10|5[015]|7[07]|99)\d{7}$/,
    "bs-BA": /^((((\+|00)3876)|06))((([0-3]|[5-6])\d{6})|(4\d{7}))$/,
    "be-BY": /^(\+?375)?(24|25|29|33|44)\d{7}$/,
    "bg-BG": /^(\+?359|0)?8[789]\d{7}$/,
    "bn-BD": /^(\+?880|0)1[13456789][0-9]{8}$/,
    "ca-AD": /^(\+376)?[346]\d{5}$/,
    "cs-CZ": /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "da-DK": /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "de-DE": /^((\+49|0)1)(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7,9}$/,
    "de-AT": /^(\+43|0)\d{1,4}\d{3,12}$/,
    "de-CH": /^(\+41|0)([1-9])\d{1,9}$/,
    "de-LU": /^(\+352)?((6\d1)\d{6})$/,
    "dv-MV": /^(\+?960)?(7[2-9]|9[1-9])\d{5}$/,
    "el-GR": /^(\+?30|0)?6(8[5-9]|9(?![26])[0-9])\d{7}$/,
    "el-CY": /^(\+?357?)?(9(9|6)\d{6})$/,
    "en-AI": /^(\+?1|0)264(?:2(35|92)|4(?:6[1-2]|76|97)|5(?:3[6-9]|8[1-4])|7(?:2(4|9)|72))\d{4}$/,
    "en-AU": /^(\+?61|0)4\d{8}$/,
    "en-AG": /^(?:\+1|1)268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4}$/,
    "en-BM": /^(\+?1)?441(((3|7)\d{6}$)|(5[0-3][0-9]\d{4}$)|(59\d{5}$))/,
    "en-BS": /^(\+?1[-\s]?|0)?\(?242\)?[-\s]?\d{3}[-\s]?\d{4}$/,
    "en-GB": /^(\+?44|0)7[1-9]\d{8}$/,
    "en-GG": /^(\+?44|0)1481\d{6}$/,
    "en-GH": /^(\+233|0)(20|50|24|54|27|57|26|56|23|53|28|55|59)\d{7}$/,
    "en-GY": /^(\+592|0)6\d{6}$/,
    "en-HK": /^(\+?852[-\s]?)?[456789]\d{3}[-\s]?\d{4}$/,
    "en-MO": /^(\+?853[-\s]?)?[6]\d{3}[-\s]?\d{4}$/,
    "en-IE": /^(\+?353|0)8[356789]\d{7}$/,
    "en-IN": /^(\+?91|0)?[6789]\d{9}$/,
    "en-JM": /^(\+?876)?\d{7}$/,
    "en-KE": /^(\+?254|0)(7|1)\d{8}$/,
    "fr-CF": /^(\+?236| ?)(70|75|77|72|21|22)\d{6}$/,
    "en-SS": /^(\+?211|0)(9[1257])\d{7}$/,
    "en-KI": /^((\+686|686)?)?( )?((6|7)(2|3|8)[0-9]{6})$/,
    "en-KN": /^(?:\+1|1)869(?:46\d|48[89]|55[6-8]|66\d|76[02-7])\d{4}$/,
    "en-LS": /^(\+?266)(22|28|57|58|59|27|52)\d{6}$/,
    "en-MT": /^(\+?356|0)?(99|79|77|21|27|22|25)[0-9]{6}$/,
    "en-MU": /^(\+?230|0)?\d{8}$/,
    "en-MW": /^(\+?265|0)(((77|88|31|99|98|21)\d{7})|(((111)|1)\d{6})|(32000\d{4}))$/,
    "en-NA": /^(\+?264|0)(6|8)\d{7}$/,
    "en-NG": /^(\+?234|0)?[789]\d{9}$/,
    "en-NZ": /^(\+?64|0)[28]\d{7,9}$/,
    "en-PG": /^(\+?675|0)?(7\d|8[18])\d{6}$/,
    "en-PK": /^((00|\+)?92|0)3[0-6]\d{8}$/,
    "en-PH": /^(09|\+639)\d{9}$/,
    "en-RW": /^(\+?250|0)?[7]\d{8}$/,
    "en-SG": /^(\+65)?[3689]\d{7}$/,
    "en-SL": /^(\+?232|0)\d{8}$/,
    "en-TZ": /^(\+?255|0)?[67]\d{8}$/,
    "en-UG": /^(\+?256|0)?[7]\d{8}$/,
    "en-US": /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
    "en-ZA": /^(\+?27|0)\d{9}$/,
    "en-ZM": /^(\+?26)?0[79][567]\d{7}$/,
    "en-ZW": /^(\+263)[0-9]{9}$/,
    "en-BW": /^(\+?267)?(7[1-8]{1})\d{6}$/,
    "es-AR": /^\+?549(11|[2368]\d)\d{8}$/,
    "es-BO": /^(\+?591)?(6|7)\d{7}$/,
    "es-CO": /^(\+?57)?3(0(0|1|2|4|5)|1\d|2[0-4]|5(0|1))\d{7}$/,
    "es-CL": /^(\+?56|0)[2-9]\d{1}\d{7}$/,
    "es-CR": /^(\+506)?[2-8]\d{7}$/,
    "es-CU": /^(\+53|0053)?5\d{7}$/,
    "es-DO": /^(\+?1)?8[024]9\d{7}$/,
    "es-HN": /^(\+?504)?[9|8|3|2]\d{7}$/,
    "es-EC": /^(\+?593|0)([2-7]|9[2-9])\d{7}$/,
    "es-ES": /^(\+?34)?[6|7]\d{8}$/,
    "es-GT": /^(\+?502)?[2|6|7]\d{7}$/,
    "es-PE": /^(\+?51)?9\d{8}$/,
    "es-MX": /^(\+?52)?(1|01)?\d{10,11}$/,
    "es-NI": /^(\+?505)\d{7,8}$/,
    "es-PA": /^(\+?507)\d{7,8}$/,
    "es-PY": /^(\+?595|0)9[9876]\d{7}$/,
    "es-SV": /^(\+?503)?[67]\d{7}$/,
    "es-UY": /^(\+598|0)9[1-9][\d]{6}$/,
    "es-VE": /^(\+?58)?(2|4)\d{9}$/,
    "et-EE": /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
    "fa-IR": /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
    "fi-FI": /^(\+?358|0)\s?(4[0-6]|50)\s?(\d\s?){4,8}$/,
    "fj-FJ": /^(\+?679)?\s?\d{3}\s?\d{4}$/,
    "fo-FO": /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "fr-BF": /^(\+226|0)[67]\d{7}$/,
    "fr-BJ": /^(\+229)\d{8}$/,
    "fr-CD": /^(\+?243|0)?(8|9)\d{8}$/,
    "fr-CM": /^(\+?237)6[0-9]{8}$/,
    "fr-FR": /^(\+?33|0)[67]\d{8}$/,
    "fr-GF": /^(\+?594|0|00594)[67]\d{8}$/,
    "fr-GP": /^(\+?590|0|00590)[67]\d{8}$/,
    "fr-MQ": /^(\+?596|0|00596)[67]\d{8}$/,
    "fr-PF": /^(\+?689)?8[789]\d{6}$/,
    "fr-RE": /^(\+?262|0|00262)[67]\d{8}$/,
    "fr-WF": /^(\+681)?\d{6}$/,
    "he-IL": /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
    "hu-HU": /^(\+?36|06)(20|30|31|50|70)\d{7}$/,
    "id-ID": /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
    "ir-IR": /^(\+98|0)?9\d{9}$/,
    "it-IT": /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
    "it-SM": /^((\+378)|(0549)|(\+390549)|(\+3780549))?6\d{5,9}$/,
    "ja-JP": /^(\+81[ \-]?(\(0\))?|0)[6789]0[ \-]?\d{4}[ \-]?\d{4}$/,
    "ka-GE": /^(\+?995)?(79\d{7}|5\d{8})$/,
    "kk-KZ": /^(\+?7|8)?7\d{9}$/,
    "kl-GL": /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
    "ko-KR": /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
    "ky-KG": /^(\+996\s?)?(22[0-9]|50[0-9]|55[0-9]|70[0-9]|75[0-9]|77[0-9]|880|990|995|996|997|998)\s?\d{3}\s?\d{3}$/,
    "lt-LT": /^(\+370|8)\d{8}$/,
    "lv-LV": /^(\+?371)2\d{7}$/,
    "mg-MG": /^((\+?261|0)(2|3)\d)?\d{7}$/,
    "mn-MN": /^(\+|00|011)?976(77|81|88|91|94|95|96|99)\d{6}$/,
    "my-MM": /^(\+?959|09|9)(2[5-7]|3[1-2]|4[0-5]|6[6-9]|7[5-9]|9[6-9])[0-9]{7}$/,
    "ms-MY": /^(\+?60|0)1(([0145](-|\s)?\d{7,8})|([236-9](-|\s)?\d{7}))$/,
    "mz-MZ": /^(\+?258)?8[234567]\d{7}$/,
    "nb-NO": /^(\+?47)?[49]\d{7}$/,
    "ne-NP": /^(\+?977)?9[78]\d{8}$/,
    "nl-BE": /^(\+?32|0)4\d{8}$/,
    "nl-NL": /^(((\+|00)?31\(0\))|((\+|00)?31)|0)6{1}\d{8}$/,
    "nl-AW": /^(\+)?297(56|59|64|73|74|99)\d{5}$/,
    "nn-NO": /^(\+?47)?[49]\d{7}$/,
    "pl-PL": /^(\+?48)? ?([5-8]\d|45) ?\d{3} ?\d{2} ?\d{2}$/,
    "pt-BR": /^((\+?55\ ?[1-9]{2}\ ?)|(\+?55\ ?\([1-9]{2}\)\ ?)|(0[1-9]{2}\ ?)|(\([1-9]{2}\)\ ?)|([1-9]{2}\ ?))((\d{4}\-?\d{4})|(9[1-9]{1}\d{3}\-?\d{4}))$/,
    "pt-PT": /^(\+?351)?9[1236]\d{7}$/,
    "pt-AO": /^(\+244)\d{9}$/,
    "ro-MD": /^(\+?373|0)((6(0|1|2|6|7|8|9))|(7(6|7|8|9)))\d{6}$/,
    "ro-RO": /^(\+?40|0)\s?7\d{2}(\/|\s|\.|-)?\d{3}(\s|\.|-)?\d{3}$/,
    "ru-RU": /^(\+?7|8)?9\d{9}$/,
    "si-LK": /^(?:0|94|\+94)?(7(0|1|2|4|5|6|7|8)( |-)?)\d{7}$/,
    "sl-SI": /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
    "sk-SK": /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
    "so-SO": /^(\+?252|0)((6[0-9])\d{7}|(7[1-9])\d{7})$/,
    "sq-AL": /^(\+355|0)6[2-9]\d{7}$/,
    "sr-RS": /^(\+3816|06)[- \d]{5,9}$/,
    "sv-SE": /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
    "tg-TJ": /^(\+?992)?[5][5]\d{7}$/,
    "th-TH": /^(\+66|66|0)\d{9}$/,
    "tr-TR": /^(\+?90|0)?5\d{9}$/,
    "tk-TM": /^(\+993|993|8)\d{8}$/,
    "uk-UA": /^(\+?38)?0(50|6[36-8]|7[357]|9[1-9])\d{7}$/,
    "uz-UZ": /^(\+?998)?(6[125-79]|7[1-69]|88|9\d)\d{7}$/,
    "vi-VN": /^((\+?84)|0)((3([2-9]))|(5([25689]))|(7([0|6-9]))|(8([1-9]))|(9([0-9])))([0-9]{7})$/,
    "zh-CN": /^((\+|00)86)?(1[3-9]|9[28])\d{9}$/,
    "zh-TW": /^(\+?886\-?|0)?9\d{8}$/,
    "dz-BT": /^(\+?975|0)?(17|16|77|02)\d{6}$/,
    "ar-YE": /^(((\+|00)9677|0?7)[0137]\d{7}|((\+|00)967|0)[1-7]\d{6})$/,
    "ar-EH": /^(\+?212|0)[\s\-]?(5288|5289)[\s\-]?\d{5}$/,
    "fa-AF": /^(\+93|0)?(2{1}[0-8]{1}|[3-5]{1}[0-4]{1})(\d{7})$/,
    "mk-MK": /^(\+?389|0)?((?:2[2-9]\d{6}|(?:3[1-4]|4[2-8])\d{6}|500\d{5}|5[2-9]\d{6}|7[0-9][2-9]\d{5}|8[1-9]\d{6}|800\d{5}|8009\d{4}))$/
  };
  r["en-CA"] = r["en-US"], r["fr-CA"] = r["en-CA"], r["fr-BE"] = r["nl-BE"], r["zh-HK"] = r["en-HK"], r["zh-MO"] = r["en-MO"], r["ga-IE"] = r["en-IE"], r["fr-CH"] = r["de-CH"], r["it-CH"] = r["fr-CH"];
  function n(d, a, o) {
    if ((0, e.default)(d), o && o.strictMode && !d.startsWith("+"))
      return !1;
    if (Array.isArray(a))
      return a.some(function(s) {
        if (r.hasOwnProperty(s)) {
          var c = r[s];
          if (c.test(d))
            return !0;
        }
        return !1;
      });
    if (a in r)
      return r[a].test(d);
    if (!a || a === "any") {
      for (var u in r)
        if (r.hasOwnProperty(u)) {
          var i = r[u];
          if (i.test(d))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(a, "'"));
  }
  return Qt.locales = Object.keys(r), Qt;
}
var ql = /* @__PURE__ */ F2();
const t4 = /* @__PURE__ */ j(ql);
var Z2 = "isMobilePhone";
function U2(e, t, r) {
  return typeof e == "string" && t4(e, t, r);
}
function e4(e, t, r) {
  return C({
    name: Z2,
    constraints: [e, t],
    validator: {
      validate: function(n, d) {
        return U2(n, d == null ? void 0 : d.constraints[0], d == null ? void 0 : d.constraints[1]);
      },
      defaultMessage: E(function(n) {
        return n + "$property must be a phone number";
      }, r)
    }
  }, r);
}
var Jt = {}, _d;
function un() {
  if (_d) return Jt;
  _d = 1, Object.defineProperty(Jt, "__esModule", {
    value: !0
  }), Jt.CountryCodes = void 0, Jt.default = n;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = /* @__PURE__ */ new Set(["AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AQ", "AR", "AS", "AT", "AU", "AW", "AX", "AZ", "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BL", "BM", "BN", "BO", "BQ", "BR", "BS", "BT", "BV", "BW", "BY", "BZ", "CA", "CC", "CD", "CF", "CG", "CH", "CI", "CK", "CL", "CM", "CN", "CO", "CR", "CU", "CV", "CW", "CX", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC", "EE", "EG", "EH", "ER", "ES", "ET", "FI", "FJ", "FK", "FM", "FO", "FR", "GA", "GB", "GD", "GE", "GF", "GG", "GH", "GI", "GL", "GM", "GN", "GP", "GQ", "GR", "GS", "GT", "GU", "GW", "GY", "HK", "HM", "HN", "HR", "HT", "HU", "ID", "IE", "IL", "IM", "IN", "IO", "IQ", "IR", "IS", "IT", "JE", "JM", "JO", "JP", "KE", "KG", "KH", "KI", "KM", "KN", "KP", "KR", "KW", "KY", "KZ", "LA", "LB", "LC", "LI", "LK", "LR", "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MF", "MG", "MH", "MK", "ML", "MM", "MN", "MO", "MP", "MQ", "MR", "MS", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NC", "NE", "NF", "NG", "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PF", "PG", "PH", "PK", "PL", "PM", "PN", "PR", "PS", "PT", "PW", "PY", "QA", "RE", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD", "SE", "SG", "SH", "SI", "SJ", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SX", "SY", "SZ", "TC", "TD", "TF", "TG", "TH", "TJ", "TK", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TW", "TZ", "UA", "UG", "UM", "US", "UY", "UZ", "VA", "VC", "VE", "VG", "VI", "VN", "VU", "WF", "WS", "YE", "YT", "ZA", "ZM", "ZW"]);
  function n(d) {
    return (0, e.default)(d), r.has(d.toUpperCase());
  }
  return Jt.CountryCodes = r, Jt;
}
var r4 = /* @__PURE__ */ un();
const n4 = /* @__PURE__ */ j(r4);
var G2 = "isISO31661Alpha2";
function k2(e) {
  return typeof e == "string" && n4(e);
}
function d4(e) {
  return C({
    name: G2,
    validator: {
      validate: function(t, r) {
        return k2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a valid ISO31661 Alpha2 code";
      }, e)
    }
  }, e);
}
var Cr = { exports: {} }, Md;
function H2() {
  return Md || (Md = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /* @__PURE__ */ new Set(["AFG", "ALA", "ALB", "DZA", "ASM", "AND", "AGO", "AIA", "ATA", "ATG", "ARG", "ARM", "ABW", "AUS", "AUT", "AZE", "BHS", "BHR", "BGD", "BRB", "BLR", "BEL", "BLZ", "BEN", "BMU", "BTN", "BOL", "BES", "BIH", "BWA", "BVT", "BRA", "IOT", "BRN", "BGR", "BFA", "BDI", "KHM", "CMR", "CAN", "CPV", "CYM", "CAF", "TCD", "CHL", "CHN", "CXR", "CCK", "COL", "COM", "COG", "COD", "COK", "CRI", "CIV", "HRV", "CUB", "CUW", "CYP", "CZE", "DNK", "DJI", "DMA", "DOM", "ECU", "EGY", "SLV", "GNQ", "ERI", "EST", "ETH", "FLK", "FRO", "FJI", "FIN", "FRA", "GUF", "PYF", "ATF", "GAB", "GMB", "GEO", "DEU", "GHA", "GIB", "GRC", "GRL", "GRD", "GLP", "GUM", "GTM", "GGY", "GIN", "GNB", "GUY", "HTI", "HMD", "VAT", "HND", "HKG", "HUN", "ISL", "IND", "IDN", "IRN", "IRQ", "IRL", "IMN", "ISR", "ITA", "JAM", "JPN", "JEY", "JOR", "KAZ", "KEN", "KIR", "PRK", "KOR", "KWT", "KGZ", "LAO", "LVA", "LBN", "LSO", "LBR", "LBY", "LIE", "LTU", "LUX", "MAC", "MKD", "MDG", "MWI", "MYS", "MDV", "MLI", "MLT", "MHL", "MTQ", "MRT", "MUS", "MYT", "MEX", "FSM", "MDA", "MCO", "MNG", "MNE", "MSR", "MAR", "MOZ", "MMR", "NAM", "NRU", "NPL", "NLD", "NCL", "NZL", "NIC", "NER", "NGA", "NIU", "NFK", "MNP", "NOR", "OMN", "PAK", "PLW", "PSE", "PAN", "PNG", "PRY", "PER", "PHL", "PCN", "POL", "PRT", "PRI", "QAT", "REU", "ROU", "RUS", "RWA", "BLM", "SHN", "KNA", "LCA", "MAF", "SPM", "VCT", "WSM", "SMR", "STP", "SAU", "SEN", "SRB", "SYC", "SLE", "SGP", "SXM", "SVK", "SVN", "SLB", "SOM", "ZAF", "SGS", "SSD", "ESP", "LKA", "SDN", "SUR", "SJM", "SWZ", "SWE", "CHE", "SYR", "TWN", "TJK", "TZA", "THA", "TLS", "TGO", "TKL", "TON", "TTO", "TUN", "TUR", "TKM", "TCA", "TUV", "UGA", "UKR", "ARE", "GBR", "USA", "UMI", "URY", "UZB", "VUT", "VEN", "VNM", "VGB", "VIR", "WLF", "ESH", "YEM", "ZMB", "ZWE"]);
    function a(o) {
      return (0, r.default)(o), d.has(o.toUpperCase());
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Cr, Cr.exports)), Cr.exports;
}
var a4 = /* @__PURE__ */ H2();
const o4 = /* @__PURE__ */ j(a4);
var V2 = "isISO31661Alpha3";
function K2(e) {
  return typeof e == "string" && o4(e);
}
function u4(e) {
  return C({
    name: V2,
    validator: {
      validate: function(t, r) {
        return K2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a valid ISO31661 Alpha3 code";
      }, e)
    }
  }, e);
}
var Nr = { exports: {} }, Sd;
function W2() {
  return Sd || (Sd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ dn());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o) {
      return (0, r.default)(o), (0, n.default)(o) && o.length === 24;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Nr, Nr.exports)), Nr.exports;
}
var i4 = /* @__PURE__ */ W2();
const s4 = /* @__PURE__ */ j(i4);
var Y2 = "isMongoId";
function z2(e) {
  return typeof e == "string" && s4(e);
}
function l4(e) {
  return C({
    name: Y2,
    validator: {
      validate: function(t, r) {
        return z2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a mongodb id";
      }, e)
    }
  }, e);
}
var Pr = { exports: {} }, Id;
function X2() {
  return Id || (Id = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /[^\x00-\x7F]/;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Pr, Pr.exports)), Pr.exports;
}
var c4 = /* @__PURE__ */ X2();
const f4 = /* @__PURE__ */ j(c4);
var Q2 = "isMultibyte";
function J2(e) {
  return typeof e == "string" && f4(e);
}
function $4(e) {
  return C({
    name: Q2,
    validator: {
      validate: function(t, r) {
        return J2(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must contain one or more multibyte chars";
      }, e)
    }
  }, e);
}
var Lr = { exports: {} }, Od;
function q2() {
  return Od || (Od = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Lr, Lr.exports)), Lr.exports;
}
var p4 = /* @__PURE__ */ q2();
const v4 = /* @__PURE__ */ j(p4);
var tu = "isSurrogatePair";
function eu(e) {
  return typeof e == "string" && v4(e);
}
function h4(e) {
  return C({
    name: tu,
    validator: {
      validate: function(t, r) {
        return eu(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must contain any surrogate pairs chars";
      }, e)
    }
  }, e);
}
var Tr = { exports: {} }, xd;
function ru() {
  return xd || (xd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = v;
    var r = u(/* @__PURE__ */ L()), n = u(/* @__PURE__ */ Qo()), d = u(/* @__PURE__ */ Ve()), a = u(/* @__PURE__ */ Ie()), o = u(/* @__PURE__ */ ot());
    function u(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function i(h, _) {
      return b(h) || $(h, _) || c(h, _) || s();
    }
    function s() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function c(h, _) {
      if (h) {
        if (typeof h == "string") return l(h, _);
        var O = {}.toString.call(h).slice(8, -1);
        return O === "Object" && h.constructor && (O = h.constructor.name), O === "Map" || O === "Set" ? Array.from(h) : O === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(O) ? l(h, _) : void 0;
      }
    }
    function l(h, _) {
      (_ == null || _ > h.length) && (_ = h.length);
      for (var O = 0, y = Array(_); O < _; O++) y[O] = h[O];
      return y;
    }
    function $(h, _) {
      var O = h == null ? null : typeof Symbol < "u" && h[Symbol.iterator] || h["@@iterator"];
      if (O != null) {
        var y, M, N, D, x = [], A = !0, S = !1;
        try {
          if (N = (O = O.call(h)).next, _ !== 0) for (; !(A = (y = N.call(O)).done) && (x.push(y.value), x.length !== _); A = !0) ;
        } catch (P) {
          S = !0, M = P;
        } finally {
          try {
            if (!A && O.return != null && (D = O.return(), Object(D) !== D)) return;
          } finally {
            if (S) throw M;
          }
        }
        return x;
      }
    }
    function b(h) {
      if (Array.isArray(h)) return h;
    }
    var m = {
      protocols: ["http", "https", "ftp"],
      require_tld: !0,
      require_protocol: !1,
      require_host: !0,
      require_port: !1,
      require_valid_protocol: !0,
      allow_underscores: !1,
      allow_trailing_dot: !1,
      allow_protocol_relative_urls: !1,
      allow_fragments: !0,
      allow_query_components: !0,
      validate_length: !0,
      max_allowed_length: 2084
    }, f = /^\[([^\]]+)\](?::([0-9]+))?$/;
    function v(h, _) {
      if ((0, r.default)(h), !h || /[\s<>]/.test(h) || h.indexOf("mailto:") === 0 || (_ = (0, o.default)(_, m), _.validate_length && h.length > _.max_allowed_length) || !_.allow_fragments && h.includes("#") || !_.allow_query_components && (h.includes("?") || h.includes("&")))
        return !1;
      var O, y, M, N, D, x, A, S;
      if (A = h.split("#"), h = A.shift(), A = h.split("?"), h = A.shift(), A = h.split("://"), A.length > 1) {
        if (O = A.shift().toLowerCase(), _.require_valid_protocol && _.protocols.indexOf(O) === -1)
          return !1;
      } else {
        if (_.require_protocol)
          return !1;
        if (h.slice(0, 2) === "//") {
          if (!_.allow_protocol_relative_urls)
            return !1;
          A[0] = h.slice(2);
        }
      }
      if (h = A.join("://"), h === "")
        return !1;
      if (A = h.split("/"), h = A.shift(), h === "" && !_.require_host)
        return !0;
      if (A = h.split("@"), A.length > 1) {
        if (_.disallow_auth || A[0] === "" || (y = A.shift(), y.indexOf(":") >= 0 && y.split(":").length > 2))
          return !1;
        var P = y.split(":"), Z = i(P, 2), G = Z[0], K = Z[1];
        if (G === "" && K === "")
          return !1;
      }
      N = A.join("@"), x = null, S = null;
      var Y = N.match(f);
      if (Y ? (M = "", S = Y[1], x = Y[2] || null) : (A = N.split(":"), M = A.shift(), A.length && (x = A.join(":"))), x !== null && x.length > 0) {
        if (D = parseInt(x, 10), !/^[0-9]+$/.test(x) || D <= 0 || D > 65535)
          return !1;
      } else if (_.require_port)
        return !1;
      return _.host_whitelist ? (0, n.default)(M, _.host_whitelist) : M === "" && !_.require_host ? !0 : !(!(0, a.default)(M) && !(0, d.default)(M, _) && (!S || !(0, a.default)(S, 6)) || (M = M || S, _.host_blacklist && (0, n.default)(M, _.host_blacklist)));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Tr, Tr.exports)), Tr.exports;
}
var m4 = /* @__PURE__ */ ru();
const g4 = /* @__PURE__ */ j(m4);
var nu = "isUrl";
function du(e, t) {
  return typeof e == "string" && g4(e, t);
}
function y4(e, t) {
  return C({
    name: nu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return du(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a URL address";
      }, t)
    }
  }, t);
}
var wr = { exports: {} }, Ed;
function au() {
  return Ed || (Ed = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = {
      1: /^[0-9A-F]{8}-[0-9A-F]{4}-1[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      2: /^[0-9A-F]{8}-[0-9A-F]{4}-2[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      6: /^[0-9A-F]{8}-[0-9A-F]{4}-6[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      7: /^[0-9A-F]{8}-[0-9A-F]{4}-7[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      8: /^[0-9A-F]{8}-[0-9A-F]{4}-8[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
      nil: /^00000000-0000-0000-0000-000000000000$/i,
      max: /^ffffffff-ffff-ffff-ffff-ffffffffffff$/i,
      // From https://github.com/uuidjs/uuid/blob/main/src/regex.js
      all: /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i
    };
    function a(o, u) {
      return (0, r.default)(o), u == null && (u = "all"), u in d ? d[u].test(o) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(wr, wr.exports)), wr.exports;
}
var b4 = /* @__PURE__ */ au();
const A4 = /* @__PURE__ */ j(b4);
var ou = "isUuid";
function uu(e, t) {
  return typeof e == "string" && A4(e, t);
}
function _4(e, t) {
  return C({
    name: ou,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return uu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a UUID";
      }, t)
    }
  }, t);
}
var iu = "IsFirebasePushId";
function su(e) {
  var t = /^[a-zA-Z0-9_-]*$/;
  return typeof e == "string" && e.length === 20 && t.test(e);
}
function M4(e) {
  return C({
    name: iu,
    validator: {
      validate: function(t, r) {
        return su(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a Firebase Push Id";
      }, e)
    }
  }, e);
}
var Rr = { exports: {} }, Cd;
function lu() {
  return Cd || (Cd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a === a.toUpperCase();
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Rr, Rr.exports)), Rr.exports;
}
var S4 = /* @__PURE__ */ lu();
const I4 = /* @__PURE__ */ j(S4);
var cu = "isUppercase";
function fu(e) {
  return typeof e == "string" && I4(e);
}
function O4(e) {
  return C({
    name: cu,
    validator: {
      validate: function(t, r) {
        return fu(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be uppercase";
      }, e)
    }
  }, e);
}
var Dr = { exports: {} }, Nd;
function $u() {
  return Nd || (Nd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function d(o) {
      "@babel/helpers - typeof";
      return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(u) {
        return typeof u;
      } : function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, d(o);
    }
    function a(o, u) {
      (0, r.default)(o);
      var i, s;
      d(u) === "object" ? (i = u.min || 0, s = u.max) : (i = arguments[1] || 0, s = arguments[2]);
      var c = o.match(/(\uFE0F|\uFE0E)/g) || [], l = o.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [], $ = o.length - c.length - l.length, b = $ >= i && (typeof s > "u" || $ <= s);
      return b && Array.isArray(u == null ? void 0 : u.discreteLengths) ? u.discreteLengths.some(function(m) {
        return m === $;
      }) : b;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Dr, Dr.exports)), Dr.exports;
}
var x4 = /* @__PURE__ */ $u();
const sn = /* @__PURE__ */ j(x4);
var pu = "isLength";
function vu(e, t, r) {
  return typeof e == "string" && sn(e, { min: t, max: r });
}
function E4(e, t, r) {
  return C({
    name: pu,
    constraints: [e, t],
    validator: {
      validate: function(n, d) {
        return vu(n, d == null ? void 0 : d.constraints[0], d == null ? void 0 : d.constraints[1]);
      },
      defaultMessage: E(function(n, d) {
        var a = (d == null ? void 0 : d.constraints[0]) !== null && (d == null ? void 0 : d.constraints[0]) !== void 0, o = (d == null ? void 0 : d.constraints[1]) !== null && (d == null ? void 0 : d.constraints[1]) !== void 0;
        return a && (!d.value || d.value.length < (d == null ? void 0 : d.constraints[0])) ? n + "$property must be longer than or equal to $constraint1 characters" : o && d.value.length > (d == null ? void 0 : d.constraints[1]) ? n + "$property must be shorter than or equal to $constraint2 characters" : n + "$property must be longer than or equal to $constraint1 and shorter than or equal to $constraint2 characters";
      }, r)
    }
  }, r);
}
var hu = "maxLength";
function mu(e, t) {
  return typeof e == "string" && sn(e, { min: 0, max: t });
}
function C4(e, t) {
  return C({
    name: hu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return mu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be shorter than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var gu = "minLength";
function yu(e, t) {
  return typeof e == "string" && sn(e, { min: t });
}
function N4(e, t) {
  return C({
    name: gu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return yu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be longer than or equal to $constraint1 characters";
      }, t)
    }
  }, t);
}
var Br = { exports: {} }, Pd;
function bu() {
  return Pd || (Pd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o, u) {
      return (0, r.default)(a), Object.prototype.toString.call(o) !== "[object RegExp]" && (o = new RegExp(o, u)), !!a.match(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Br, Br.exports)), Br.exports;
}
var P4 = /* @__PURE__ */ bu();
const Au = /* @__PURE__ */ j(P4);
var _u = "matches";
function Mu(e, t, r) {
  return typeof e == "string" && Au(e, t, r);
}
function L4(e, t, r) {
  var n;
  return t && t instanceof Object && !r ? r = t : n = t, C({
    name: _u,
    constraints: [e, n],
    validator: {
      validate: function(d, a) {
        return Mu(d, a == null ? void 0 : a.constraints[0], a == null ? void 0 : a.constraints[1]);
      },
      defaultMessage: E(function(d, a) {
        return d + "$property must match $constraint1 regular expression";
      }, r)
    }
  }, r);
}
const T4 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|[67][125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["300\\d{6}|[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|77)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-3])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|3(?:2\\d\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-3])|600)|646[59])|80[1-9]\\d\\d|9(?:3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|7[1-9]\\d\\d|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}|(?:22|3[2-5]|[47][1-35]|5[1-3578]|6[13-57]|8[1-9]|9[2458])\\d{7}", [9]], ["", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[124-7][2-9]|8[1-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:24[1-9]|3(?:00|3[0-24-9]))|9101)\\d{6}|3(?:0[0-5]|1\\d|2[0-3]|5[01]|70)\\d{7}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["(?:60[1-8]\\d|7(?:0(?:[2-5]\\d|60)|19[0-2]|[2379]\\d\\d))\\d{5}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|310)|76\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["8(?:00(?:14|[2-9]\\d)|(?:33|44|55|66|77|88)[2-9]\\d)\\d{5}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[124]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|11|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:[0147-9]\\d\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8\\d{3})\\d{3}"], ["(?:[23679]\\d|4[015]|5[0-489])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:510|6\\d\\d|7(?:[0-5]\\d|6[01]))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-2]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:1[0-79]|4[0-57-9]|6[0-4])|7(?:[26][0-5]|4[0-28]))|5(?:73[0-6]|95[0-8])|6(?:26[013-8]|66[0-3]|78[0-5])|70(?:7[1-8]|8[0-4])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-4]|899))\\d{4}|(?:4(?:4[0-35-9]|6[02357-9]|7[015])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}"], ["6[01459]\\d{6}|6[01]\\d{5}", [7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|55)\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:[01]0|5[0-2])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:0\\d|5[0-3569]|88)|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0(?:[0-35]\\d|4[4-6])|(?:[13]\\d|2[0-3])\\d)\\d|9(?:[0-46]\\d\\d|5[15]0|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["7(?:[78][0-25-9]|9\\d)\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["[7-9]0[1-9]\\d{7}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1[0-7]|2[014]|30)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["208[78]\\d{6}|(?:20[23579]|30[24])\\d{7}", [10]], 0, 0, 0, 0, ["30[0135-9]\\d{6}", [9]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-7]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["793(?:[01]\\d|2[0-4])\\d{3}|(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[89]|9[12]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[02]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5[0-469])\\d|6(?:[024-6]\\d|[17]0|3[7-9]))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|(?:77|88)\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[01]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["(?:83[01]|92[039])\\d{5}|(?:5[05]|6[069]|72|8[015689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-9]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-7])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-4]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, 0, ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4270\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])|38)\\d{6}", [8, 10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}", [10, 11, 12, 13, 14]], 0, 0, 0, ["700\\d{7,11}", [10, 11, 12, 13, 14]]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[024-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["(?:1505|90[1-9]\\d)\\d{4}|(?:7[126-9]|9[1-9])\\d{6}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[07-9]\\d|1[0-7]|2[0-5]|33|4[0-79]|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[5-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-38])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|8988)\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[16]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", [["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, ["811\\d{7}", [10]], 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["896[0-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-5])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|(?:4|68)\\d|5[2-58])\\d{4}"], ["(?:7[124-7]|8[1-9])\\d{5}", [7]], 0, 0, 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-689])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[6-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[015-8]\\d|2[067]|36|4[0-8]|9[089])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}"], ["90[0-8]\\d{4}", [7]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-7]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:[59][5-8]|7[5-9])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function w4(e, t) {
  var r = Array.prototype.slice.call(t);
  return r.push(T4), e.apply(this, r);
}
function Ld(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var r = e[0].split("."), n = t[0].split("."), d = 0; d < 3; d++) {
    var a = Number(r[d]), o = Number(n[d]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var R4 = {}.constructor;
function le(e) {
  return e != null && e.constructor === R4;
}
function V0(e) {
  "@babel/helpers - typeof";
  return V0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, V0(e);
}
function Ke(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function D4(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function We(e, t, r) {
  return t && D4(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var B4 = "1.2.0", j4 = "1.7.35", Td = " ext. ", F4 = /^\d+$/, ut = /* @__PURE__ */ function() {
  function e(t) {
    Ke(this, e), Su(t), this.metadata = t, Iu.call(this, t);
  }
  return We(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && F4.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new wd(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new wd(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var n = this.nonGeographic()[t];
        if (n)
          return n;
      } else {
        var d = this.countryCallingCodes()[t];
        if (d && d.length === 1 && d[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), wd = /* @__PURE__ */ function() {
  function e(t, r) {
    Ke(this, e), this.globalMetadataObject = r, this.metadata = t, Iu.call(this, r.metadata);
  }
  return We(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(n) {
        return new Z4(n, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && Rd(this.types(), t))
        return new G4(Rd(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Td : this.metadata[13] || Td;
    }
  }]), e;
}(), Z4 = /* @__PURE__ */ function() {
  function e(t, r) {
    Ke(this, e), this._format = t, this.metadata = r;
  }
  return We(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !U4.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), U4 = /^\(?\$1\)?$/, G4 = /* @__PURE__ */ function() {
  function e(t, r) {
    Ke(this, e), this.type = t, this.metadata = r;
  }
  return We(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Rd(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Su(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!le(e) || !le(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(le(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + k4(e) + ": " + e, "."));
}
var k4 = function(e) {
  return V0(e);
};
function ln(e, t) {
  if (t = new ut(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Iu(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Ld(t, B4) === -1 ? this.v2 = !0 : Ld(t, j4) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function cn(e, t) {
  return H4(e, void 0, t);
}
function H4(e, t, r) {
  var n = r.type(t), d = n && n.possibleLengths() || r.possibleLengths();
  if (!d)
    return "IS_POSSIBLE";
  var a = e.length, o = d[0];
  return o === a ? "IS_POSSIBLE" : o > a ? "TOO_SHORT" : d[d.length - 1] < a ? "TOO_LONG" : d.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function V4(e, t, r) {
  if (t === void 0 && (t = {}), r = new ut(r), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    r.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!r.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      r.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      r.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (r.possibleLengths())
    return Ou(e.phone || e.nationalNumber, r);
  if (e.countryCallingCode && r.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Ou(e, t) {
  switch (cn(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function St(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function K4(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = W4(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function W4(e, t) {
  if (e) {
    if (typeof e == "string") return Dd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Dd(e, t);
  }
}
function Dd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var Y4 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function fn(e, t, r) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    r = new ut(r), r.selectNumberingPlan(e.country, e.countryCallingCode);
    var n = t.v2 ? e.nationalNumber : e.phone;
    if (St(n, r.nationalNumberPattern())) {
      if (jr(n, "FIXED_LINE", r))
        return r.type("MOBILE") && r.type("MOBILE").pattern() === "" || !r.type("MOBILE") || jr(n, "MOBILE", r) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var d = K4(Y4), a; !(a = d()).done; ) {
        var o = a.value;
        if (jr(n, o, r))
          return o;
      }
    }
  }
}
function jr(e, t, r) {
  return t = r.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : St(e, t.pattern());
}
function z4(e, t, r) {
  if (t = t || {}, r = new ut(r), r.selectNumberingPlan(e.country, e.countryCallingCode), r.hasTypes())
    return fn(e, t, r.metadata) !== void 0;
  var n = t.v2 ? e.nationalNumber : e.phone;
  return St(n, r.nationalNumberPattern());
}
function X4(e, t, r) {
  var n = new ut(r), d = n.getCountryCodesForCallingCode(e);
  return d ? d.filter(function(a) {
    return Q4(t, a, r);
  }) : [];
}
function Q4(e, t, r) {
  var n = new ut(r);
  return n.selectNumberingPlan(t), n.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var $n = 2, J4 = 17, q4 = 3, ht = "0-9０-９٠-٩۰-۹", tc = "-‐-―−ー－", ec = "／/", rc = "．.", nc = "  ­​⁠　", dc = "()（）［］\\[\\]", ac = "~⁓∼～", Ue = "".concat(tc).concat(ec).concat(rc).concat(nc).concat(dc).concat(ac), pn = "+＋", oc = new RegExp("([" + ht + "])");
function uc(e, t, r, n) {
  if (t) {
    var d = new ut(n);
    d.selectNumberingPlan(t, r);
    var a = new RegExp(d.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(oc);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function ic(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var r = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), n = r.exec(e);
    if (n) {
      var d, a, o = n.length - 1, u = o > 0 && n[o];
      if (t.nationalPrefixTransformRule() && u)
        d = e.replace(r, t.nationalPrefixTransformRule()), o > 1 && (a = n[1]);
      else {
        var i = n[0];
        d = e.slice(i.length), u && (a = n[1]);
      }
      var s;
      if (u) {
        var c = e.indexOf(n[1]), l = e.slice(0, c);
        l === t.numberingPlan.nationalPrefix() && (s = t.numberingPlan.nationalPrefix());
      } else
        s = n[0];
      return {
        nationalNumber: d,
        nationalPrefix: s,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function K0(e, t) {
  var r = ic(e, t), n = r.carrierCode, d = r.nationalNumber;
  if (d !== e) {
    if (!sc(e, d, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !lc(d, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: d,
    carrierCode: n
  };
}
function sc(e, t, r) {
  return !(St(e, r.nationalNumberPattern()) && !St(t, r.nationalNumberPattern()));
}
function lc(e, t) {
  switch (cn(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function cc(e, t, r, n) {
  var d = t ? ln(t, n) : r;
  if (e.indexOf(d) === 0) {
    n = new ut(n), n.selectNumberingPlan(t, r);
    var a = e.slice(d.length), o = K0(a, n), u = o.nationalNumber, i = K0(e, n), s = i.nationalNumber;
    if (!St(s, n.nationalNumberPattern()) && St(u, n.nationalNumberPattern()) || cn(s, n) === "TOO_LONG")
      return {
        countryCallingCode: d,
        number: a
      };
  }
  return {
    number: e
  };
}
function xu(e, t, r, n) {
  if (!e)
    return {};
  var d;
  if (e[0] !== "+") {
    var a = uc(e, t, r, n);
    if (a && a !== e)
      d = !0, e = "+" + a;
    else {
      if (t || r) {
        var o = cc(e, t, r, n), u = o.countryCallingCode, i = o.number;
        if (u)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: u,
            number: i
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new ut(n);
  for (var s = 2; s - 1 <= q4 && s <= e.length; ) {
    var c = e.slice(1, s);
    if (n.hasCallingCode(c))
      return n.selectNumberingPlan(c), {
        countryCallingCodeSource: d ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(s)
      };
    s++;
  }
  return {};
}
function fc(e) {
  return e.replace(new RegExp("[".concat(Ue, "]+"), "g"), " ").trim();
}
var $c = /(\$\d)/;
function pc(e, t, r) {
  var n = r.useInternationalFormat, d = r.withNationalPrefix, a = e.replace(new RegExp(t.pattern()), n ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    d && t.nationalPrefixFormattingRule() ? t.format().replace($c, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return n ? fc(a) : a;
}
var vc = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function hc(e, t, r) {
  var n = new ut(r);
  if (n.selectNumberingPlan(e, t), n.defaultIDDPrefix())
    return n.defaultIDDPrefix();
  if (vc.test(n.IDDPrefix()))
    return n.IDDPrefix();
}
var mc = ";ext=", qt = function(e) {
  return "([".concat(ht, "]{1,").concat(e, "})");
};
function Eu(e) {
  var t = "20", r = "15", n = "9", d = "6", a = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", u = "#?", i = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", s = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", l = "[  \\t]*", $ = "(?:,{2}|;)", b = mc + qt(t), m = a + i + o + qt(t) + u, f = a + s + o + qt(n) + u, v = c + qt(d) + "#", h = l + $ + o + qt(r) + u, _ = l + "(?:,)+" + o + qt(n) + u;
  return b + "|" + m + "|" + f + "|" + v + "|" + h + "|" + _;
}
var gc = "[" + ht + "]{" + $n + "}", yc = "[" + pn + "]{0,1}(?:[" + Ue + "]*[" + ht + "]){3,}[" + Ue + ht + "]*", bc = new RegExp("^[" + pn + "]{0,1}(?:[" + Ue + "]*[" + ht + "]){1,2}$", "i"), Ac = yc + // Phone number extensions
"(?:" + Eu() + ")?", _c = new RegExp(
  // Either a short two-digit-only phone number
  "^" + gc + "$|^" + Ac + "$",
  "i"
);
function Mc(e) {
  return e.length >= $n && _c.test(e);
}
function Sc(e) {
  return bc.test(e);
}
function Ic(e) {
  var t = e.number, r = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(r ? ";ext=" + r : "");
}
function Oc(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = xc(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xc(e, t) {
  if (e) {
    if (typeof e == "string") return Bd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Bd(e, t);
  }
}
function Bd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function jd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? jd(Object(r), !0).forEach(function(n) {
      Ec(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ec(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
var Zd = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function Cc(e, t, r, n) {
  if (r ? r = Fd(Fd({}, Zd), r) : r = Zd, n = new ut(n), e.country && e.country !== "001") {
    if (!n.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    n.country(e.country);
  } else if (e.countryCallingCode)
    n.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var d = n.countryCallingCode(), a = r.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return a ? (o = Ge(a, e.carrierCode, "NATIONAL", n, r), Fr(o, e.ext, n, r.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (o = Ge(a, null, "INTERNATIONAL", n, r), o = "+".concat(d, " ").concat(o), Fr(o, e.ext, n, r.formatExtension)) : "+".concat(d);
    case "E.164":
      return "+".concat(d).concat(a);
    case "RFC3966":
      return Ic({
        number: "+".concat(d).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!r.fromCountry)
        return;
      var u = Pc(a, e.carrierCode, d, r.fromCountry, n);
      return Fr(u, e.ext, n, r.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Ge(e, t, r, n, d) {
  var a = Nc(n.formats(), e);
  return a ? pc(e, a, {
    useInternationalFormat: r === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && d && d.nationalPrefix === !1)
  }) : e;
}
function Nc(e, t) {
  for (var r = Oc(e), n; !(n = r()).done; ) {
    var d = n.value;
    if (d.leadingDigitsPatterns().length > 0) {
      var a = d.leadingDigitsPatterns()[d.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (St(t, d.pattern()))
      return d;
  }
}
function Fr(e, t, r, n) {
  return t ? n(e, t, r) : e;
}
function Pc(e, t, r, n, d) {
  var a = ln(n, d.metadata);
  if (a === r) {
    var o = Ge(e, t, "NATIONAL", d);
    return r === "1" ? r + " " + o : o;
  }
  var u = hc(n, void 0, d.metadata);
  if (u)
    return "".concat(u, " ").concat(r, " ").concat(Ge(e, null, "INTERNATIONAL", d));
}
function Ud(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ud(Object(r), !0).forEach(function(n) {
      Lc(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ud(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lc(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Tc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function wc(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function Rc(e, t, r) {
  return t && wc(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Dc = /* @__PURE__ */ function() {
  function e(t, r, n) {
    if (Tc(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !r)
        throw new TypeError("`metadata` argument not passed");
      if (le(r) && le(r.countries)) {
        n = r;
        var d = t;
        if (!Fc.test(d))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = xu(d, void 0, void 0, n), o = a.countryCallingCode, u = a.number;
        if (r = u, t = o, !r)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!r)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof r != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Su(n);
    var i = jc(t, n), s = i.country, c = i.countryCallingCode;
    this.country = s, this.countryCallingCode = c, this.nationalNumber = r, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return n;
    };
  }
  return Rc(e, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : X4(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return V4(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return z4(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new ut(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return fn(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return Cc(this, t, r ? Gd(Gd({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]), e;
}(), Bc = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function jc(e, t) {
  var r, n, d = new ut(t);
  return Bc(e) ? (r = e, d.selectNumberingPlan(r), n = d.countryCallingCode()) : n = e, {
    country: r,
    countryCallingCode: n
  };
}
var Fc = /^\+\d+$/;
function W0(e) {
  "@babel/helpers - typeof";
  return W0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, W0(e);
}
function Zc(e, t, r) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Uc(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Gc(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _e(e, t);
}
function kc(e) {
  var t = Nu();
  return function() {
    var r = Me(e), n;
    if (t) {
      var d = Me(this).constructor;
      n = Reflect.construct(r, arguments, d);
    } else
      n = r.apply(this, arguments);
    return Hc(this, n);
  };
}
function Hc(e, t) {
  if (t && (W0(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Cu(e);
}
function Cu(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Y0(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Y0 = function(r) {
    if (r === null || !Vc(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, n);
    }
    function n() {
      return Ze(r, arguments, Me(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), _e(n, r);
  }, Y0(e);
}
function Ze(e, t, r) {
  return Nu() ? Ze = Reflect.construct : Ze = function(n, d, a) {
    var o = [null];
    o.push.apply(o, d);
    var u = Function.bind.apply(n, o), i = new u();
    return a && _e(i, a.prototype), i;
  }, Ze.apply(null, arguments);
}
function Nu() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Vc(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function _e(e, t) {
  return _e = Object.setPrototypeOf || function(r, n) {
    return r.__proto__ = n, r;
  }, _e(e, t);
}
function Me(e) {
  return Me = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Me(e);
}
var Ct = /* @__PURE__ */ function(e) {
  Gc(r, e);
  var t = kc(r);
  function r(n) {
    var d;
    return Uc(this, r), d = t.call(this, n), Object.setPrototypeOf(Cu(d), r.prototype), d.name = d.constructor.name, d;
  }
  return Zc(r);
}(/* @__PURE__ */ Y0(Error)), kd = new RegExp("(?:" + Eu() + ")$", "i");
function Kc(e) {
  var t = e.search(kd);
  if (t < 0)
    return {};
  for (var r = e.slice(0, t), n = e.match(kd), d = 1; d < n.length; ) {
    if (n[d])
      return {
        number: r,
        ext: n[d]
      };
    d++;
  }
}
var Wc = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Yc(e) {
  return Wc[e];
}
function zc(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = Xc(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xc(e, t) {
  if (e) {
    if (typeof e == "string") return Hd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hd(e, t);
  }
}
function Hd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function Vd(e) {
  for (var t = "", r = zc(e.split("")), n; !(n = r()).done; ) {
    var d = n.value;
    t += Qc(d, t) || "";
  }
  return t;
}
function Qc(e, t, r) {
  return e === "+" ? t ? void 0 : "+" : Yc(e);
}
function Jc(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r) return (r = r.call(e)).next.bind(r);
  if (Array.isArray(e) || (r = qc(e)) || t) {
    r && (e = r);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qc(e, t) {
  if (e) {
    if (typeof e == "string") return Kd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Kd(e, t);
  }
}
function Kd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function t8(e, t) {
  var r = t.countries, n = t.metadata;
  n = new ut(n);
  for (var d = Jc(r), a; !(a = d()).done; ) {
    var o = a.value;
    if (n.country(o), n.leadingDigits()) {
      if (e && e.search(n.leadingDigits()) === 0)
        return o;
    } else if (fn({
      phone: e,
      country: o
    }, void 0, n.metadata))
      return o;
  }
}
function e8(e, t) {
  var r = t.nationalNumber, n = t.metadata, d = n.getCountryCodesForCallingCode(e);
  if (d)
    return d.length === 1 ? d[0] : t8(r, {
      countries: d,
      metadata: n.metadata
    });
}
var Pu = "+", r8 = "[\\-\\.\\(\\)]?", Wd = "([" + ht + "]|" + r8 + ")", n8 = "^\\" + Pu + Wd + "*[" + ht + "]" + Wd + "*$", d8 = new RegExp(n8, "g"), z0 = ht, a8 = "[" + z0 + "]+((\\-)*[" + z0 + "])*", o8 = "a-zA-Z", u8 = "[" + o8 + "]+((\\-)*[" + z0 + "])*", i8 = "^(" + a8 + "\\.)*" + u8 + "\\.?$", s8 = new RegExp(i8, "g"), Yd = "tel:", X0 = ";phone-context=", l8 = ";isub=";
function c8(e) {
  var t = e.indexOf(X0);
  if (t < 0)
    return null;
  var r = t + X0.length;
  if (r >= e.length)
    return "";
  var n = e.indexOf(";", r);
  return n >= 0 ? e.substring(r, n) : e.substring(r);
}
function f8(e) {
  return e === null ? !0 : e.length === 0 ? !1 : d8.test(e) || s8.test(e);
}
function $8(e, t) {
  var r = t.extractFormattedPhoneNumber, n = c8(e);
  if (!f8(n))
    throw new Ct("NOT_A_NUMBER");
  var d;
  if (n === null)
    d = r(e) || "";
  else {
    d = "", n.charAt(0) === Pu && (d += n);
    var a = e.indexOf(Yd), o;
    a >= 0 ? o = a + Yd.length : o = 0;
    var u = e.indexOf(X0);
    d += e.substring(o, u);
  }
  var i = d.indexOf(l8);
  if (i > 0 && (d = d.substring(0, i)), d !== "")
    return d;
}
var p8 = 250, v8 = new RegExp("[" + pn + ht + "]"), h8 = new RegExp("[^" + ht + "#]+$");
function m8(e, t, r) {
  if (t = t || {}, r = new ut(r), t.defaultCountry && !r.hasCountry(t.defaultCountry))
    throw t.v2 ? new Ct("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var n = y8(e, t.v2, t.extract), d = n.number, a = n.ext, o = n.error;
  if (!d) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new Ct("TOO_SHORT") : new Ct("NOT_A_NUMBER");
    return {};
  }
  var u = A8(d, t.defaultCountry, t.defaultCallingCode, r), i = u.country, s = u.nationalNumber, c = u.countryCallingCode, l = u.countryCallingCodeSource, $ = u.carrierCode;
  if (!r.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Ct("INVALID_COUNTRY");
    return {};
  }
  if (!s || s.length < $n) {
    if (t.v2)
      throw new Ct("TOO_SHORT");
    return {};
  }
  if (s.length > J4) {
    if (t.v2)
      throw new Ct("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var b = new Dc(c, s, r.metadata);
    return i && (b.country = i), $ && (b.carrierCode = $), a && (b.ext = a), b.__countryCallingCodeSource = l, b;
  }
  var m = (t.extended ? r.hasSelectedNumberingPlan() : i) ? St(s, r.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: i,
    countryCallingCode: c,
    carrierCode: $,
    valid: m,
    possible: m ? !0 : !!(t.extended === !0 && r.possibleLengths() && Ou(s, r)),
    phone: s,
    ext: a
  } : m ? b8(i, s, a) : {};
}
function g8(e, t, r) {
  if (e) {
    if (e.length > p8) {
      if (r)
        throw new Ct("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var n = e.search(v8);
    if (!(n < 0))
      return e.slice(n).replace(h8, "");
  }
}
function y8(e, t, r) {
  var n = $8(e, {
    extractFormattedPhoneNumber: function(a) {
      return g8(a, r, t);
    }
  });
  if (!n)
    return {};
  if (!Mc(n))
    return Sc(n) ? {
      error: "TOO_SHORT"
    } : {};
  var d = Kc(n);
  return d.ext ? d : {
    number: n
  };
}
function b8(e, t, r) {
  var n = {
    country: e,
    phone: t
  };
  return r && (n.ext = r), n;
}
function A8(e, t, r, n) {
  var d = xu(Vd(e), t, r, n.metadata), a = d.countryCallingCodeSource, o = d.countryCallingCode, u = d.number, i;
  if (o)
    n.selectNumberingPlan(o);
  else if (u && (t || r))
    n.selectNumberingPlan(t, r), t && (i = t), o = r || ln(t, n.metadata);
  else return {};
  if (!u)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o
    };
  var s = K0(Vd(u), n), c = s.nationalNumber, l = s.carrierCode, $ = e8(o, {
    nationalNumber: c,
    metadata: n
  });
  return $ && (i = $, $ === "001" || n.country(i)), {
    country: i,
    countryCallingCode: o,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: l
  };
}
function zd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zd(Object(r), !0).forEach(function(n) {
      _8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function _8(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function M8(e, t, r) {
  return m8(e, Xd(Xd({}, t), {}, {
    v2: !0
  }), r);
}
function Qd(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function S8(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qd(Object(r), !0).forEach(function(n) {
      I8(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qd(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function I8(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function O8(e, t) {
  return N8(e) || C8(e, t) || E8(e, t) || x8();
}
function x8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function E8(e, t) {
  if (e) {
    if (typeof e == "string") return Jd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Jd(e, t);
  }
}
function Jd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function C8(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], d = !0, a = !1, o, u;
    try {
      for (r = r.call(e); !(d = (o = r.next()).done) && (n.push(o.value), !(t && n.length === t)); d = !0)
        ;
    } catch (i) {
      a = !0, u = i;
    } finally {
      try {
        !d && r.return != null && r.return();
      } finally {
        if (a) throw u;
      }
    }
    return n;
  }
}
function N8(e) {
  if (Array.isArray(e)) return e;
}
function P8(e) {
  var t = Array.prototype.slice.call(e), r = O8(t, 4), n = r[0], d = r[1], a = r[2], o = r[3], u, i, s;
  if (typeof n == "string")
    u = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!d || typeof d == "string")
    o ? (i = a, s = o) : (i = void 0, s = a), d && (i = S8({
      defaultCountry: d
    }, i));
  else if (le(d))
    a ? (i = d, s = a) : s = d;
  else throw new Error("Invalid second argument: ".concat(d));
  return {
    text: u,
    options: i,
    metadata: s
  };
}
function L8() {
  var e = P8(arguments), t = e.text, r = e.options, n = e.metadata;
  return M8(t, r, n);
}
function T8() {
  return w4(L8, arguments);
}
var Lu = "isPhoneNumber";
function Tu(e, t) {
  if (typeof e != "string" || e.trim() !== e)
    return !1;
  try {
    var r = T8(e, t);
    return t && r.country !== t ? !1 : r.isValid();
  } catch {
    return !1;
  }
}
function w8(e, t) {
  return C({
    name: Lu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Tu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a valid phone number";
      }, t)
    }
  }, t);
}
var wu = "isMilitaryTime";
function Ru(e) {
  var t = /^([01]\d|2[0-3]):?([0-5]\d)$/;
  return typeof e == "string" && Au(e, t);
}
function R8(e) {
  return C({
    name: wu,
    validator: {
      validate: function(t, r) {
        return Ru(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a valid representation of military time in the format HH:MM";
      }, e)
    }
  }, e);
}
var Zr = { exports: {} }, qd;
function Du() {
  return qd || (qd = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = {
      md5: 32,
      md4: 32,
      sha1: 40,
      sha256: 64,
      sha384: 96,
      sha512: 128,
      ripemd128: 32,
      ripemd160: 40,
      tiger128: 32,
      tiger160: 40,
      tiger192: 48,
      crc32: 8,
      crc32b: 8
    };
    function a(o, u) {
      (0, r.default)(o);
      var i = new RegExp("^[a-fA-F0-9]{".concat(d[u], "}$"));
      return i.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Zr, Zr.exports)), Zr.exports;
}
var D8 = /* @__PURE__ */ Du();
const B8 = /* @__PURE__ */ j(D8);
var Bu = "isHash";
function ju(e, t) {
  return typeof e == "string" && B8(e, t);
}
function j8(e, t) {
  return C({
    name: Bu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ju(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a hash of type $constraint1";
      }, t)
    }
  }, t);
}
var Ur = { exports: {} }, ta;
function Fu() {
  return ta || (ta = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = "^\\d{4}-?\\d{3}[\\dX]$";
    function a(o) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      (0, r.default)(o);
      var i = d;
      if (i = u.require_hyphen ? i.replace("?", "") : i, i = u.case_sensitive ? new RegExp(i) : new RegExp(i, "i"), !i.test(o))
        return !1;
      for (var s = o.replace("-", "").toUpperCase(), c = 0, l = 0; l < s.length; l++) {
        var $ = s[l];
        c += ($ === "X" ? 10 : +$) * (8 - l);
      }
      return c % 11 === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Ur, Ur.exports)), Ur.exports;
}
var F8 = /* @__PURE__ */ Fu();
const Z8 = /* @__PURE__ */ j(F8);
var Zu = "isISSN";
function Uu(e, t) {
  return typeof e == "string" && Z8(e, t);
}
function U8(e, t) {
  return C({
    name: Zu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Uu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a ISSN";
      }, t)
    }
  }, t);
}
var Gu = "isDateString";
function ku(e, t) {
  return on(e, t);
}
function G8(e, t) {
  return C({
    name: Gu,
    constraints: [e],
    validator: {
      validate: function(r) {
        return ku(r, e);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a valid ISO 8601 date string";
      }, t)
    }
  }, t);
}
var Gr = { exports: {} }, ea;
function Hu() {
  return ea || (ea = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ L());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = {
      loose: !1
    }, a = ["true", "false", "1", "0"], o = [].concat(a, ["yes", "no"]);
    function u(i) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d;
      return (0, r.default)(i), s.loose ? o.includes(i.toLowerCase()) : a.includes(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Gr, Gr.exports)), Gr.exports;
}
var k8 = /* @__PURE__ */ Hu();
const H8 = /* @__PURE__ */ j(k8);
var Vu = "isBooleanString";
function Ku(e) {
  return typeof e == "string" && H8(e);
}
function V8(e) {
  return C({
    name: Vu,
    validator: {
      validate: function(t, r) {
        return Ku(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a boolean string";
      }, e)
    }
  }, e);
}
var kr = { exports: {} }, ra;
function Wu() {
  return ra || (ra = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = /* @__PURE__ */ Se();
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^[0-9]+$/;
    function o(u, i) {
      return (0, r.default)(u), i && i.no_symbols ? a.test(u) : new RegExp("^[+-]?([0-9]*[".concat((i || {}).locale ? n.decimal[i.locale] : ".", "])?[0-9]+$")).test(u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(kr, kr.exports)), kr.exports;
}
var K8 = /* @__PURE__ */ Wu();
const W8 = /* @__PURE__ */ j(K8);
var Yu = "isNumberString";
function zu(e, t) {
  return typeof e == "string" && W8(e, t);
}
function Y8(e, t) {
  return C({
    name: Yu,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return zu(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a number string";
      }, t)
    }
  }, t);
}
var Hr = { exports: {} }, na;
function Xu() {
  return na || (na = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ot());
    function d(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /^[A-Z2-7]+=*$/, o = /^[A-HJKMNP-TV-Z0-9]+$/, u = {
      crockford: !1
    };
    function i(s, c) {
      if ((0, r.default)(s), c = (0, n.default)(c, u), c.crockford)
        return o.test(s);
      var l = s.length;
      return !!(l % 8 === 0 && a.test(s));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Hr, Hr.exports)), Hr.exports;
}
var z8 = /* @__PURE__ */ Xu();
const X8 = /* @__PURE__ */ j(z8);
var Qu = "isBase32";
function Ju(e) {
  return typeof e == "string" && X8(e);
}
function Q8(e) {
  return C({
    name: Qu,
    validator: {
      validate: function(t, r) {
        return Ju(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be base32 encoded";
      }, e)
    }
  }, e);
}
var Vr = { exports: {} }, da;
function qu() {
  return da || (da = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = /* @__PURE__ */ un();
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = /^[A-Za-z]{6}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    function o(u) {
      (0, r.default)(u);
      var i = u.slice(4, 6).toUpperCase();
      return !n.CountryCodes.has(i) && i !== "XK" ? !1 : a.test(u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Vr, Vr.exports)), Vr.exports;
}
var J8 = /* @__PURE__ */ qu();
const q8 = /* @__PURE__ */ j(J8);
var ti = "isBIC";
function ei(e) {
  return typeof e == "string" && q8(e);
}
function t6(e) {
  return C({
    name: ti,
    validator: {
      validate: function(t, r) {
        return ei(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a BIC or SWIFT code";
      }, e)
    }
  }, e);
}
var Kr = { exports: {} }, aa;
function ri() {
  return aa || (aa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ L());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = /^(bc1|tb1|bc1p|tb1p)[ac-hj-np-z02-9]{39,58}$/, a = /^(1|2|3|m)[A-HJ-NP-Za-km-z1-9]{25,39}$/;
    function o(u) {
      return (0, r.default)(u), d.test(u) || a.test(u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Kr, Kr.exports)), Kr.exports;
}
var e6 = /* @__PURE__ */ ri();
const r6 = /* @__PURE__ */ j(e6);
var ni = "isBtcAddress";
function di(e) {
  return typeof e == "string" && r6(e);
}
function n6(e) {
  return C({
    name: ni,
    validator: {
      validate: function(t, r) {
        return di(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a BTC address";
      }, e)
    }
  }, e);
}
var Wr = { exports: {} }, oa;
function ai() {
  return oa || (oa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ L());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^[a-z]+\/[a-z0-9\-\+\._]+$/i, a = /^[a-z\-]+=[a-z0-9\-]+$/i, o = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;
    function u(i) {
      (0, r.default)(i);
      var s = i.split(",");
      if (s.length < 2)
        return !1;
      var c = s.shift().trim().split(";"), l = c.shift();
      if (l.slice(0, 5) !== "data:")
        return !1;
      var $ = l.slice(5);
      if ($ !== "" && !d.test($))
        return !1;
      for (var b = 0; b < c.length; b++)
        if (!(b === c.length - 1 && c[b].toLowerCase() === "base64") && !a.test(c[b]))
          return !1;
      for (var m = 0; m < s.length; m++)
        if (!o.test(s[m]))
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Wr, Wr.exports)), Wr.exports;
}
var d6 = /* @__PURE__ */ ai();
const a6 = /* @__PURE__ */ j(d6);
var oi = "isDataURI";
function ui(e) {
  return typeof e == "string" && a6(e);
}
function o6(e) {
  return C({
    name: oi,
    validator: {
      validate: function(t, r) {
        return ui(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a data uri format";
      }, e)
    }
  }, e);
}
var Yr = { exports: {} }, ua;
function ii() {
  return ua || (ua = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var r = n(/* @__PURE__ */ L());
    function n(c) {
      return c && c.__esModule ? c : { default: c };
    }
    var d = 8, a = 14, o = /^(\d{8}|\d{13}|\d{14})$/;
    function u(c, l) {
      return c === d || c === a ? l % 2 === 0 ? 3 : 1 : l % 2 === 0 ? 1 : 3;
    }
    function i(c) {
      var l = c.slice(0, -1).split("").map(function(b, m) {
        return Number(b) * u(c.length, m);
      }).reduce(function(b, m) {
        return b + m;
      }, 0), $ = 10 - l % 10;
      return $ < 10 ? $ : 0;
    }
    function s(c) {
      (0, r.default)(c);
      var l = Number(c.slice(-1));
      return o.test(c) && l === i(c);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Yr, Yr.exports)), Yr.exports;
}
var u6 = /* @__PURE__ */ ii();
const i6 = /* @__PURE__ */ j(u6);
var si = "isEAN";
function li(e) {
  return typeof e == "string" && i6(e);
}
function s6(e) {
  return C({
    name: si,
    validator: {
      validate: function(t, r) {
        return li(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an EAN (European Article Number)";
      }, e)
    }
  }, e);
}
var zr = { exports: {} }, ia;
function ci() {
  return ia || (ia = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^(0x)[0-9a-f]{40}$/i;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(zr, zr.exports)), zr.exports;
}
var l6 = /* @__PURE__ */ ci();
const c6 = /* @__PURE__ */ j(l6);
var fi = "isEthereumAddress";
function $i(e) {
  return typeof e == "string" && c6(e);
}
function f6(e) {
  return C({
    name: fi,
    validator: {
      validate: function(t, r) {
        return $i(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an Ethereum address";
      }, e)
    }
  }, e);
}
var Xr = { exports: {} }, sa;
function pi() {
  return sa || (sa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ L());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(,(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}(,((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?))?\)$/i, a = /^hsla?\(((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?))(deg|grad|rad|turn)?(\s(\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%){2}\s?(\/\s((\+|\-)?([0-9]+(\.[0-9]+)?(e(\+|\-)?[0-9]+)?|\.[0-9]+(e(\+|\-)?[0-9]+)?)%?)\s?)?\)$/i;
    function o(u) {
      (0, r.default)(u);
      var i = u.replace(/\s+/g, " ").replace(/\s?(hsla?\(|\)|,)\s?/ig, "$1");
      return i.indexOf(",") !== -1 ? d.test(i) : a.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Xr, Xr.exports)), Xr.exports;
}
var $6 = /* @__PURE__ */ pi();
const p6 = /* @__PURE__ */ j($6);
var vi = "isHSL";
function hi(e) {
  return typeof e == "string" && p6(e);
}
function v6(e) {
  return C({
    name: vi,
    validator: {
      validate: function(t, r) {
        return hi(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a HSL color";
      }, e)
    }
  }, e);
}
var te = {}, la;
function mi() {
  if (la) return te;
  la = 1, Object.defineProperty(te, "__esModule", {
    value: !0
  }), te.default = o, te.locales = void 0;
  var e = t(/* @__PURE__ */ L());
  function t(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var r = {
    AD: /^(AD[0-9]{2})\d{8}[A-Z0-9]{12}$/,
    AE: /^(AE[0-9]{2})\d{3}\d{16}$/,
    AL: /^(AL[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    AT: /^(AT[0-9]{2})\d{16}$/,
    AZ: /^(AZ[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    BA: /^(BA[0-9]{2})\d{16}$/,
    BE: /^(BE[0-9]{2})\d{12}$/,
    BG: /^(BG[0-9]{2})[A-Z]{4}\d{6}[A-Z0-9]{8}$/,
    BH: /^(BH[0-9]{2})[A-Z]{4}[A-Z0-9]{14}$/,
    BR: /^(BR[0-9]{2})\d{23}[A-Z]{1}[A-Z0-9]{1}$/,
    BY: /^(BY[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    CH: /^(CH[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    CR: /^(CR[0-9]{2})\d{18}$/,
    CY: /^(CY[0-9]{2})\d{8}[A-Z0-9]{16}$/,
    CZ: /^(CZ[0-9]{2})\d{20}$/,
    DE: /^(DE[0-9]{2})\d{18}$/,
    DK: /^(DK[0-9]{2})\d{14}$/,
    DO: /^(DO[0-9]{2})[A-Z]{4}\d{20}$/,
    DZ: /^(DZ\d{24})$/,
    EE: /^(EE[0-9]{2})\d{16}$/,
    EG: /^(EG[0-9]{2})\d{25}$/,
    ES: /^(ES[0-9]{2})\d{20}$/,
    FI: /^(FI[0-9]{2})\d{14}$/,
    FO: /^(FO[0-9]{2})\d{14}$/,
    FR: /^(FR[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    GB: /^(GB[0-9]{2})[A-Z]{4}\d{14}$/,
    GE: /^(GE[0-9]{2})[A-Z0-9]{2}\d{16}$/,
    GI: /^(GI[0-9]{2})[A-Z]{4}[A-Z0-9]{15}$/,
    GL: /^(GL[0-9]{2})\d{14}$/,
    GR: /^(GR[0-9]{2})\d{7}[A-Z0-9]{16}$/,
    GT: /^(GT[0-9]{2})[A-Z0-9]{4}[A-Z0-9]{20}$/,
    HR: /^(HR[0-9]{2})\d{17}$/,
    HU: /^(HU[0-9]{2})\d{24}$/,
    IE: /^(IE[0-9]{2})[A-Z]{4}\d{14}$/,
    IL: /^(IL[0-9]{2})\d{19}$/,
    IQ: /^(IQ[0-9]{2})[A-Z]{4}\d{15}$/,
    IR: /^(IR[0-9]{2})0\d{2}0\d{18}$/,
    IS: /^(IS[0-9]{2})\d{22}$/,
    IT: /^(IT[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    JO: /^(JO[0-9]{2})[A-Z]{4}\d{22}$/,
    KW: /^(KW[0-9]{2})[A-Z]{4}[A-Z0-9]{22}$/,
    KZ: /^(KZ[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LB: /^(LB[0-9]{2})\d{4}[A-Z0-9]{20}$/,
    LC: /^(LC[0-9]{2})[A-Z]{4}[A-Z0-9]{24}$/,
    LI: /^(LI[0-9]{2})\d{5}[A-Z0-9]{12}$/,
    LT: /^(LT[0-9]{2})\d{16}$/,
    LU: /^(LU[0-9]{2})\d{3}[A-Z0-9]{13}$/,
    LV: /^(LV[0-9]{2})[A-Z]{4}[A-Z0-9]{13}$/,
    MA: /^(MA[0-9]{26})$/,
    MC: /^(MC[0-9]{2})\d{10}[A-Z0-9]{11}\d{2}$/,
    MD: /^(MD[0-9]{2})[A-Z0-9]{20}$/,
    ME: /^(ME[0-9]{2})\d{18}$/,
    MK: /^(MK[0-9]{2})\d{3}[A-Z0-9]{10}\d{2}$/,
    MR: /^(MR[0-9]{2})\d{23}$/,
    MT: /^(MT[0-9]{2})[A-Z]{4}\d{5}[A-Z0-9]{18}$/,
    MU: /^(MU[0-9]{2})[A-Z]{4}\d{19}[A-Z]{3}$/,
    MZ: /^(MZ[0-9]{2})\d{21}$/,
    NL: /^(NL[0-9]{2})[A-Z]{4}\d{10}$/,
    NO: /^(NO[0-9]{2})\d{11}$/,
    PK: /^(PK[0-9]{2})[A-Z0-9]{4}\d{16}$/,
    PL: /^(PL[0-9]{2})\d{24}$/,
    PS: /^(PS[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    PT: /^(PT[0-9]{2})\d{21}$/,
    QA: /^(QA[0-9]{2})[A-Z]{4}[A-Z0-9]{21}$/,
    RO: /^(RO[0-9]{2})[A-Z]{4}[A-Z0-9]{16}$/,
    RS: /^(RS[0-9]{2})\d{18}$/,
    SA: /^(SA[0-9]{2})\d{2}[A-Z0-9]{18}$/,
    SC: /^(SC[0-9]{2})[A-Z]{4}\d{20}[A-Z]{3}$/,
    SE: /^(SE[0-9]{2})\d{20}$/,
    SI: /^(SI[0-9]{2})\d{15}$/,
    SK: /^(SK[0-9]{2})\d{20}$/,
    SM: /^(SM[0-9]{2})[A-Z]{1}\d{10}[A-Z0-9]{12}$/,
    SV: /^(SV[0-9]{2})[A-Z0-9]{4}\d{20}$/,
    TL: /^(TL[0-9]{2})\d{19}$/,
    TN: /^(TN[0-9]{2})\d{20}$/,
    TR: /^(TR[0-9]{2})\d{5}[A-Z0-9]{17}$/,
    UA: /^(UA[0-9]{2})\d{6}[A-Z0-9]{19}$/,
    VA: /^(VA[0-9]{2})\d{18}$/,
    VG: /^(VG[0-9]{2})[A-Z]{4}\d{16}$/,
    XK: /^(XK[0-9]{2})\d{16}$/
  };
  function n(u) {
    var i = u.filter(function(s) {
      return !(s in r);
    });
    return !(i.length > 0);
  }
  function d(u, i) {
    var s = u.replace(/[\s\-]+/gi, "").toUpperCase(), c = s.slice(0, 2).toUpperCase(), l = c in r;
    if (i.whitelist) {
      if (!n(i.whitelist))
        return !1;
      var $ = i.whitelist.includes(c);
      if (!$)
        return !1;
    }
    if (i.blacklist) {
      var b = i.blacklist.includes(c);
      if (b)
        return !1;
    }
    return l && r[c].test(s);
  }
  function a(u) {
    var i = u.replace(/[^A-Z0-9]+/gi, "").toUpperCase(), s = i.slice(4) + i.slice(0, 4), c = s.replace(/[A-Z]/g, function($) {
      return $.charCodeAt(0) - 55;
    }), l = c.match(/\d{1,7}/g).reduce(function($, b) {
      return Number($ + b) % 97;
    }, "");
    return l === 1;
  }
  function o(u) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return (0, e.default)(u), d(u, i) && a(u);
  }
  return te.locales = Object.keys(r), te;
}
var h6 = /* @__PURE__ */ mi();
const m6 = /* @__PURE__ */ j(h6);
var gi = "isIBAN";
function yi(e) {
  return typeof e == "string" && m6(e);
}
function g6(e) {
  return C({
    name: gi,
    validator: {
      validate: function(t, r) {
        return yi(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an IBAN";
      }, e)
    }
  }, e);
}
var Qr = { exports: {} }, ca;
function bi() {
  return ca || (ca = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ an());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = {
      PL: function(u) {
        (0, r.default)(u);
        var i = {
          1: 1,
          2: 3,
          3: 7,
          4: 9,
          5: 1,
          6: 3,
          7: 7,
          8: 9,
          9: 1,
          10: 3,
          11: 0
        };
        if (u != null && u.length === 11 && (0, n.default)(u, {
          allow_leading_zeroes: !0
        })) {
          var s = u.split("").slice(0, -1), c = s.reduce(function(b, m, f) {
            return b + Number(m) * i[f + 1];
          }, 0), l = c % 10, $ = Number(u.charAt(u.length - 1));
          if (l === 0 && $ === 0 || $ === 10 - l)
            return !0;
        }
        return !1;
      },
      ES: function(u) {
        (0, r.default)(u);
        var i = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/, s = {
          X: 0,
          Y: 1,
          Z: 2
        }, c = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"], l = u.trim().toUpperCase();
        if (!i.test(l))
          return !1;
        var $ = l.slice(0, -1).replace(/[X,Y,Z]/g, function(b) {
          return s[b];
        });
        return l.endsWith(c[$ % 23]);
      },
      FI: function(u) {
        if ((0, r.default)(u), u.length !== 11 || !u.match(/^\d{6}[\-A\+]\d{3}[0-9ABCDEFHJKLMNPRSTUVWXY]{1}$/))
          return !1;
        var i = "0123456789ABCDEFHJKLMNPRSTUVWXY", s = parseInt(u.slice(0, 6), 10) * 1e3 + parseInt(u.slice(7, 10), 10), c = s % 31, l = i[c];
        return l === u.slice(10, 11);
      },
      IN: function(u) {
        var i = /^[1-9]\d{3}\s?\d{4}\s?\d{4}$/, s = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], c = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], l = u.trim();
        if (!i.test(l))
          return !1;
        var $ = 0, b = l.replace(/\s/g, "").split("").map(Number).reverse();
        return b.forEach(function(m, f) {
          $ = s[$][c[f % 8][m]];
        }), $ === 0;
      },
      IR: function(u) {
        if (!u.match(/^\d{10}$/) || (u = "0000".concat(u).slice(u.length - 6), parseInt(u.slice(3, 9), 10) === 0)) return !1;
        for (var i = parseInt(u.slice(9, 10), 10), s = 0, c = 0; c < 9; c++)
          s += parseInt(u.slice(c, c + 1), 10) * (10 - c);
        return s %= 11, s < 2 && i === s || s >= 2 && i === 11 - s;
      },
      IT: function(u) {
        return u.length !== 9 || u === "CA00000AA" ? !1 : u.search(/C[A-Z]\d{5}[A-Z]{2}/i) > -1;
      },
      NO: function(u) {
        var i = u.trim();
        if (isNaN(Number(i)) || i.length !== 11 || i === "00000000000") return !1;
        var s = i.split("").map(Number), c = (11 - (3 * s[0] + 7 * s[1] + 6 * s[2] + 1 * s[3] + 8 * s[4] + 9 * s[5] + 4 * s[6] + 5 * s[7] + 2 * s[8]) % 11) % 11, l = (11 - (5 * s[0] + 4 * s[1] + 3 * s[2] + 2 * s[3] + 7 * s[4] + 6 * s[5] + 5 * s[6] + 4 * s[7] + 3 * s[8] + 2 * c) % 11) % 11;
        return !(c !== s[9] || l !== s[10]);
      },
      TH: function(u) {
        if (!u.match(/^[1-8]\d{12}$/)) return !1;
        for (var i = 0, s = 0; s < 12; s++)
          i += parseInt(u[s], 10) * (13 - s);
        return u[12] === ((11 - i % 11) % 10).toString();
      },
      LK: function(u) {
        var i = /^[1-9]\d{8}[vx]$/i, s = /^[1-9]\d{11}$/i;
        return u.length === 10 && i.test(u) ? !0 : !!(u.length === 12 && s.test(u));
      },
      "he-IL": function(u) {
        var i = /^\d{9}$/, s = u.trim();
        if (!i.test(s))
          return !1;
        for (var c = s, l = 0, $, b = 0; b < c.length; b++)
          $ = Number(c[b]) * (b % 2 + 1), l += $ > 9 ? $ - 9 : $;
        return l % 10 === 0;
      },
      "ar-LY": function(u) {
        var i = /^(1|2)\d{11}$/, s = u.trim();
        return !!i.test(s);
      },
      "ar-TN": function(u) {
        var i = /^\d{8}$/, s = u.trim();
        return !!i.test(s);
      },
      "zh-CN": function(u) {
        var i = [
          "11",
          // 北京
          "12",
          // 天津
          "13",
          // 河北
          "14",
          // 山西
          "15",
          // 内蒙古
          "21",
          // 辽宁
          "22",
          // 吉林
          "23",
          // 黑龙江
          "31",
          // 上海
          "32",
          // 江苏
          "33",
          // 浙江
          "34",
          // 安徽
          "35",
          // 福建
          "36",
          // 江西
          "37",
          // 山东
          "41",
          // 河南
          "42",
          // 湖北
          "43",
          // 湖南
          "44",
          // 广东
          "45",
          // 广西
          "46",
          // 海南
          "50",
          // 重庆
          "51",
          // 四川
          "52",
          // 贵州
          "53",
          // 云南
          "54",
          // 西藏
          "61",
          // 陕西
          "62",
          // 甘肃
          "63",
          // 青海
          "64",
          // 宁夏
          "65",
          // 新疆
          "71",
          // 台湾
          "81",
          // 香港
          "82",
          // 澳门
          "91"
          // 国外
        ], s = ["7", "9", "10", "5", "8", "4", "2", "1", "6", "3", "7", "9", "10", "5", "8", "4", "2"], c = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"], l = function(_) {
          return i.includes(_);
        }, $ = function(_) {
          var O = parseInt(_.substring(0, 4), 10), y = parseInt(_.substring(4, 6), 10), M = parseInt(_.substring(6), 10), N = new Date(O, y - 1, M);
          return N > /* @__PURE__ */ new Date() ? !1 : N.getFullYear() === O && N.getMonth() === y - 1 && N.getDate() === M;
        }, b = function(_) {
          for (var O = _.substring(0, 17), y = 0, M = 0; M < 17; M++)
            y += parseInt(O.charAt(M), 10) * parseInt(s[M], 10);
          var N = y % 11;
          return c[N];
        }, m = function(_) {
          return b(_) === _.charAt(17).toUpperCase();
        }, f = function(_) {
          var O = /^[1-9]\d{7}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}$/.test(_);
          if (!O) return !1;
          var y = _.substring(0, 2);
          if (O = l(y), !O) return !1;
          var M = "19".concat(_.substring(6, 12));
          return O = $(M), !!O;
        }, v = function(_) {
          var O = /^[1-9]\d{5}[1-9]\d{3}((0[1-9])|(1[0-2]))((0[1-9])|([1-2][0-9])|(3[0-1]))\d{3}(\d|x|X)$/.test(_);
          if (!O) return !1;
          var y = _.substring(0, 2);
          if (O = l(y), !O) return !1;
          var M = _.substring(6, 14);
          return O = $(M), O ? m(_) : !1;
        }, h = function(_) {
          var O = /^\d{15}|(\d{17}(\d|x|X))$/.test(_);
          return O ? _.length === 15 ? f(_) : v(_) : !1;
        };
        return h(u);
      },
      "zh-HK": function(u) {
        u = u.trim();
        var i = /^[A-Z]{1,2}[0-9]{6}((\([0-9A]\))|(\[[0-9A]\])|([0-9A]))$/, s = /^[0-9]$/;
        if (u = u.toUpperCase(), !i.test(u)) return !1;
        u = u.replace(/\[|\]|\(|\)/g, ""), u.length === 8 && (u = "3".concat(u));
        for (var c = 0, l = 0; l <= 7; l++) {
          var $ = void 0;
          s.test(u[l]) ? $ = u[l] : $ = (u[l].charCodeAt(0) - 55) % 11, c += $ * (9 - l);
        }
        c %= 11;
        var b;
        return c === 0 ? b = "0" : c === 1 ? b = "A" : b = String(11 - c), b === u[u.length - 1];
      },
      "zh-TW": function(u) {
        var i = {
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          G: 16,
          H: 17,
          I: 34,
          J: 18,
          K: 19,
          L: 20,
          M: 21,
          N: 22,
          O: 35,
          P: 23,
          Q: 24,
          R: 25,
          S: 26,
          T: 27,
          U: 28,
          V: 29,
          W: 32,
          X: 30,
          Y: 31,
          Z: 33
        }, s = u.trim().toUpperCase();
        return /^[A-Z][0-9]{9}$/.test(s) ? Array.from(s).reduce(function(c, l, $) {
          if ($ === 0) {
            var b = i[l];
            return b % 10 * 9 + Math.floor(b / 10);
          }
          return $ === 9 ? (10 - c % 10 - Number(l)) % 10 === 0 : c + Number(l) * (9 - $);
        }, 0) : !1;
      },
      PK: function(u) {
        var i = /^[1-7][0-9]{4}-[0-9]{7}-[1-9]$/, s = u.trim();
        return i.test(s);
      }
    };
    function o(u, i) {
      if ((0, r.default)(u), i in a)
        return a[i](u);
      if (i === "any") {
        for (var s in a)
          if (a.hasOwnProperty(s)) {
            var c = a[s];
            if (c(u))
              return !0;
          }
        return !1;
      }
      throw new Error("Invalid locale '".concat(i, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Qr, Qr.exports)), Qr.exports;
}
var y6 = /* @__PURE__ */ bi();
const b6 = /* @__PURE__ */ j(y6);
var Ai = "isIdentityCard";
function _i(e, t) {
  return typeof e == "string" && b6(e, t);
}
function A6(e, t) {
  return C({
    name: Ai,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return _i(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a identity card number";
      }, t)
    }
  }, t);
}
var Jr = { exports: {} }, fa;
function Mi() {
  return fa || (fa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Jr, Jr.exports)), Jr.exports;
}
var _6 = /* @__PURE__ */ Mi();
const M6 = /* @__PURE__ */ j(_6);
var Si = "isISRC";
function Ii(e) {
  return typeof e == "string" && M6(e);
}
function S6(e) {
  return C({
    name: Si,
    validator: {
      validate: function(t, r) {
        return Ii(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an ISRC";
      }, e)
    }
  }, e);
}
var qr = { exports: {} }, $a;
function Oi() {
  return $a || ($a = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = _;
    var r = n(/* @__PURE__ */ L());
    function n(O) {
      return O && O.__esModule ? O : { default: O };
    }
    var d = "([A-Za-z]{3}(-[A-Za-z]{3}){0,2})", a = "(([a-zA-Z]{2,3}(-".concat(d, ")?)|([a-zA-Z]{5,8}))"), o = "([A-Za-z]{4})", u = "([A-Za-z]{2}|\\d{3})", i = "([A-Za-z0-9]{5,8}|(\\d[A-Z-a-z0-9]{3}))", s = "(\\d|[A-W]|[Y-Z]|[a-w]|[y-z])", c = "(".concat(s, "(-[A-Za-z0-9]{2,8})+)"), l = "(x(-[A-Za-z0-9]{1,8})+)", $ = "((en-GB-oed)|(i-ami)|(i-bnn)|(i-default)|(i-enochian)|(i-hak)|(i-klingon)|(i-lux)|(i-mingo)|(i-navajo)|(i-pwn)|(i-tao)|(i-tay)|(i-tsu)|(sgn-BE-FR)|(sgn-BE-NL)|(sgn-CH-DE))", b = "((art-lojban)|(cel-gaulish)|(no-bok)|(no-nyn)|(zh-guoyu)|(zh-hakka)|(zh-min)|(zh-min-nan)|(zh-xiang))", m = "(".concat($, "|").concat(b, ")"), f = "(-|_)", v = "".concat(a, "(").concat(f).concat(o, ")?(").concat(f).concat(u, ")?(").concat(f).concat(i, ")*(").concat(f).concat(c, ")*(").concat(f).concat(l, ")?"), h = new RegExp("(^".concat(l, "$)|(^").concat(m, "$)|(^").concat(v, "$)"));
    function _(O) {
      return (0, r.default)(O), h.test(O);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(qr, qr.exports)), qr.exports;
}
var I6 = /* @__PURE__ */ Oi();
const O6 = /* @__PURE__ */ j(I6);
var xi = "isLocale";
function Ei(e) {
  return typeof e == "string" && O6(e);
}
function x6(e) {
  return C({
    name: xi,
    validator: {
      validate: function(t, r) {
        return Ei(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be locale";
      }, e)
    }
  }, e);
}
var t0 = { exports: {} }, pa;
function Ci() {
  return pa || (pa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /(?:^magnet:\?|[^?&]&)xt(?:\.1)?=urn:(?:(?:aich|bitprint|btih|ed2k|ed2khash|kzhash|md5|sha1|tree:tiger):[a-z0-9]{32}(?:[a-z0-9]{8})?|btmh:1220[a-z0-9]{64})(?:$|&)/i;
    function a(o) {
      return (0, r.default)(o), o.indexOf("magnet:?") !== 0 ? !1 : d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(t0, t0.exports)), t0.exports;
}
var E6 = /* @__PURE__ */ Ci();
const C6 = /* @__PURE__ */ j(E6);
var Ni = "isMagnetURI";
function Pi(e) {
  return typeof e == "string" && C6(e);
}
function N6(e) {
  return C({
    name: Ni,
    validator: {
      validate: function(t, r) {
        return Pi(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be magnet uri format";
      }, e)
    }
  }, e);
}
var e0 = { exports: {} }, va;
function Li() {
  return va || (va = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var r = n(/* @__PURE__ */ L());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    var d = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+_]{1,100}$/i, a = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i, o = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i;
    function u(i) {
      return (0, r.default)(i), d.test(i) || a.test(i) || o.test(i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(e0, e0.exports)), e0.exports;
}
var P6 = /* @__PURE__ */ Li();
const L6 = /* @__PURE__ */ j(P6);
var Ti = "isMimeType";
function wi(e) {
  return typeof e == "string" && L6(e);
}
function T6(e) {
  return C({
    name: Ti,
    validator: {
      validate: function(t, r) {
        return wi(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be MIME type format";
      }, e)
    }
  }, e);
}
var r0 = { exports: {} }, ha;
function Ri() {
  return ha || (ha = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^(0o)?[0-7]+$/i;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(r0, r0.exports)), r0.exports;
}
var w6 = /* @__PURE__ */ Ri();
const R6 = /* @__PURE__ */ j(w6);
var Di = "isOctal";
function Bi(e) {
  return typeof e == "string" && R6(e);
}
function D6(e) {
  return C({
    name: Di,
    validator: {
      validate: function(t, r) {
        return Bi(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be valid octal number";
      }, e)
    }
  }, e);
}
var ee = {}, ma;
function ji() {
  if (ma) return ee;
  ma = 1, Object.defineProperty(ee, "__esModule", {
    value: !0
  }), ee.default = n, ee.locales = void 0;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = {
    AM: /^[A-Z]{2}\d{7}$/,
    // ARMENIA
    AR: /^[A-Z]{3}\d{6}$/,
    // ARGENTINA
    AT: /^[A-Z]\d{7}$/,
    // AUSTRIA
    AU: /^[A-Z]\d{7}$/,
    // AUSTRALIA
    AZ: /^[A-Z]{1}\d{8}$/,
    // AZERBAIJAN
    BE: /^[A-Z]{2}\d{6}$/,
    // BELGIUM
    BG: /^\d{9}$/,
    // BULGARIA
    BR: /^[A-Z]{2}\d{6}$/,
    // BRAZIL
    BY: /^[A-Z]{2}\d{7}$/,
    // BELARUS
    CA: /^[A-Z]{2}\d{6}$/,
    // CANADA
    CH: /^[A-Z]\d{7}$/,
    // SWITZERLAND
    CN: /^G\d{8}$|^E(?![IO])[A-Z0-9]\d{7}$/,
    // CHINA [G=Ordinary, E=Electronic] followed by 8-digits, or E followed by any UPPERCASE letter (except I and O) followed by 7 digits
    CY: /^[A-Z](\d{6}|\d{8})$/,
    // CYPRUS
    CZ: /^\d{8}$/,
    // CZECH REPUBLIC
    DE: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/,
    // GERMANY
    DK: /^\d{9}$/,
    // DENMARK
    DZ: /^\d{9}$/,
    // ALGERIA
    EE: /^([A-Z]\d{7}|[A-Z]{2}\d{7})$/,
    // ESTONIA (K followed by 7-digits), e-passports have 2 UPPERCASE followed by 7 digits
    ES: /^[A-Z0-9]{2}([A-Z0-9]?)\d{6}$/,
    // SPAIN
    FI: /^[A-Z]{2}\d{7}$/,
    // FINLAND
    FR: /^\d{2}[A-Z]{2}\d{5}$/,
    // FRANCE
    GB: /^\d{9}$/,
    // UNITED KINGDOM
    GR: /^[A-Z]{2}\d{7}$/,
    // GREECE
    HR: /^\d{9}$/,
    // CROATIA
    HU: /^[A-Z]{2}(\d{6}|\d{7})$/,
    // HUNGARY
    IE: /^[A-Z0-9]{2}\d{7}$/,
    // IRELAND
    IN: /^[A-Z]{1}-?\d{7}$/,
    // INDIA
    ID: /^[A-C]\d{7}$/,
    // INDONESIA
    IR: /^[A-Z]\d{8}$/,
    // IRAN
    IS: /^(A)\d{7}$/,
    // ICELAND
    IT: /^[A-Z0-9]{2}\d{7}$/,
    // ITALY
    JM: /^[Aa]\d{7}$/,
    // JAMAICA
    JP: /^[A-Z]{2}\d{7}$/,
    // JAPAN
    KR: /^[MS]\d{8}$/,
    // SOUTH KOREA, REPUBLIC OF KOREA, [S=PS Passports, M=PM Passports]
    KZ: /^[a-zA-Z]\d{7}$/,
    // KAZAKHSTAN
    LI: /^[a-zA-Z]\d{5}$/,
    // LIECHTENSTEIN
    LT: /^[A-Z0-9]{8}$/,
    // LITHUANIA
    LU: /^[A-Z0-9]{8}$/,
    // LUXEMBURG
    LV: /^[A-Z0-9]{2}\d{7}$/,
    // LATVIA
    LY: /^[A-Z0-9]{8}$/,
    // LIBYA
    MT: /^\d{7}$/,
    // MALTA
    MZ: /^([A-Z]{2}\d{7})|(\d{2}[A-Z]{2}\d{5})$/,
    // MOZAMBIQUE
    MY: /^[AHK]\d{8}$/,
    // MALAYSIA
    MX: /^\d{10,11}$/,
    // MEXICO
    NL: /^[A-Z]{2}[A-Z0-9]{6}\d$/,
    // NETHERLANDS
    NZ: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])\d{6}$/,
    // NEW ZEALAND
    PH: /^([A-Z](\d{6}|\d{7}[A-Z]))|([A-Z]{2}(\d{6}|\d{7}))$/,
    // PHILIPPINES
    PK: /^[A-Z]{2}\d{7}$/,
    // PAKISTAN
    PL: /^[A-Z]{2}\d{7}$/,
    // POLAND
    PT: /^[A-Z]\d{6}$/,
    // PORTUGAL
    RO: /^\d{8,9}$/,
    // ROMANIA
    RU: /^\d{9}$/,
    // RUSSIAN FEDERATION
    SE: /^\d{8}$/,
    // SWEDEN
    SL: /^(P)[A-Z]\d{7}$/,
    // SLOVENIA
    SK: /^[0-9A-Z]\d{7}$/,
    // SLOVAKIA
    TH: /^[A-Z]{1,2}\d{6,7}$/,
    // THAILAND
    TR: /^[A-Z]\d{8}$/,
    // TURKEY
    UA: /^[A-Z]{2}\d{6}$/,
    // UKRAINE
    US: /^\d{9}$/,
    // UNITED STATES
    ZA: /^[TAMD]\d{8}$/
    // SOUTH AFRICA
  };
  ee.locales = Object.keys(r);
  function n(d, a) {
    (0, e.default)(d);
    var o = d.replace(/\s/g, "").toUpperCase();
    return a.toUpperCase() in r && r[a].test(o);
  }
  return ee;
}
var B6 = /* @__PURE__ */ ji();
const j6 = /* @__PURE__ */ j(B6);
var Fi = "isPassportNumber";
function Zi(e, t) {
  return typeof e == "string" && j6(e, t);
}
function F6(e, t) {
  return C({
    name: Fi,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Zi(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be valid passport number";
      }, t)
    }
  }, t);
}
var re = {}, ga;
function Ui() {
  if (ga) return re;
  ga = 1, Object.defineProperty(re, "__esModule", {
    value: !0
  }), re.default = u, re.locales = void 0;
  var e = t(/* @__PURE__ */ L());
  function t(i) {
    return i && i.__esModule ? i : { default: i };
  }
  var r = /^\d{3}$/, n = /^\d{4}$/, d = /^\d{5}$/, a = /^\d{6}$/, o = {
    AD: /^AD\d{3}$/,
    AT: n,
    AU: n,
    AZ: /^AZ\d{4}$/,
    BA: /^([7-8]\d{4}$)/,
    BE: n,
    BG: n,
    BR: /^\d{5}-?\d{3}$/,
    BY: /^2[1-4]\d{4}$/,
    CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
    CH: n,
    CN: /^(0[1-7]|1[012356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[1-5]|8[1345]|9[09])\d{4}$/,
    CO: /^(05|08|11|13|15|17|18|19|20|23|25|27|41|44|47|50|52|54|63|66|68|70|73|76|81|85|86|88|91|94|95|97|99)(\d{4})$/,
    CZ: /^\d{3}\s?\d{2}$/,
    DE: d,
    DK: n,
    DO: d,
    DZ: d,
    EE: d,
    ES: /^(5[0-2]{1}|[0-4]{1}\d{1})\d{3}$/,
    FI: d,
    FR: /^\d{2}\s?\d{3}$/,
    GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
    GR: /^\d{3}\s?\d{2}$/,
    HR: /^([1-5]\d{4}$)/,
    HT: /^HT\d{4}$/,
    HU: n,
    ID: d,
    IE: /^(?!.*(?:o))[A-Za-z]\d[\dw]\s\w{4}$/i,
    IL: /^(\d{5}|\d{7})$/,
    IN: /^((?!10|29|35|54|55|65|66|86|87|88|89)[1-9][0-9]{5})$/,
    IR: /^(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}$/,
    IS: r,
    IT: d,
    JP: /^\d{3}\-\d{4}$/,
    KE: d,
    KR: /^(\d{5}|\d{6})$/,
    LI: /^(948[5-9]|949[0-7])$/,
    LT: /^LT\-\d{5}$/,
    LU: n,
    LV: /^LV\-\d{4}$/,
    LK: d,
    MG: r,
    MX: d,
    MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/,
    MY: d,
    NL: /^[1-9]\d{3}\s?(?!sa|sd|ss)[a-z]{2}$/i,
    NO: n,
    NP: /^(10|21|22|32|33|34|44|45|56|57)\d{3}$|^(977)$/i,
    NZ: n,
    PL: /^\d{2}\-\d{3}$/,
    PR: /^00[679]\d{2}([ -]\d{4})?$/,
    PT: /^\d{4}\-\d{3}?$/,
    RO: a,
    RU: a,
    SA: d,
    SE: /^[1-9]\d{2}\s?\d{2}$/,
    SG: a,
    SI: n,
    SK: /^\d{3}\s?\d{2}$/,
    TH: d,
    TN: n,
    TW: /^\d{3}(\d{2})?$/,
    UA: d,
    US: /^\d{5}(-\d{4})?$/,
    ZA: n,
    ZM: d
  };
  re.locales = Object.keys(o);
  function u(i, s) {
    if ((0, e.default)(i), s in o)
      return o[s].test(i);
    if (s === "any") {
      for (var c in o)
        if (o.hasOwnProperty(c)) {
          var l = o[c];
          if (l.test(i))
            return !0;
        }
      return !1;
    }
    throw new Error("Invalid locale '".concat(s, "'"));
  }
  return re;
}
var Z6 = /* @__PURE__ */ Ui();
const U6 = /* @__PURE__ */ j(Z6);
var Gi = "isPostalCode";
function ki(e, t) {
  return typeof e == "string" && U6(e, t);
}
function G6(e, t) {
  return C({
    name: Gi,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ki(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a postal code";
      }, t)
    }
  }, t);
}
var n0 = { exports: {} }, ya;
function Hi() {
  return ya || (ya = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = h;
    var r = n(/* @__PURE__ */ L());
    function n(_) {
      return _ && _.__esModule ? _ : { default: _ };
    }
    var d = /[0-9]{4}/, a = /(0[1-9]|1[0-2])/, o = /([12]\d|0[1-9]|3[01])/, u = /([01][0-9]|2[0-3])/, i = /[0-5][0-9]/, s = /([0-5][0-9]|60)/, c = /(\.[0-9]+)?/, l = new RegExp("[-+]".concat(u.source, ":").concat(i.source)), $ = new RegExp("([zZ]|".concat(l.source, ")")), b = new RegExp("".concat(u.source, ":").concat(i.source, ":").concat(s.source).concat(c.source)), m = new RegExp("".concat(d.source, "-").concat(a.source, "-").concat(o.source)), f = new RegExp("".concat(b.source).concat($.source)), v = new RegExp("^".concat(m.source, "[ tT]").concat(f.source, "$"));
    function h(_) {
      return (0, r.default)(_), v.test(_);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(n0, n0.exports)), n0.exports;
}
var k6 = /* @__PURE__ */ Hi();
const H6 = /* @__PURE__ */ j(k6);
var Vi = "isRFC3339";
function Ki(e) {
  return typeof e == "string" && H6(e);
}
function V6(e) {
  return C({
    name: Vi,
    validator: {
      validate: function(t, r) {
        return Ki(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be RFC 3339 date";
      }, e)
    }
  }, e);
}
var d0 = { exports: {} }, ba;
function Wi() {
  return ba || (ba = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ L());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function d(l) {
      "@babel/helpers - typeof";
      return d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function($) {
        return typeof $;
      } : function($) {
        return $ && typeof Symbol == "function" && $.constructor === Symbol && $ !== Symbol.prototype ? "symbol" : typeof $;
      }, d(l);
    }
    var a = /^rgb\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){2}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\)$/, o = /^rgba\((([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5]),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, u = /^rgb\((([0-9]%|[1-9][0-9]%|100%),){2}([0-9]%|[1-9][0-9]%|100%)\)$/, i = /^rgba\((([0-9]%|[1-9][0-9]%|100%),){3}(0?\.\d|1(\.0)?|0(\.0)?)\)$/, s = /^rgba?/;
    function c(l, $) {
      (0, r.default)(l);
      var b = !1, m = !0;
      if (d($) !== "object" ? arguments.length >= 2 && (m = arguments[1]) : (b = $.allowSpaces !== void 0 ? $.allowSpaces : b, m = $.includePercentValues !== void 0 ? $.includePercentValues : m), b) {
        if (!s.test(l))
          return !1;
        l = l.replace(/\s/g, "");
      }
      return m ? a.test(l) || o.test(l) || u.test(l) || i.test(l) : a.test(l) || o.test(l);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(d0, d0.exports)), d0.exports;
}
var K6 = /* @__PURE__ */ Wi();
const W6 = /* @__PURE__ */ j(K6);
var Yi = "isRgbColor";
function zi(e, t) {
  return typeof e == "string" && W6(e, t);
}
function Y6(e, t) {
  return C({
    name: Yi,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return zi(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be RGB color";
      }, t)
    }
  }, t);
}
var a0 = { exports: {} }, o0 = { exports: {} }, Aa;
function z6() {
  return Aa || (Aa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    function r(n, d) {
      var a = n.join("");
      return new RegExp(a, d);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(o0, o0.exports)), o0.exports;
}
var _a;
function Xi() {
  return _a || (_a = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ z6());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = (0, n.default)(["^(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)", "(?:-((?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*)(?:\\.(?:0|[1-9]\\d*|\\d*[a-z-][0-9a-z-]*))*))", "?(?:\\+([0-9a-z-]+(?:\\.[0-9a-z-]+)*))?$"], "i");
    function o(u) {
      return (0, r.default)(u), a.test(u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(a0, a0.exports)), a0.exports;
}
var X6 = /* @__PURE__ */ Xi();
const Q6 = /* @__PURE__ */ j(X6);
var Qi = "isSemVer";
function Ji(e) {
  return typeof e == "string" && Q6(e);
}
function J6(e) {
  return C({
    name: Qi,
    validator: {
      validate: function(t, r) {
        return Ji(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a Semantic Versioning Specification";
      }, e)
    }
  }, e);
}
var u0 = { exports: {} }, i0 = { exports: {} }, Ma;
function vn() {
  return Ma || (Ma = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a = Date.parse(a), isNaN(a) ? null : new Date(a);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(i0, i0.exports)), i0.exports;
}
var s0 = { exports: {} }, Sa;
function q6() {
  return Sa || (Sa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      return (0, r.default)(a), parseInt(a, o || 10);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(s0, s0.exports)), s0.exports;
}
var l0 = { exports: {} }, Ia;
function tf() {
  return Ia || (Ia = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      return (0, r.default)(a), o ? a === "1" || /^true$/i.test(a) : a !== "0" && !/^false$/i.test(a) && a !== "";
    }
    e.exports = t.default, e.exports.default = t.default;
  }(l0, l0.exports)), l0.exports;
}
var c0 = { exports: {} }, Oa;
function ef() {
  return Oa || (Oa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      return (0, r.default)(a), a === o;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(c0, c0.exports)), c0.exports;
}
var f0 = { exports: {} }, xa;
function rf() {
  return xa || (xa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ Ie());
    function d(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var a = /^\d{1,3}$/, o = 32, u = 128;
    function i(s) {
      var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      (0, r.default)(s);
      var l = s.split("/");
      if (l.length !== 2 || !a.test(l[1]) || l[1].length > 1 && l[1].startsWith("0"))
        return !1;
      var $ = (0, n.default)(l[0], c);
      if (!$)
        return !1;
      var b = null;
      switch (String(c)) {
        case "4":
          b = o;
          break;
        case "6":
          b = u;
          break;
        default:
          b = (0, n.default)(l[0], "6") ? u : o;
      }
      return l[1] <= b && l[1] >= 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(f0, f0.exports)), f0.exports;
}
var $0 = { exports: {} }, Ea;
function qi() {
  return Ea || (Ea = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = m;
    var r = n(/* @__PURE__ */ ot());
    function n(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function d(f, v) {
      return u(f) || o(f, v) || s(f, v) || a();
    }
    function a() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function o(f, v) {
      var h = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (h != null) {
        var _, O, y, M, N = [], D = !0, x = !1;
        try {
          if (y = (h = h.call(f)).next, v !== 0) for (; !(D = (_ = y.call(h)).done) && (N.push(_.value), N.length !== v); D = !0) ;
        } catch (A) {
          x = !0, O = A;
        } finally {
          try {
            if (!D && h.return != null && (M = h.return(), Object(M) !== M)) return;
          } finally {
            if (x) throw O;
          }
        }
        return N;
      }
    }
    function u(f) {
      if (Array.isArray(f)) return f;
    }
    function i(f, v) {
      var h = typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (!h) {
        if (Array.isArray(f) || (h = s(f)) || v) {
          h && (f = h);
          var _ = 0, O = function() {
          };
          return { s: O, n: function() {
            return _ >= f.length ? { done: !0 } : { done: !1, value: f[_++] };
          }, e: function(D) {
            throw D;
          }, f: O };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var y, M = !0, N = !1;
      return { s: function() {
        h = h.call(f);
      }, n: function() {
        var D = h.next();
        return M = D.done, D;
      }, e: function(D) {
        N = !0, y = D;
      }, f: function() {
        try {
          M || h.return == null || h.return();
        } finally {
          if (N) throw y;
        }
      } };
    }
    function s(f, v) {
      if (f) {
        if (typeof f == "string") return c(f, v);
        var h = {}.toString.call(f).slice(8, -1);
        return h === "Object" && f.constructor && (h = f.constructor.name), h === "Map" || h === "Set" ? Array.from(f) : h === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(h) ? c(f, v) : void 0;
      }
    }
    function c(f, v) {
      (v == null || v > f.length) && (v = f.length);
      for (var h = 0, _ = Array(v); h < v; h++) _[h] = f[h];
      return _;
    }
    var l = {
      format: "YYYY/MM/DD",
      delimiters: ["/", "-"],
      strictMode: !1
    };
    function $(f) {
      return /(^(y{4}|y{2})[.\/-](m{1,2})[.\/-](d{1,2})$)|(^(m{1,2})[.\/-](d{1,2})[.\/-]((y{4}|y{2})$))|(^(d{1,2})[.\/-](m{1,2})[.\/-]((y{4}|y{2})$))/gi.test(f);
    }
    function b(f, v) {
      for (var h = [], _ = Math.max(f.length, v.length), O = 0; O < _; O++)
        h.push([f[O], v[O]]);
      return h;
    }
    function m(f, v) {
      if (typeof v == "string" ? v = (0, r.default)({
        format: v
      }, l) : v = (0, r.default)(v, l), typeof f == "string" && $(v.format)) {
        if (v.strictMode && f.length !== v.format.length) return !1;
        var h = v.delimiters.find(function(Y) {
          return v.format.indexOf(Y) !== -1;
        }), _ = v.strictMode ? h : v.delimiters.find(function(Y) {
          return f.indexOf(Y) !== -1;
        }), O = b(f.split(_), v.format.toLowerCase().split(h)), y = {}, M = i(O), N;
        try {
          for (M.s(); !(N = M.n()).done; ) {
            var D = d(N.value, 2), x = D[0], A = D[1];
            if (!x || !A || x.length !== A.length)
              return !1;
            y[A.charAt(0)] = x;
          }
        } catch (Y) {
          M.e(Y);
        } finally {
          M.f();
        }
        var S = y.y;
        if (S.startsWith("-"))
          return !1;
        if (y.y.length === 2) {
          var P = parseInt(y.y, 10);
          if (isNaN(P))
            return !1;
          var Z = (/* @__PURE__ */ new Date()).getFullYear() % 100;
          P < Z ? S = "20".concat(y.y) : S = "19".concat(y.y);
        }
        var G = y.m;
        y.m.length === 1 && (G = "0".concat(y.m));
        var K = y.d;
        return y.d.length === 1 && (K = "0".concat(y.d)), new Date("".concat(S, "-").concat(G, "-").concat(K, "T00:00:00.000Z")).getUTCDate() === +y.d;
      }
      return v.strictMode ? !1 : Object.prototype.toString.call(f) === "[object Date]" && isFinite(f);
    }
    e.exports = t.default, e.exports.default = t.default;
  }($0, $0.exports)), $0.exports;
}
var p0 = { exports: {} }, Ca;
function nf() {
  return Ca || (Ca = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ ot());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = {
      hourFormat: "hour24",
      mode: "default"
    }, a = {
      hour24: {
        default: /^([01]?[0-9]|2[0-3]):([0-5][0-9])$/,
        withSeconds: /^([01]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/
      },
      hour12: {
        default: /^(0?[1-9]|1[0-2]):([0-5][0-9]) (A|P)M$/,
        withSeconds: /^(0?[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9]) (A|P)M$/
      }
    };
    function o(u, i) {
      return i = (0, r.default)(i, d), typeof u != "string" ? !1 : a[i.hourFormat][i.mode].test(u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(p0, p0.exports)), p0.exports;
}
var v0 = { exports: {} }, Na;
function df() {
  return Na || (Na = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^(?!(1[3-9])|(20)|(3[3-9])|(4[0-9])|(5[0-9])|(60)|(7[3-9])|(8[1-9])|(9[0-2])|(9[3-9]))[0-9]{9}$/;
    function a(o) {
      if ((0, r.default)(o), !d.test(o)) return !1;
      for (var u = 0, i = 0; i < o.length; i++)
        i % 3 === 0 ? u += o[i] * 3 : i % 3 === 1 ? u += o[i] * 7 : u += o[i] * 1;
      return u % 10 === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(v0, v0.exports)), v0.exports;
}
var h0 = { exports: {} }, Pa;
function af() {
  return Pa || (Pa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = n(/* @__PURE__ */ L());
    function n(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var d = /^[0-9]{15}$/, a = /^\d{2}-\d{6}-\d{6}-\d{1}$/;
    function o(u, i) {
      (0, r.default)(u), i = i || {};
      var s = d;
      if (i.allow_hyphens && (s = a), !s.test(u))
        return !1;
      u = u.replace(/-/g, "");
      for (var c = 0, l = 2, $ = 14, b = 0; b < $; b++) {
        var m = u.substring($ - b - 1, $ - b), f = parseInt(m, 10) * l;
        f >= 10 ? c += f % 10 + 1 : c += f, l === 1 ? l += 1 : l -= 1;
      }
      var v = (10 - c % 10) % 10;
      return v === parseInt(u.substring(14, 15), 10);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(h0, h0.exports)), h0.exports;
}
var m0 = { exports: {} }, La;
function of() {
  return La || (La = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[a-f0-9]{32}$/;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(m0, m0.exports)), m0.exports;
}
var g0 = { exports: {} }, Ta;
function uf() {
  return Ta || (Ta = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ ot());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = {
      ignore_whitespace: !1
    };
    function o(u, i) {
      return (0, r.default)(u), i = (0, n.default)(i, a), (i.ignore_whitespace ? u.trim().length : u.length) === 0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(g0, g0.exports)), g0.exports;
}
var y0 = { exports: {} }, wa;
function sf() {
  return wa || (wa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), /^[0-7][0-9A-HJKMNP-TV-Z]{25}$/i.test(a);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(y0, y0.exports)), y0.exports;
}
var b0 = { exports: {} }, Ra;
function lf() {
  return Ra || (Ra = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ vn());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      var u = (o == null ? void 0 : o.comparisonDate) || o || Date().toString(), i = (0, r.default)(u), s = (0, r.default)(a);
      return !!(s && i && s > i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(b0, b0.exports)), b0.exports;
}
var A0 = { exports: {} }, Da;
function cf() {
  return Da || (Da = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ vn());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : String(/* @__PURE__ */ new Date());
      (0, r.default)(o);
      var i = (0, n.default)(u), s = (0, n.default)(o);
      return !!(s && i && s < i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(A0, A0.exports)), A0.exports;
}
var _0 = { exports: {} }, Ba;
function ff() {
  return Ba || (Ba = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ Ao());
    function d(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function a(u) {
      "@babel/helpers - typeof";
      return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, a(u);
    }
    function o(u, i) {
      (0, r.default)(u);
      var s;
      if (Object.prototype.toString.call(i) === "[object Array]") {
        var c = [];
        for (s in i)
          ({}).hasOwnProperty.call(i, s) && (c[s] = (0, n.default)(i[s]));
        return c.indexOf(u) >= 0;
      } else {
        if (a(i) === "object")
          return i.hasOwnProperty(u);
        if (i && typeof i.indexOf == "function")
          return i.indexOf(u) >= 0;
      }
      return !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(_0, _0.exports)), _0.exports;
}
var M0 = { exports: {} }, Dt = {}, ja;
function ts() {
  if (ja) return Dt;
  ja = 1, Object.defineProperty(Dt, "__esModule", {
    value: !0
  }), Dt.iso7064Check = e, Dt.luhnCheck = t, Dt.reverseMultiplyAndSum = r, Dt.verhoeffCheck = n;
  function e(d) {
    for (var a = 10, o = 0; o < d.length - 1; o++)
      a = (parseInt(d[o], 10) + a) % 10 === 0 ? 10 * 2 % 11 : (parseInt(d[o], 10) + a) % 10 * 2 % 11;
    return a = a === 1 ? 0 : 11 - a, a === parseInt(d[10], 10);
  }
  function t(d) {
    for (var a = 0, o = !1, u = d.length - 1; u >= 0; u--) {
      if (o) {
        var i = parseInt(d[u], 10) * 2;
        i > 9 ? a += i.toString().split("").map(function(s) {
          return parseInt(s, 10);
        }).reduce(function(s, c) {
          return s + c;
        }, 0) : a += i;
      } else
        a += parseInt(d[u], 10);
      o = !o;
    }
    return a % 10 === 0;
  }
  function r(d, a) {
    for (var o = 0, u = 0; u < d.length; u++)
      o += d[u] * (a - u);
    return o;
  }
  function n(d) {
    for (var a = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 2, 3, 4, 0, 6, 7, 8, 9, 5], [2, 3, 4, 0, 1, 7, 8, 9, 5, 6], [3, 4, 0, 1, 2, 8, 9, 5, 6, 7], [4, 0, 1, 2, 3, 9, 5, 6, 7, 8], [5, 9, 8, 7, 6, 0, 4, 3, 2, 1], [6, 5, 9, 8, 7, 1, 0, 4, 3, 2], [7, 6, 5, 9, 8, 2, 1, 0, 4, 3], [8, 7, 6, 5, 9, 3, 2, 1, 0, 4], [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]], o = [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9], [1, 5, 7, 6, 2, 8, 3, 0, 9, 4], [5, 8, 0, 3, 7, 9, 6, 1, 4, 2], [8, 9, 1, 6, 0, 4, 3, 5, 2, 7], [9, 4, 5, 3, 1, 2, 6, 8, 7, 0], [4, 2, 8, 6, 5, 7, 3, 9, 0, 1], [2, 7, 9, 3, 8, 0, 6, 4, 1, 5], [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]], u = d.split("").reverse().join(""), i = 0, s = 0; s < u.length; s++)
      i = a[i][o[s % 8][parseInt(u[s], 10)]];
    return i === 0;
  }
  return Dt;
}
var Fa;
function es() {
  return Fa || (Fa = 1, function(e, t) {
    function r(p) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(g) {
        return typeof g;
      } : function(g) {
        return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
      }, r(p);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = Ye;
    var n = i(/* @__PURE__ */ L()), d = u(/* @__PURE__ */ ts()), a = i(/* @__PURE__ */ qi());
    function o(p) {
      if (typeof WeakMap != "function") return null;
      var g = /* @__PURE__ */ new WeakMap(), I = /* @__PURE__ */ new WeakMap();
      return (o = function(T) {
        return T ? I : g;
      })(p);
    }
    function u(p, g) {
      if (p && p.__esModule) return p;
      if (p === null || r(p) != "object" && typeof p != "function") return { default: p };
      var I = o(g);
      if (I && I.has(p)) return I.get(p);
      var T = { __proto__: null }, R = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var B in p) if (B !== "default" && {}.hasOwnProperty.call(p, B)) {
        var U = R ? Object.getOwnPropertyDescriptor(p, B) : null;
        U && (U.get || U.set) ? Object.defineProperty(T, B, U) : T[B] = p[B];
      }
      return T.default = p, I && I.set(p, T), T;
    }
    function i(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function s(p) {
      return b(p) || $(p) || l(p) || c();
    }
    function c() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function l(p, g) {
      if (p) {
        if (typeof p == "string") return m(p, g);
        var I = {}.toString.call(p).slice(8, -1);
        return I === "Object" && p.constructor && (I = p.constructor.name), I === "Map" || I === "Set" ? Array.from(p) : I === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(I) ? m(p, g) : void 0;
      }
    }
    function $(p) {
      if (typeof Symbol < "u" && p[Symbol.iterator] != null || p["@@iterator"] != null) return Array.from(p);
    }
    function b(p) {
      if (Array.isArray(p)) return m(p);
    }
    function m(p, g) {
      (g == null || g > p.length) && (g = p.length);
      for (var I = 0, T = Array(g); I < g; I++) T[I] = p[I];
      return T;
    }
    function f(p) {
      var g = p.slice(0, 2), I = parseInt(p.slice(2, 4), 10);
      I > 40 ? (I -= 40, g = "20".concat(g)) : I > 20 ? (I -= 20, g = "18".concat(g)) : g = "19".concat(g), I < 10 && (I = "0".concat(I));
      var T = "".concat(g, "/").concat(I, "/").concat(p.slice(4, 6));
      if (!(0, a.default)(T, "YYYY/MM/DD"))
        return !1;
      for (var R = p.split("").map(function(W) {
        return parseInt(W, 10);
      }), B = [2, 4, 8, 5, 10, 9, 7, 3, 6], U = 0, H = 0; H < B.length; H++)
        U += R[H] * B[H];
      return U = U % 11 === 10 ? 0 : U % 11, U === R[9];
    }
    function v(p) {
      var g = p.split(""), I = g.filter(function(R, B) {
        return B % 2;
      }).map(function(R) {
        return Number(R) * 2;
      }).join("").split(""), T = g.filter(function(R, B) {
        return !(B % 2);
      }).concat(I).map(function(R) {
        return Number(R);
      }).reduce(function(R, B) {
        return R + B;
      });
      return T % 10 === 0;
    }
    function h(p) {
      p = p.replace(/\W/, "");
      var g = parseInt(p.slice(0, 2), 10);
      if (p.length === 10)
        g < 54 ? g = "20".concat(g) : g = "19".concat(g);
      else {
        if (p.slice(6) === "000")
          return !1;
        if (g < 54)
          g = "19".concat(g);
        else
          return !1;
      }
      g.length === 3 && (g = [g.slice(0, 2), "0", g.slice(2)].join(""));
      var I = parseInt(p.slice(2, 4), 10);
      if (I > 50 && (I -= 50), I > 20) {
        if (parseInt(g, 10) < 2004)
          return !1;
        I -= 20;
      }
      I < 10 && (I = "0".concat(I));
      var T = "".concat(g, "/").concat(I, "/").concat(p.slice(4, 6));
      if (!(0, a.default)(T, "YYYY/MM/DD"))
        return !1;
      if (p.length === 10 && parseInt(p, 10) % 11 !== 0) {
        var R = parseInt(p.slice(0, 9), 10) % 11;
        if (parseInt(g, 10) < 1986 && R === 10) {
          if (parseInt(p.slice(9), 10) !== 0)
            return !1;
        } else
          return !1;
      }
      return !0;
    }
    function _(p) {
      return d.luhnCheck(p);
    }
    function O(p) {
      for (var g = p.split("").map(function(W) {
        return parseInt(W, 10);
      }), I = [], T = 0; T < g.length - 1; T++) {
        I.push("");
        for (var R = 0; R < g.length - 1; R++)
          g[T] === g[R] && (I[T] += R);
      }
      if (I = I.filter(function(W) {
        return W.length > 1;
      }), I.length !== 2 && I.length !== 3)
        return !1;
      if (I[0].length === 3) {
        for (var B = I[0].split("").map(function(W) {
          return parseInt(W, 10);
        }), U = 0, H = 0; H < B.length - 1; H++)
          B[H] + 1 === B[H + 1] && (U += 1);
        if (U === 2)
          return !1;
      }
      return d.iso7064Check(p);
    }
    function y(p) {
      p = p.replace(/\W/, "");
      var g = parseInt(p.slice(4, 6), 10), I = p.slice(6, 7);
      switch (I) {
        case "0":
        case "1":
        case "2":
        case "3":
          g = "19".concat(g);
          break;
        case "4":
        case "9":
          g < 37 ? g = "20".concat(g) : g = "19".concat(g);
          break;
        default:
          if (g < 37)
            g = "20".concat(g);
          else if (g > 58)
            g = "18".concat(g);
          else
            return !1;
          break;
      }
      g.length === 3 && (g = [g.slice(0, 2), "0", g.slice(2)].join(""));
      var T = "".concat(g, "/").concat(p.slice(2, 4), "/").concat(p.slice(0, 2));
      if (!(0, a.default)(T, "YYYY/MM/DD"))
        return !1;
      for (var R = p.split("").map(function(W) {
        return parseInt(W, 10);
      }), B = 0, U = 4, H = 0; H < 9; H++)
        B += R[H] * U, U -= 1, U === 1 && (U = 7);
      return B %= 11, B === 1 ? !1 : B === 0 ? R[9] === 0 : R[9] === 11 - B;
    }
    function M(p) {
      for (var g = p.slice(0, 8).split("").map(function(B) {
        return parseInt(B, 10);
      }), I = 0, T = 1; T < g.length; T += 2)
        I += g[T];
      for (var R = 0; R < g.length; R += 2)
        g[R] < 2 ? I += 1 - g[R] : (I += 2 * (g[R] - 2) + 5, g[R] > 4 && (I += 2));
      return String.fromCharCode(I % 26 + 65) === p.charAt(8);
    }
    function N(p) {
      for (var g = p.split("").map(function(R) {
        return parseInt(R, 10);
      }), I = 0, T = 0; T < 8; T++)
        I += g[T] * Math.pow(2, 8 - T);
      return I % 11 % 10 === g[8];
    }
    function D(p) {
      var g = d.reverseMultiplyAndSum(p.split("").slice(0, 7).map(function(I) {
        return parseInt(I, 10);
      }), 8);
      return p.length === 9 && p[8] !== "W" && (g += (p[8].charCodeAt(0) - 64) * 9), g %= 23, g === 0 ? p[7].toUpperCase() === "W" : p[7].toUpperCase() === String.fromCharCode(64 + g);
    }
    var x = {
      andover: ["10", "12"],
      atlanta: ["60", "67"],
      austin: ["50", "53"],
      brookhaven: ["01", "02", "03", "04", "05", "06", "11", "13", "14", "16", "21", "22", "23", "25", "34", "51", "52", "54", "55", "56", "57", "58", "59", "65"],
      cincinnati: ["30", "32", "35", "36", "37", "38", "61"],
      fresno: ["15", "24"],
      internet: ["20", "26", "27", "45", "46", "47"],
      kansas: ["40", "44"],
      memphis: ["94", "95"],
      ogden: ["80", "90"],
      philadelphia: ["33", "39", "41", "42", "43", "46", "48", "62", "63", "64", "66", "68", "71", "72", "73", "74", "75", "76", "77", "81", "82", "83", "84", "85", "86", "87", "88", "91", "92", "93", "98", "99"],
      sba: ["31"]
    };
    function A() {
      var p = [];
      for (var g in x)
        x.hasOwnProperty(g) && p.push.apply(p, s(x[g]));
      return p;
    }
    function S(p) {
      return A().indexOf(p.slice(0, 2)) !== -1;
    }
    function P(p) {
      for (var g = 0, I = p.split(""), T = parseInt(I.pop(), 10), R = 0; R < I.length; R++)
        g += I[9 - R] * (2 + R % 6);
      var B = 11 - g % 11;
      return B === 11 ? B = 0 : B === 10 && (B = 9), T === B;
    }
    function Z(p) {
      var g = p.toUpperCase().split("");
      if (isNaN(parseInt(g[0], 10)) && g.length > 1) {
        var I = 0;
        switch (g[0]) {
          case "Y":
            I = 1;
            break;
          case "Z":
            I = 2;
            break;
        }
        g.splice(0, 1, I);
      } else
        for (; g.length < 9; )
          g.unshift(0);
      var T = ["T", "R", "W", "A", "G", "M", "Y", "F", "P", "D", "X", "B", "N", "J", "Z", "S", "Q", "V", "H", "L", "C", "K", "E"];
      g = g.join("");
      var R = parseInt(g.slice(0, 8), 10) % 23;
      return g[8] === T[R];
    }
    function G(p) {
      var g = p.slice(1, 3), I = p.slice(0, 1);
      switch (I) {
        case "1":
        case "2":
          g = "18".concat(g);
          break;
        case "3":
        case "4":
          g = "19".concat(g);
          break;
        default:
          g = "20".concat(g);
          break;
      }
      var T = "".concat(g, "/").concat(p.slice(3, 5), "/").concat(p.slice(5, 7));
      if (!(0, a.default)(T, "YYYY/MM/DD"))
        return !1;
      for (var R = p.split("").map(function(tt) {
        return parseInt(tt, 10);
      }), B = 0, U = 1, H = 0; H < 10; H++)
        B += R[H] * U, U += 1, U === 10 && (U = 1);
      if (B % 11 === 10) {
        B = 0, U = 3;
        for (var W = 0; W < 10; W++)
          B += R[W] * U, U += 1, U === 10 && (U = 1);
        if (B % 11 === 10)
          return R[10] === 0;
      }
      return B % 11 === R[10];
    }
    function K(p) {
      var g = p.slice(4, 6), I = p.slice(6, 7);
      switch (I) {
        case "+":
          g = "18".concat(g);
          break;
        case "-":
          g = "19".concat(g);
          break;
        default:
          g = "20".concat(g);
          break;
      }
      var T = "".concat(g, "/").concat(p.slice(2, 4), "/").concat(p.slice(0, 2));
      if (!(0, a.default)(T, "YYYY/MM/DD"))
        return !1;
      var R = parseInt(p.slice(0, 6) + p.slice(7, 10), 10) % 31;
      if (R < 10)
        return R === parseInt(p.slice(10), 10);
      R -= 10;
      var B = ["A", "B", "C", "D", "E", "F", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y"];
      return B[R] === p.slice(10);
    }
    function Y(p) {
      if (p.slice(2, 4) !== "00" || p.slice(4, 6) !== "00") {
        var g = "".concat(p.slice(0, 2), "/").concat(p.slice(2, 4), "/").concat(p.slice(4, 6));
        if (!(0, a.default)(g, "YY/MM/DD"))
          return !1;
      }
      var I = 97 - parseInt(p.slice(0, 9), 10) % 97, T = parseInt(p.slice(9, 11), 10);
      return !(I !== T && (I = 97 - parseInt("2".concat(p.slice(0, 9)), 10) % 97, I !== T));
    }
    function it(p) {
      p = p.replace(/\s/g, "");
      var g = parseInt(p.slice(0, 10), 10) % 511, I = parseInt(p.slice(10, 13), 10);
      return g === I;
    }
    function V(p) {
      var g = "".concat(p.slice(0, 4), "/").concat(p.slice(4, 6), "/").concat(p.slice(6, 8));
      return !(0, a.default)(g, "YYYY/MM/DD") || !d.luhnCheck(p.slice(0, 12)) ? !1 : d.verhoeffCheck("".concat(p.slice(0, 11)).concat(p[12]));
    }
    function At(p) {
      return d.iso7064Check(p);
    }
    function $t(p) {
      for (var g = p.split("").map(function(R) {
        return parseInt(R, 10);
      }), I = 8, T = 1; T < 9; T++)
        I += g[T] * (T + 1);
      return I % 11 === g[9];
    }
    function It(p) {
      for (var g = !1, I = !1, T = 0; T < 3; T++)
        if (!g && /[AEIOU]/.test(p[T]))
          g = !0;
        else if (!I && g && p[T] === "X")
          I = !0;
        else if (T > 0 && (g && !I && !/[AEIOU]/.test(p[T]) || I && !/X/.test(p[T])))
          return !1;
      return !0;
    }
    function st(p) {
      var g = p.toUpperCase().split("");
      if (!It(g.slice(0, 3)) || !It(g.slice(3, 6)))
        return !1;
      for (var I = [6, 7, 9, 10, 12, 13, 14], T = {
        L: "0",
        M: "1",
        N: "2",
        P: "3",
        Q: "4",
        R: "5",
        S: "6",
        T: "7",
        U: "8",
        V: "9"
      }, R = 0, B = I; R < B.length; R++) {
        var U = B[R];
        g[U] in T && g.splice(U, 1, T[g[U]]);
      }
      var H = {
        A: "01",
        B: "02",
        C: "03",
        D: "04",
        E: "05",
        H: "06",
        L: "07",
        M: "08",
        P: "09",
        R: "10",
        S: "11",
        T: "12"
      }, W = H[g[8]], tt = parseInt(g[9] + g[10], 10);
      tt > 40 && (tt -= 40), tt < 10 && (tt = "0".concat(tt));
      var Lt = "".concat(g[6]).concat(g[7], "/").concat(W, "/").concat(tt);
      if (!(0, a.default)(Lt, "YY/MM/DD"))
        return !1;
      for (var _t = 0, gt = 1; gt < g.length - 1; gt += 2) {
        var he = parseInt(g[gt], 10);
        isNaN(he) && (he = g[gt].charCodeAt(0) - 65), _t += he;
      }
      for (var xe = {
        // Maps of characters at odd places
        A: 1,
        B: 0,
        C: 5,
        D: 7,
        E: 9,
        F: 13,
        G: 15,
        H: 17,
        I: 19,
        J: 21,
        K: 2,
        L: 4,
        M: 18,
        N: 20,
        O: 11,
        P: 3,
        Q: 6,
        R: 8,
        S: 12,
        T: 14,
        U: 16,
        V: 10,
        W: 22,
        X: 25,
        Y: 24,
        Z: 23,
        0: 1,
        1: 0
      }, xt = 0; xt < g.length - 1; xt += 2) {
        var Gt = 0;
        if (g[xt] in xe)
          Gt = xe[g[xt]];
        else {
          var Ee = parseInt(g[xt], 10);
          Gt = 2 * Ee + 1, Ee > 4 && (Gt += 2);
        }
        _t += Gt;
      }
      return String.fromCharCode(65 + _t % 26) === g[15];
    }
    function Pt(p) {
      p = p.replace(/\W/, "");
      var g = p.slice(0, 2);
      if (g !== "32") {
        var I = p.slice(2, 4);
        if (I !== "00") {
          var T = p.slice(4, 6);
          switch (p[6]) {
            case "0":
              T = "18".concat(T);
              break;
            case "1":
              T = "19".concat(T);
              break;
            default:
              T = "20".concat(T);
              break;
          }
          var R = "".concat(T, "/").concat(p.slice(2, 4), "/").concat(g);
          if (!(0, a.default)(R, "YYYY/MM/DD"))
            return !1;
        }
        for (var B = 1101, U = [1, 6, 3, 7, 9, 10, 5, 8, 4, 2], H = 0; H < p.length - 1; H++)
          B -= parseInt(p[H], 10) * U[H];
        return parseInt(p[10], 10) === B % 11;
      }
      return !0;
    }
    function ct(p) {
      if (p.length !== 9) {
        for (var g = p.toUpperCase().split(""); g.length < 8; )
          g.unshift(0);
        switch (p[7]) {
          case "A":
          case "P":
            if (parseInt(g[6], 10) === 0)
              return !1;
            break;
          default: {
            var I = parseInt(g.join("").slice(0, 5), 10);
            if (I > 32e3)
              return !1;
            var T = parseInt(g.join("").slice(5, 7), 10);
            if (I === T)
              return !1;
          }
        }
      }
      return !0;
    }
    function mt(p) {
      return d.reverseMultiplyAndSum(p.split("").slice(0, 8).map(function(g) {
        return parseInt(g, 10);
      }), 9) % 11 === parseInt(p[8], 10);
    }
    function Ot(p) {
      if (p.length === 10) {
        for (var g = [6, 5, 7, 2, 3, 4, 5, 6, 7], I = 0, T = 0; T < g.length; T++)
          I += parseInt(p[T], 10) * g[T];
        return I %= 11, I === 10 ? !1 : I === parseInt(p[9], 10);
      }
      var R = p.slice(0, 2), B = parseInt(p.slice(2, 4), 10);
      B > 80 ? (R = "18".concat(R), B -= 80) : B > 60 ? (R = "22".concat(R), B -= 60) : B > 40 ? (R = "21".concat(R), B -= 40) : B > 20 ? (R = "20".concat(R), B -= 20) : R = "19".concat(R), B < 10 && (B = "0".concat(B));
      var U = "".concat(R, "/").concat(B, "/").concat(p.slice(4, 6));
      if (!(0, a.default)(U, "YYYY/MM/DD"))
        return !1;
      for (var H = 0, W = 1, tt = 0; tt < p.length - 1; tt++)
        H += parseInt(p[tt], 10) * W % 10, W += 2, W > 10 ? W = 1 : W === 5 && (W += 2);
      return H = 10 - H % 10, H === parseInt(p[10], 10);
    }
    function fe(p) {
      if (p.length === 11) {
        var g, I;
        if (g = 0, // Reject known invalid CPFs
        p === "11111111111" || p === "22222222222" || p === "33333333333" || p === "44444444444" || p === "55555555555" || p === "66666666666" || p === "77777777777" || p === "88888888888" || p === "99999999999" || p === "00000000000") return !1;
        for (var T = 1; T <= 9; T++) g += parseInt(p.substring(T - 1, T), 10) * (11 - T);
        if (I = g * 10 % 11, I === 10 && (I = 0), I !== parseInt(p.substring(9, 10), 10)) return !1;
        g = 0;
        for (var R = 1; R <= 10; R++) g += parseInt(p.substring(R - 1, R), 10) * (12 - R);
        return I = g * 10 % 11, I === 10 && (I = 0), I === parseInt(p.substring(10, 11), 10);
      }
      if (
        // Reject know invalid CNPJs
        p === "00000000000000" || p === "11111111111111" || p === "22222222222222" || p === "33333333333333" || p === "44444444444444" || p === "55555555555555" || p === "66666666666666" || p === "77777777777777" || p === "88888888888888" || p === "99999999999999"
      )
        return !1;
      for (var B = p.length - 2, U = p.substring(0, B), H = p.substring(B), W = 0, tt = B - 7, Lt = B; Lt >= 1; Lt--)
        W += U.charAt(B - Lt) * tt, tt -= 1, tt < 2 && (tt = 9);
      var _t = W % 11 < 2 ? 0 : 11 - W % 11;
      if (_t !== parseInt(H.charAt(0), 10))
        return !1;
      B += 1, U = p.substring(0, B), W = 0, tt = B - 7;
      for (var gt = B; gt >= 1; gt--)
        W += U.charAt(B - gt) * tt, tt -= 1, tt < 2 && (tt = 9);
      return _t = W % 11 < 2 ? 0 : 11 - W % 11, _t === parseInt(H.charAt(1), 10);
    }
    function $e(p) {
      var g = 11 - d.reverseMultiplyAndSum(p.split("").slice(0, 8).map(function(I) {
        return parseInt(I, 10);
      }), 9) % 11;
      return g > 9 ? parseInt(p[8], 10) === 0 : g === parseInt(p[8], 10);
    }
    function pe(p) {
      if (p.slice(0, 4) !== "9000") {
        var g = p.slice(1, 3);
        switch (p[0]) {
          case "1":
          case "2":
            g = "19".concat(g);
            break;
          case "3":
          case "4":
            g = "18".concat(g);
            break;
          case "5":
          case "6":
            g = "20".concat(g);
            break;
        }
        var I = "".concat(g, "/").concat(p.slice(3, 5), "/").concat(p.slice(5, 7));
        if (I.length === 8) {
          if (!(0, a.default)(I, "YY/MM/DD"))
            return !1;
        } else if (!(0, a.default)(I, "YYYY/MM/DD"))
          return !1;
        for (var T = p.split("").map(function(H) {
          return parseInt(H, 10);
        }), R = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9], B = 0, U = 0; U < R.length; U++)
          B += T[U] * R[U];
        return B % 11 === 10 ? T[12] === 1 : T[12] === B % 11;
      }
      return !0;
    }
    function ve(p) {
      if (p.length === 9) {
        if (p = p.replace(/\W/, ""), p.slice(6) === "000")
          return !1;
        var g = parseInt(p.slice(0, 2), 10);
        if (g > 53)
          return !1;
        g < 10 ? g = "190".concat(g) : g = "19".concat(g);
        var I = parseInt(p.slice(2, 4), 10);
        I > 50 && (I -= 50), I < 10 && (I = "0".concat(I));
        var T = "".concat(g, "/").concat(I, "/").concat(p.slice(4, 6));
        if (!(0, a.default)(T, "YYYY/MM/DD"))
          return !1;
      }
      return !0;
    }
    function Zt(p) {
      var g = 11 - d.reverseMultiplyAndSum(p.split("").slice(0, 7).map(function(I) {
        return parseInt(I, 10);
      }), 8) % 11;
      return g === 10 ? parseInt(p[7], 10) === 0 : g === parseInt(p[7], 10);
    }
    function F(p) {
      var g = p.slice(0);
      p.length > 11 && (g = g.slice(2));
      var I = "", T = g.slice(2, 4), R = parseInt(g.slice(4, 6), 10);
      if (p.length > 11)
        I = p.slice(0, 4);
      else if (I = p.slice(0, 2), p.length === 11 && R < 60) {
        var B = (/* @__PURE__ */ new Date()).getFullYear().toString(), U = parseInt(B.slice(0, 2), 10);
        if (B = parseInt(B, 10), p[6] === "-")
          parseInt("".concat(U).concat(I), 10) > B ? I = "".concat(U - 1).concat(I) : I = "".concat(U).concat(I);
        else if (I = "".concat(U - 1).concat(I), B - parseInt(I, 10) < 100)
          return !1;
      }
      R > 60 && (R -= 60), R < 10 && (R = "0".concat(R));
      var H = "".concat(I, "/").concat(T, "/").concat(R);
      if (H.length === 8) {
        if (!(0, a.default)(H, "YY/MM/DD"))
          return !1;
      } else if (!(0, a.default)(H, "YYYY/MM/DD"))
        return !1;
      return d.luhnCheck(p.replace(/\W/, ""));
    }
    function k(p) {
      for (var g = p.split("").map(function(B) {
        return parseInt(B, 10);
      }), I = [-1, 5, 7, 9, 4, 6, 10, 5, 7], T = 0, R = 0; R < I.length; R++)
        T += g[R] * I[R];
      return T % 11 === 10 ? g[9] === 0 : g[9] === T % 11;
    }
    var z = {
      "bg-BG": /^\d{10}$/,
      "cs-CZ": /^\d{6}\/{0,1}\d{3,4}$/,
      "de-AT": /^\d{9}$/,
      "de-DE": /^[1-9]\d{10}$/,
      "dk-DK": /^\d{6}-{0,1}\d{4}$/,
      "el-CY": /^[09]\d{7}[A-Z]$/,
      "el-GR": /^([0-4]|[7-9])\d{8}$/,
      "en-CA": /^\d{9}$/,
      "en-GB": /^\d{10}$|^(?!GB|NK|TN|ZZ)(?![DFIQUV])[A-Z](?![DFIQUVO])[A-Z]\d{6}[ABCD ]$/i,
      "en-IE": /^\d{7}[A-W][A-IW]{0,1}$/i,
      "en-US": /^\d{2}[- ]{0,1}\d{7}$/,
      "es-AR": /(20|23|24|27|30|33|34)[0-9]{8}[0-9]/,
      "es-ES": /^(\d{0,8}|[XYZKLM]\d{7})[A-HJ-NP-TV-Z]$/i,
      "et-EE": /^[1-6]\d{6}(00[1-9]|0[1-9][0-9]|[1-6][0-9]{2}|70[0-9]|710)\d$/,
      "fi-FI": /^\d{6}[-+A]\d{3}[0-9A-FHJ-NPR-Y]$/i,
      "fr-BE": /^\d{11}$/,
      "fr-FR": /^[0-3]\d{12}$|^[0-3]\d\s\d{2}(\s\d{3}){3}$/,
      // Conforms both to official spec and provided example
      "fr-LU": /^\d{13}$/,
      "hr-HR": /^\d{11}$/,
      "hu-HU": /^8\d{9}$/,
      "it-IT": /^[A-Z]{6}[L-NP-V0-9]{2}[A-EHLMPRST][L-NP-V0-9]{2}[A-ILMZ][L-NP-V0-9]{3}[A-Z]$/i,
      "lv-LV": /^\d{6}-{0,1}\d{5}$/,
      // Conforms both to DG TAXUD spec and original research
      "mt-MT": /^\d{3,7}[APMGLHBZ]$|^([1-8])\1\d{7}$/i,
      "nl-NL": /^\d{9}$/,
      "pl-PL": /^\d{10,11}$/,
      "pt-BR": /(?:^\d{11}$)|(?:^\d{14}$)/,
      "pt-PT": /^\d{9}$/,
      "ro-RO": /^\d{13}$/,
      "sk-SK": /^\d{6}\/{0,1}\d{3,4}$/,
      "sl-SI": /^[1-9]\d{7}$/,
      "sv-SE": /^(\d{6}[-+]{0,1}\d{4}|(18|19|20)\d{6}[-+]{0,1}\d{4})$/,
      "uk-UA": /^\d{10}$/
    };
    z["lb-LU"] = z["fr-LU"], z["lt-LT"] = z["et-EE"], z["nl-BE"] = z["fr-BE"], z["fr-CA"] = z["en-CA"];
    var dt = {
      "bg-BG": f,
      "cs-CZ": h,
      "de-AT": _,
      "de-DE": O,
      "dk-DK": y,
      "el-CY": M,
      "el-GR": N,
      "en-CA": v,
      "en-IE": D,
      "en-US": S,
      "es-AR": P,
      "es-ES": Z,
      "et-EE": G,
      "fi-FI": K,
      "fr-BE": Y,
      "fr-FR": it,
      "fr-LU": V,
      "hr-HR": At,
      "hu-HU": $t,
      "it-IT": st,
      "lv-LV": Pt,
      "mt-MT": ct,
      "nl-NL": mt,
      "pl-PL": Ot,
      "pt-BR": fe,
      "pt-PT": $e,
      "ro-RO": pe,
      "sk-SK": ve,
      "sl-SI": Zt,
      "sv-SE": F,
      "uk-UA": k
    };
    dt["lb-LU"] = dt["fr-LU"], dt["lt-LT"] = dt["et-EE"], dt["nl-BE"] = dt["fr-BE"], dt["fr-CA"] = dt["en-CA"];
    var Oe = /[-\\\/!@#$%\^&\*\(\)\+\=\[\]]+/g, Ut = {
      "de-AT": Oe,
      "de-DE": /[\/\\]/g,
      "fr-BE": Oe
    };
    Ut["nl-BE"] = Ut["fr-BE"];
    function Ye(p) {
      var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US";
      (0, n.default)(p);
      var I = p.slice(0);
      if (g in z)
        return g in Ut && (I = I.replace(Ut[g], "")), z[g].test(I) ? g in dt ? dt[g](I) : !0 : !1;
      throw new Error("Invalid locale '".concat(g, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(M0, M0.exports)), M0.exports;
}
var ne = {}, Za;
function $f() {
  if (Za) return ne;
  Za = 1, Object.defineProperty(ne, "__esModule", {
    value: !0
  }), ne.isFreightContainerID = void 0, ne.isISO6346 = d;
  var e = t(/* @__PURE__ */ L());
  function t(a) {
    return a && a.__esModule ? a : { default: a };
  }
  var r = /^[A-Z]{3}(U[0-9]{7})|([J,Z][0-9]{6,7})$/, n = /^[0-9]$/;
  function d(a) {
    if ((0, e.default)(a), a = a.toUpperCase(), !r.test(a)) return !1;
    if (a.length === 11) {
      for (var o = 0, u = 0; u < a.length - 1; u++)
        if (n.test(a[u]))
          o += a[u] * Math.pow(2, u);
        else {
          var i = void 0, s = a.charCodeAt(u) - 55;
          s < 11 ? i = s : s >= 11 && s <= 20 ? i = 12 + s % 11 : s >= 21 && s <= 30 ? i = 23 + s % 21 : i = 34 + s % 31, o += i * Math.pow(2, u);
        }
      var c = o % 11;
      return c === 10 && (c = 0), Number(a[a.length - 1]) === c;
    }
    return !0;
  }
  return ne.isFreightContainerID = d, ne;
}
var S0 = { exports: {} }, Ua;
function pf() {
  return Ua || (Ua = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /* @__PURE__ */ new Set(["aa", "ab", "ae", "af", "ak", "am", "an", "ar", "as", "av", "ay", "az", "az", "ba", "be", "bg", "bh", "bi", "bm", "bn", "bo", "br", "bs", "ca", "ce", "ch", "co", "cr", "cs", "cu", "cv", "cy", "da", "de", "dv", "dz", "ee", "el", "en", "eo", "es", "et", "eu", "fa", "ff", "fi", "fj", "fo", "fr", "fy", "ga", "gd", "gl", "gn", "gu", "gv", "ha", "he", "hi", "ho", "hr", "ht", "hu", "hy", "hz", "ia", "id", "ie", "ig", "ii", "ik", "io", "is", "it", "iu", "ja", "jv", "ka", "kg", "ki", "kj", "kk", "kl", "km", "kn", "ko", "kr", "ks", "ku", "kv", "kw", "ky", "la", "lb", "lg", "li", "ln", "lo", "lt", "lu", "lv", "mg", "mh", "mi", "mk", "ml", "mn", "mr", "ms", "mt", "my", "na", "nb", "nd", "ne", "ng", "nl", "nn", "no", "nr", "nv", "ny", "oc", "oj", "om", "or", "os", "pa", "pi", "pl", "ps", "pt", "qu", "rm", "rn", "ro", "ru", "rw", "sa", "sc", "sd", "se", "sg", "si", "sk", "sl", "sm", "sn", "so", "sq", "sr", "ss", "st", "su", "sv", "sw", "ta", "te", "tg", "th", "ti", "tk", "tl", "tn", "to", "tr", "ts", "tt", "tw", "ty", "ug", "uk", "ur", "uz", "ve", "vi", "vo", "wa", "wo", "xh", "yi", "yo", "za", "zh", "zu"]);
    function a(o) {
      return (0, r.default)(o), d.has(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(S0, S0.exports)), S0.exports;
}
var de = {}, Ga;
function vf() {
  if (Ga) return de;
  Ga = 1, Object.defineProperty(de, "__esModule", {
    value: !0
  }), de.ScriptCodes = void 0, de.default = n;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = /* @__PURE__ */ new Set(["Adlm", "Afak", "Aghb", "Ahom", "Arab", "Aran", "Armi", "Armn", "Avst", "Bali", "Bamu", "Bass", "Batk", "Beng", "Bhks", "Blis", "Bopo", "Brah", "Brai", "Bugi", "Buhd", "Cakm", "Cans", "Cari", "Cham", "Cher", "Chis", "Chrs", "Cirt", "Copt", "Cpmn", "Cprt", "Cyrl", "Cyrs", "Deva", "Diak", "Dogr", "Dsrt", "Dupl", "Egyd", "Egyh", "Egyp", "Elba", "Elym", "Ethi", "Gara", "Geok", "Geor", "Glag", "Gong", "Gonm", "Goth", "Gran", "Grek", "Gujr", "Gukh", "Guru", "Hanb", "Hang", "Hani", "Hano", "Hans", "Hant", "Hatr", "Hebr", "Hira", "Hluw", "Hmng", "Hmnp", "Hrkt", "Hung", "Inds", "Ital", "Jamo", "Java", "Jpan", "Jurc", "Kali", "Kana", "Kawi", "Khar", "Khmr", "Khoj", "Kitl", "Kits", "Knda", "Kore", "Kpel", "Krai", "Kthi", "Lana", "Laoo", "Latf", "Latg", "Latn", "Leke", "Lepc", "Limb", "Lina", "Linb", "Lisu", "Loma", "Lyci", "Lydi", "Mahj", "Maka", "Mand", "Mani", "Marc", "Maya", "Medf", "Mend", "Merc", "Mero", "Mlym", "Modi", "Mong", "Moon", "Mroo", "Mtei", "Mult", "Mymr", "Nagm", "Nand", "Narb", "Nbat", "Newa", "Nkdb", "Nkgb", "Nkoo", "Nshu", "Ogam", "Olck", "Onao", "Orkh", "Orya", "Osge", "Osma", "Ougr", "Palm", "Pauc", "Pcun", "Pelm", "Perm", "Phag", "Phli", "Phlp", "Phlv", "Phnx", "Plrd", "Piqd", "Prti", "Psin", "Qaaa", "Qaab", "Qaac", "Qaad", "Qaae", "Qaaf", "Qaag", "Qaah", "Qaai", "Qaaj", "Qaak", "Qaal", "Qaam", "Qaan", "Qaao", "Qaap", "Qaaq", "Qaar", "Qaas", "Qaat", "Qaau", "Qaav", "Qaaw", "Qaax", "Qaay", "Qaaz", "Qaba", "Qabb", "Qabc", "Qabd", "Qabe", "Qabf", "Qabg", "Qabh", "Qabi", "Qabj", "Qabk", "Qabl", "Qabm", "Qabn", "Qabo", "Qabp", "Qabq", "Qabr", "Qabs", "Qabt", "Qabu", "Qabv", "Qabw", "Qabx", "Ranj", "Rjng", "Rohg", "Roro", "Runr", "Samr", "Sara", "Sarb", "Saur", "Sgnw", "Shaw", "Shrd", "Shui", "Sidd", "Sidt", "Sind", "Sinh", "Sogd", "Sogo", "Sora", "Soyo", "Sund", "Sunu", "Sylo", "Syrc", "Syre", "Syrj", "Syrn", "Tagb", "Takr", "Tale", "Talu", "Taml", "Tang", "Tavt", "Tayo", "Telu", "Teng", "Tfng", "Tglg", "Thaa", "Thai", "Tibt", "Tirh", "Tnsa", "Todr", "Tols", "Toto", "Tutg", "Ugar", "Vaii", "Visp", "Vith", "Wara", "Wcho", "Wole", "Xpeo", "Xsux", "Yezi", "Yiii", "Zanb", "Zinh", "Zmth", "Zsye", "Zsym", "Zxxx", "Zyyy", "Zzzz"]);
  function n(d) {
    return (0, e.default)(d), r.has(d);
  }
  return de.ScriptCodes = r, de;
}
var I0 = { exports: {} }, ka;
function hf() {
  return ka || (ka = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /* @__PURE__ */ new Set(["004", "008", "010", "012", "016", "020", "024", "028", "031", "032", "036", "040", "044", "048", "050", "051", "052", "056", "060", "064", "068", "070", "072", "074", "076", "084", "086", "090", "092", "096", "100", "104", "108", "112", "116", "120", "124", "132", "136", "140", "144", "148", "152", "156", "158", "162", "166", "170", "174", "175", "178", "180", "184", "188", "191", "192", "196", "203", "204", "208", "212", "214", "218", "222", "226", "231", "232", "233", "234", "238", "239", "242", "246", "248", "250", "254", "258", "260", "262", "266", "268", "270", "275", "276", "288", "292", "296", "300", "304", "308", "312", "316", "320", "324", "328", "332", "334", "336", "340", "344", "348", "352", "356", "360", "364", "368", "372", "376", "380", "384", "388", "392", "398", "400", "404", "408", "410", "414", "417", "418", "422", "426", "428", "430", "434", "438", "440", "442", "446", "450", "454", "458", "462", "466", "470", "474", "478", "480", "484", "492", "496", "498", "499", "500", "504", "508", "512", "516", "520", "524", "528", "531", "533", "534", "535", "540", "548", "554", "558", "562", "566", "570", "574", "578", "580", "581", "583", "584", "585", "586", "591", "598", "600", "604", "608", "612", "616", "620", "624", "626", "630", "634", "638", "642", "643", "646", "652", "654", "659", "660", "662", "663", "666", "670", "674", "678", "682", "686", "688", "690", "694", "702", "703", "704", "705", "706", "710", "716", "724", "728", "729", "732", "740", "744", "748", "752", "756", "760", "762", "764", "768", "772", "776", "780", "784", "788", "792", "795", "796", "798", "800", "804", "807", "818", "826", "831", "832", "833", "834", "840", "850", "854", "858", "860", "862", "876", "882", "887", "894"]);
    function a(o) {
      return (0, r.default)(o), d.has(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(I0, I0.exports)), I0.exports;
}
var ae = {}, Ha;
function rs() {
  if (Ha) return ae;
  Ha = 1, Object.defineProperty(ae, "__esModule", {
    value: !0
  }), ae.CurrencyCodes = void 0, ae.default = n;
  var e = t(/* @__PURE__ */ L());
  function t(d) {
    return d && d.__esModule ? d : { default: d };
  }
  var r = /* @__PURE__ */ new Set(["AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BOV", "BRL", "BSD", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHE", "CHF", "CHW", "CLF", "CLP", "CNY", "COP", "COU", "CRC", "CUP", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HTG", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KGS", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MXV", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLE", "SLL", "SOS", "SRD", "SSP", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "USN", "UYI", "UYU", "UYW", "UZS", "VED", "VES", "VND", "VUV", "WST", "XAF", "XAG", "XAU", "XBA", "XBB", "XBC", "XBD", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "XSU", "XTS", "XUA", "XXX", "YER", "ZAR", "ZMW", "ZWL"]);
  function n(d) {
    return (0, e.default)(d), r.has(d.toUpperCase());
  }
  return ae.CurrencyCodes = r, ae;
}
var O0 = { exports: {} }, Va;
function ns() {
  return Va || (Va = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[A-HJ-NP-Za-km-z1-9]*$/;
    function a(o) {
      return (0, r.default)(o), !!d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(O0, O0.exports)), O0.exports;
}
var x0 = { exports: {} }, E0 = { exports: {} }, C0 = { exports: {} }, Ka;
function ds() {
  return Ka || (Ka = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      if ((0, r.default)(a), o) {
        var u = new RegExp("[".concat(o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+$"), "g");
        return a.replace(u, "");
      }
      for (var i = a.length - 1; /\s/.test(a.charAt(i)); )
        i -= 1;
      return a.slice(0, i + 1);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(C0, C0.exports)), C0.exports;
}
var N0 = { exports: {} }, Wa;
function as() {
  return Wa || (Wa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      (0, r.default)(a);
      var u = o ? new RegExp("^[".concat(o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "]+"), "g") : /^\s+/g;
      return a.replace(u, "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(N0, N0.exports)), N0.exports;
}
var Ya;
function os() {
  return Ya || (Ya = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = d(/* @__PURE__ */ ds()), n = d(/* @__PURE__ */ as());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o, u) {
      return (0, r.default)((0, n.default)(o, u), u);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(E0, E0.exports)), E0.exports;
}
var za;
function mf() {
  return za || (za = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = m;
    var r = a(/* @__PURE__ */ os()), n = a(/* @__PURE__ */ en()), d = a(/* @__PURE__ */ L());
    function a(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function o(f, v) {
      return s(f) || i(f, v) || l(f, v) || u();
    }
    function u() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function i(f, v) {
      var h = f == null ? null : typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (h != null) {
        var _, O, y, M, N = [], D = !0, x = !1;
        try {
          if (y = (h = h.call(f)).next, v !== 0) for (; !(D = (_ = y.call(h)).done) && (N.push(_.value), N.length !== v); D = !0) ;
        } catch (A) {
          x = !0, O = A;
        } finally {
          try {
            if (!D && h.return != null && (M = h.return(), Object(M) !== M)) return;
          } finally {
            if (x) throw O;
          }
        }
        return N;
      }
    }
    function s(f) {
      if (Array.isArray(f)) return f;
    }
    function c(f, v) {
      var h = typeof Symbol < "u" && f[Symbol.iterator] || f["@@iterator"];
      if (!h) {
        if (Array.isArray(f) || (h = l(f)) || v) {
          h && (f = h);
          var _ = 0, O = function() {
          };
          return { s: O, n: function() {
            return _ >= f.length ? { done: !0 } : { done: !1, value: f[_++] };
          }, e: function(D) {
            throw D;
          }, f: O };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      var y, M = !0, N = !1;
      return { s: function() {
        h = h.call(f);
      }, n: function() {
        var D = h.next();
        return M = D.done, D;
      }, e: function(D) {
        N = !0, y = D;
      }, f: function() {
        try {
          M || h.return == null || h.return();
        } finally {
          if (N) throw y;
        }
      } };
    }
    function l(f, v) {
      if (f) {
        if (typeof f == "string") return $(f, v);
        var h = {}.toString.call(f).slice(8, -1);
        return h === "Object" && f.constructor && (h = f.constructor.name), h === "Map" || h === "Set" ? Array.from(f) : h === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(h) ? $(f, v) : void 0;
      }
    }
    function $(f, v) {
      (v == null || v > f.length) && (v = f.length);
      for (var h = 0, _ = Array(v); h < v; h++) _[h] = f[h];
      return _;
    }
    function b(f) {
      var v = /* @__PURE__ */ new Set(["subject", "body", "cc", "bcc"]), h = {
        cc: "",
        bcc: ""
      }, _ = !1, O = f.split("&");
      if (O.length > 4)
        return !1;
      var y = c(O), M;
      try {
        for (y.s(); !(M = y.n()).done; ) {
          var N = M.value, D = N.split("="), x = o(D, 2), A = x[0], S = x[1];
          if (A && !v.has(A)) {
            _ = !0;
            break;
          }
          S && (A === "cc" || A === "bcc") && (h[A] = S), A && v.delete(A);
        }
      } catch (P) {
        y.e(P);
      } finally {
        y.f();
      }
      return _ ? !1 : h;
    }
    function m(f, v) {
      if ((0, d.default)(f), f.indexOf("mailto:") !== 0)
        return !1;
      var h = f.replace("mailto:", "").split("?"), _ = o(h, 2), O = _[0], y = _[1], M = y === void 0 ? "" : y;
      if (!O && !M)
        return !0;
      var N = b(M);
      return N ? "".concat(O, ",").concat(N.cc, ",").concat(N.bcc).split(",").every(function(D) {
        return D = (0, r.default)(D, " "), D ? (0, n.default)(D, v) : !0;
      }) : !1;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(x0, x0.exports)), x0.exports;
}
var P0 = { exports: {} }, Xa;
function gf() {
  return Xa || (Xa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\//g, "&#x2F;").replace(/\\/g, "&#x5C;").replace(/`/g, "&#96;");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(P0, P0.exports)), P0.exports;
}
var L0 = { exports: {} }, Qa;
function yf() {
  return Qa || (Qa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a) {
      return (0, r.default)(a), a.replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#x2F;/g, "/").replace(/&#x5C;/g, "\\").replace(/&#96;/g, "`").replace(/&amp;/g, "&");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(L0, L0.exports)), L0.exports;
}
var T0 = { exports: {} }, w0 = { exports: {} }, Ja;
function us() {
  return Ja || (Ja = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      return (0, r.default)(a), a.replace(new RegExp("[".concat(o, "]+"), "g"), "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(w0, w0.exports)), w0.exports;
}
var qa;
function bf() {
  return qa || (qa = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = d(/* @__PURE__ */ L()), n = d(/* @__PURE__ */ us());
    function d(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function a(o, u) {
      (0, r.default)(o);
      var i = u ? "\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F" : "\\x00-\\x1F\\x7F";
      return (0, n.default)(o, i);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(T0, T0.exports)), T0.exports;
}
var R0 = { exports: {} }, t1;
function Af() {
  return t1 || (t1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      return (0, r.default)(a), a.replace(new RegExp("[^".concat(o, "]+"), "g"), "");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(R0, R0.exports)), R0.exports;
}
var D0 = { exports: {} }, e1;
function _f() {
  return e1 || (e1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var r = n(/* @__PURE__ */ L());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function d(a, o) {
      (0, r.default)(a);
      for (var u = a.length - 1; u >= 0; u--)
        if (o.indexOf(a[u]) === -1)
          return !1;
      return !0;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(D0, D0.exports)), D0.exports;
}
var B0 = { exports: {} }, r1;
function Mf() {
  return r1 || (r1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var r = n(/* @__PURE__ */ ot());
    function n(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var d = {
      // The following options apply to all email addresses
      // Lowercases the local part of the email address.
      // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
      // The domain is always lowercased, as per RFC 1035
      all_lowercase: !0,
      // The following conversions are specific to GMail
      // Lowercases the local part of the GMail address (known to be case-insensitive)
      gmail_lowercase: !0,
      // Removes dots from the local part of the email address, as that's ignored by GMail
      gmail_remove_dots: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      gmail_remove_subaddress: !0,
      // Conversts the googlemail.com domain to gmail.com
      gmail_convert_googlemaildotcom: !0,
      // The following conversions are specific to Outlook.com / Windows Live / Hotmail
      // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
      outlookdotcom_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      outlookdotcom_remove_subaddress: !0,
      // The following conversions are specific to Yahoo
      // Lowercases the local part of the Yahoo address (known to be case-insensitive)
      yahoo_lowercase: !0,
      // Removes the subaddress (e.g. "-foo") from the email address
      yahoo_remove_subaddress: !0,
      // The following conversions are specific to Yandex
      // Lowercases the local part of the Yandex address (known to be case-insensitive)
      yandex_lowercase: !0,
      // all yandex domains are equal, this explicitly sets the domain to 'yandex.ru'
      yandex_convert_yandexru: !0,
      // The following conversions are specific to iCloud
      // Lowercases the local part of the iCloud address (known to be case-insensitive)
      icloud_lowercase: !0,
      // Removes the subaddress (e.g. "+foo") from the email address
      icloud_remove_subaddress: !0
    }, a = ["icloud.com", "me.com"], o = ["hotmail.at", "hotmail.be", "hotmail.ca", "hotmail.cl", "hotmail.co.il", "hotmail.co.nz", "hotmail.co.th", "hotmail.co.uk", "hotmail.com", "hotmail.com.ar", "hotmail.com.au", "hotmail.com.br", "hotmail.com.gr", "hotmail.com.mx", "hotmail.com.pe", "hotmail.com.tr", "hotmail.com.vn", "hotmail.cz", "hotmail.de", "hotmail.dk", "hotmail.es", "hotmail.fr", "hotmail.hu", "hotmail.id", "hotmail.ie", "hotmail.in", "hotmail.it", "hotmail.jp", "hotmail.kr", "hotmail.lv", "hotmail.my", "hotmail.ph", "hotmail.pt", "hotmail.sa", "hotmail.sg", "hotmail.sk", "live.be", "live.co.uk", "live.com", "live.com.ar", "live.com.mx", "live.de", "live.es", "live.eu", "live.fr", "live.it", "live.nl", "msn.com", "outlook.at", "outlook.be", "outlook.cl", "outlook.co.il", "outlook.co.nz", "outlook.co.th", "outlook.com", "outlook.com.ar", "outlook.com.au", "outlook.com.br", "outlook.com.gr", "outlook.com.pe", "outlook.com.tr", "outlook.com.vn", "outlook.cz", "outlook.de", "outlook.dk", "outlook.es", "outlook.fr", "outlook.hu", "outlook.id", "outlook.ie", "outlook.in", "outlook.it", "outlook.jp", "outlook.kr", "outlook.lv", "outlook.my", "outlook.ph", "outlook.pt", "outlook.sa", "outlook.sg", "outlook.sk", "passport.com"], u = ["rocketmail.com", "yahoo.ca", "yahoo.co.uk", "yahoo.com", "yahoo.de", "yahoo.fr", "yahoo.in", "yahoo.it", "ymail.com"], i = ["yandex.ru", "yandex.ua", "yandex.kz", "yandex.com", "yandex.by", "ya.ru"];
    function s(l) {
      return l.length > 1 ? l : "";
    }
    function c(l, $) {
      $ = (0, r.default)($, d);
      var b = l.split("@"), m = b.pop(), f = b.join("@"), v = [f, m];
      if (v[1] = v[1].toLowerCase(), v[1] === "gmail.com" || v[1] === "googlemail.com") {
        if ($.gmail_remove_subaddress && (v[0] = v[0].split("+")[0]), $.gmail_remove_dots && (v[0] = v[0].replace(/\.+/g, s)), !v[0].length)
          return !1;
        ($.all_lowercase || $.gmail_lowercase) && (v[0] = v[0].toLowerCase()), v[1] = $.gmail_convert_googlemaildotcom ? "gmail.com" : v[1];
      } else if (a.indexOf(v[1]) >= 0) {
        if ($.icloud_remove_subaddress && (v[0] = v[0].split("+")[0]), !v[0].length)
          return !1;
        ($.all_lowercase || $.icloud_lowercase) && (v[0] = v[0].toLowerCase());
      } else if (o.indexOf(v[1]) >= 0) {
        if ($.outlookdotcom_remove_subaddress && (v[0] = v[0].split("+")[0]), !v[0].length)
          return !1;
        ($.all_lowercase || $.outlookdotcom_lowercase) && (v[0] = v[0].toLowerCase());
      } else if (u.indexOf(v[1]) >= 0) {
        if ($.yahoo_remove_subaddress) {
          var h = v[0].split("-");
          v[0] = h.length > 1 ? h.slice(0, -1).join("-") : h[0];
        }
        if (!v[0].length)
          return !1;
        ($.all_lowercase || $.yahoo_lowercase) && (v[0] = v[0].toLowerCase());
      } else i.indexOf(v[1]) >= 0 ? (($.all_lowercase || $.yandex_lowercase) && (v[0] = v[0].toLowerCase()), v[1] = $.yandex_convert_yandexru ? "yandex.ru" : v[1]) : $.all_lowercase && (v[0] = v[0].toLowerCase());
      return v.join("@");
    }
    e.exports = t.default, e.exports.default = t.default;
  }(B0, B0.exports)), B0.exports;
}
var j0 = { exports: {} }, n1;
function Sf() {
  return n1 || (n1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
    function a(o) {
      return (0, r.default)(o), d.test(o);
    }
    e.exports = t.default, e.exports.default = t.default;
  }(j0, j0.exports)), j0.exports;
}
var F0 = { exports: {} }, d1;
function If() {
  return d1 || (d1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    var r = n(/* @__PURE__ */ L());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var d = {
      "cs-CZ": function(o) {
        return /^(([ABCDEFHIJKLMNPRSTUVXYZ]|[0-9])-?){5,8}$/.test(o);
      },
      "de-DE": function(o) {
        return /^((A|AA|AB|AC|AE|AH|AK|AM|AN|AÖ|AP|AS|AT|AU|AW|AZ|B|BA|BB|BC|BE|BF|BH|BI|BK|BL|BM|BN|BO|BÖ|BS|BT|BZ|C|CA|CB|CE|CO|CR|CW|D|DA|DD|DE|DH|DI|DL|DM|DN|DO|DU|DW|DZ|E|EA|EB|ED|EE|EF|EG|EH|EI|EL|EM|EN|ER|ES|EU|EW|F|FB|FD|FF|FG|FI|FL|FN|FO|FR|FS|FT|FÜ|FW|FZ|G|GA|GC|GD|GE|GF|GG|GI|GK|GL|GM|GN|GÖ|GP|GR|GS|GT|GÜ|GV|GW|GZ|H|HA|HB|HC|HD|HE|HF|HG|HH|HI|HK|HL|HM|HN|HO|HP|HR|HS|HU|HV|HX|HY|HZ|IK|IL|IN|IZ|J|JE|JL|K|KA|KB|KC|KE|KF|KG|KH|KI|KK|KL|KM|KN|KO|KR|KS|KT|KU|KW|KY|L|LA|LB|LC|LD|LF|LG|LH|LI|LL|LM|LN|LÖ|LP|LR|LU|M|MA|MB|MC|MD|ME|MG|MH|MI|MK|ML|MM|MN|MO|MQ|MR|MS|MÜ|MW|MY|MZ|N|NB|ND|NE|NF|NH|NI|NK|NM|NÖ|NP|NR|NT|NU|NW|NY|NZ|OA|OB|OC|OD|OE|OF|OG|OH|OK|OL|OP|OS|OZ|P|PA|PB|PE|PF|PI|PL|PM|PN|PR|PS|PW|PZ|R|RA|RC|RD|RE|RG|RH|RI|RL|RM|RN|RO|RP|RS|RT|RU|RV|RW|RZ|S|SB|SC|SE|SG|SI|SK|SL|SM|SN|SO|SP|SR|ST|SU|SW|SY|SZ|TE|TF|TG|TO|TP|TR|TS|TT|TÜ|ÜB|UE|UH|UL|UM|UN|V|VB|VG|VK|VR|VS|W|WA|WB|WE|WF|WI|WK|WL|WM|WN|WO|WR|WS|WT|WÜ|WW|WZ|Z|ZE|ZI|ZP|ZR|ZW|ZZ)[- ]?[A-Z]{1,2}[- ]?\d{1,4}|(ABG|ABI|AIB|AIC|ALF|ALZ|ANA|ANG|ANK|APD|ARN|ART|ASL|ASZ|AUR|AZE|BAD|BAR|BBG|BCH|BED|BER|BGD|BGL|BID|BIN|BIR|BIT|BIW|BKS|BLB|BLK|BNA|BOG|BOH|BOR|BOT|BRA|BRB|BRG|BRK|BRL|BRV|BSB|BSK|BTF|BÜD|BUL|BÜR|BÜS|BÜZ|CAS|CHA|CLP|CLZ|COC|COE|CUX|DAH|DAN|DAU|DBR|DEG|DEL|DGF|DIL|DIN|DIZ|DKB|DLG|DON|DUD|DÜW|EBE|EBN|EBS|ECK|EIC|EIL|EIN|EIS|EMD|EMS|ERB|ERH|ERK|ERZ|ESB|ESW|FDB|FDS|FEU|FFB|FKB|FLÖ|FOR|FRG|FRI|FRW|FTL|FÜS|GAN|GAP|GDB|GEL|GEO|GER|GHA|GHC|GLA|GMN|GNT|GOA|GOH|GRA|GRH|GRI|GRM|GRZ|GTH|GUB|GUN|GVM|HAB|HAL|HAM|HAS|HBN|HBS|HCH|HDH|HDL|HEB|HEF|HEI|HER|HET|HGN|HGW|HHM|HIG|HIP|HMÜ|HOG|HOH|HOL|HOM|HOR|HÖS|HOT|HRO|HSK|HST|HVL|HWI|IGB|ILL|JÜL|KEH|KEL|KEM|KIB|KLE|KLZ|KÖN|KÖT|KÖZ|KRU|KÜN|KUS|KYF|LAN|LAU|LBS|LBZ|LDK|LDS|LEO|LER|LEV|LIB|LIF|LIP|LÖB|LOS|LRO|LSZ|LÜN|LUP|LWL|MAB|MAI|MAK|MAL|MED|MEG|MEI|MEK|MEL|MER|MET|MGH|MGN|MHL|MIL|MKK|MOD|MOL|MON|MOS|MSE|MSH|MSP|MST|MTK|MTL|MÜB|MÜR|MYK|MZG|NAB|NAI|NAU|NDH|NEA|NEB|NEC|NEN|NES|NEW|NMB|NMS|NOH|NOL|NOM|NOR|NVP|NWM|OAL|OBB|OBG|OCH|OHA|ÖHR|OHV|OHZ|OPR|OSL|OVI|OVL|OVP|PAF|PAN|PAR|PCH|PEG|PIR|PLÖ|PRÜ|QFT|QLB|RDG|REG|REH|REI|RID|RIE|ROD|ROF|ROK|ROL|ROS|ROT|ROW|RSL|RÜD|RÜG|SAB|SAD|SAN|SAW|SBG|SBK|SCZ|SDH|SDL|SDT|SEB|SEE|SEF|SEL|SFB|SFT|SGH|SHA|SHG|SHK|SHL|SIG|SIM|SLE|SLF|SLK|SLN|SLS|SLÜ|SLZ|SMÜ|SOB|SOG|SOK|SÖM|SON|SPB|SPN|SRB|SRO|STA|STB|STD|STE|STL|SUL|SÜW|SWA|SZB|TBB|TDO|TET|TIR|TÖL|TUT|UEM|UER|UFF|USI|VAI|VEC|VER|VIB|VIE|VIT|VOH|WAF|WAK|WAN|WAR|WAT|WBS|WDA|WEL|WEN|WER|WES|WHV|WIL|WIS|WIT|WIZ|WLG|WMS|WND|WOB|WOH|WOL|WOR|WOS|WRN|WSF|WST|WSW|WTL|WTM|WUG|WÜM|WUN|WUR|WZL|ZEL|ZIG)[- ]?(([A-Z][- ]?\d{1,4})|([A-Z]{2}[- ]?\d{1,3})))[- ]?(E|H)?$/.test(o);
      },
      "de-LI": function(o) {
        return /^FL[- ]?\d{1,5}[UZ]?$/.test(o);
      },
      "en-IN": function(o) {
        return /^[A-Z]{2}[ -]?[0-9]{1,2}(?:[ -]?[A-Z])(?:[ -]?[A-Z]*)?[ -]?[0-9]{4}$/.test(o);
      },
      "en-SG": function(o) {
        return /^[A-Z]{3}[ -]?[\d]{4}[ -]?[A-Z]{1}$/.test(o);
      },
      "es-AR": function(o) {
        return /^(([A-Z]{2} ?[0-9]{3} ?[A-Z]{2})|([A-Z]{3} ?[0-9]{3}))$/.test(o);
      },
      "fi-FI": function(o) {
        return /^(?=.{4,7})(([A-Z]{1,3}|[0-9]{1,3})[\s-]?([A-Z]{1,3}|[0-9]{1,5}))$/.test(o);
      },
      "hu-HU": function(o) {
        return /^((((?!AAA)(([A-NPRSTVZWXY]{1})([A-PR-Z]{1})([A-HJ-NPR-Z]))|(A[ABC]I)|A[ABC]O|A[A-W]Q|BPI|BPO|UCO|UDO|XAO)-(?!000)\d{3})|(M\d{6})|((CK|DT|CD|HC|H[ABEFIKLMNPRSTVX]|MA|OT|R[A-Z]) \d{2}-\d{2})|(CD \d{3}-\d{3})|(C-(C|X) \d{4})|(X-(A|B|C) \d{4})|(([EPVZ]-\d{5}))|(S A[A-Z]{2} \d{2})|(SP \d{2}-\d{2}))$/.test(o);
      },
      "pt-BR": function(o) {
        return /^[A-Z]{3}[ -]?[0-9][A-Z][0-9]{2}|[A-Z]{3}[ -]?[0-9]{4}$/.test(o);
      },
      "pt-PT": function(o) {
        return /^([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})[ -·]?([A-Z]{2}|[0-9]{2})$/.test(o);
      },
      "sq-AL": function(o) {
        return /^[A-Z]{2}[- ]?((\d{3}[- ]?(([A-Z]{2})|T))|(R[- ]?\d{3}))$/.test(o);
      },
      "sv-SE": function(o) {
        return /^[A-HJ-PR-UW-Z]{3} ?[\d]{2}[A-HJ-PR-UW-Z1-9]$|(^[A-ZÅÄÖ ]{2,7}$)/.test(o.trim());
      },
      "en-PK": function(o) {
        return /(^[A-Z]{2}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{3}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]{4}((\s|-){0,1})[0-9]{3,4}((\s|-)[0-9]{2}){0,1}$)|(^[A-Z]((\s|-){0,1})[0-9]{4}((\s|-)[0-9]{2}){0,1}$)/.test(o.trim());
      }
    };
    function a(o, u) {
      if ((0, r.default)(o), u in d)
        return d[u](o);
      if (u === "any") {
        for (var i in d) {
          var s = d[i];
          if (s(o))
            return !0;
        }
        return !1;
      }
      throw new Error("Invalid locale '".concat(u, "'"));
    }
    e.exports = t.default, e.exports.default = t.default;
  }(F0, F0.exports)), F0.exports;
}
var Z0 = { exports: {} }, a1;
function Of() {
  return a1 || (a1 = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = b;
    var r = d(/* @__PURE__ */ ot()), n = d(/* @__PURE__ */ L());
    function d(m) {
      return m && m.__esModule ? m : { default: m };
    }
    var a = /^[A-Z]$/, o = /^[a-z]$/, u = /^[0-9]$/, i = /^[-#!$@£%^&*()_+|~=`{}\[\]:";'<>?,.\/\\ ]$/, s = {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
      returnScore: !1,
      pointsPerUnique: 1,
      pointsPerRepeat: 0.5,
      pointsForContainingLower: 10,
      pointsForContainingUpper: 10,
      pointsForContainingNumber: 10,
      pointsForContainingSymbol: 10
    };
    function c(m) {
      var f = {};
      return Array.from(m).forEach(function(v) {
        var h = f[v];
        h ? f[v] += 1 : f[v] = 1;
      }), f;
    }
    function l(m) {
      var f = c(m), v = {
        length: m.length,
        uniqueChars: Object.keys(f).length,
        uppercaseCount: 0,
        lowercaseCount: 0,
        numberCount: 0,
        symbolCount: 0
      };
      return Object.keys(f).forEach(function(h) {
        a.test(h) ? v.uppercaseCount += f[h] : o.test(h) ? v.lowercaseCount += f[h] : u.test(h) ? v.numberCount += f[h] : i.test(h) && (v.symbolCount += f[h]);
      }), v;
    }
    function $(m, f) {
      var v = 0;
      return v += m.uniqueChars * f.pointsPerUnique, v += (m.length - m.uniqueChars) * f.pointsPerRepeat, m.lowercaseCount > 0 && (v += f.pointsForContainingLower), m.uppercaseCount > 0 && (v += f.pointsForContainingUpper), m.numberCount > 0 && (v += f.pointsForContainingNumber), m.symbolCount > 0 && (v += f.pointsForContainingSymbol), v;
    }
    function b(m) {
      var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      (0, n.default)(m);
      var v = l(m);
      return f = (0, r.default)(f || {}, s), f.returnScore ? $(v, f) : v.length >= f.minLength && v.lowercaseCount >= f.minLowercase && v.uppercaseCount >= f.minUppercase && v.numberCount >= f.minNumbers && v.symbolCount >= f.minSymbols;
    }
    e.exports = t.default, e.exports.default = t.default;
  }(Z0, Z0.exports)), Z0.exports;
}
var oe = {}, o1;
function xf() {
  if (o1) return oe;
  o1 = 1;
  function e(l) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function($) {
      return typeof $;
    } : function($) {
      return $ && typeof Symbol == "function" && $.constructor === Symbol && $ !== Symbol.prototype ? "symbol" : typeof $;
    }, e(l);
  }
  Object.defineProperty(oe, "__esModule", {
    value: !0
  }), oe.default = c, oe.vatMatchers = void 0;
  var t = a(/* @__PURE__ */ L()), r = d(/* @__PURE__ */ ts());
  function n(l) {
    if (typeof WeakMap != "function") return null;
    var $ = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (n = function(m) {
      return m ? b : $;
    })(l);
  }
  function d(l, $) {
    if (l && l.__esModule) return l;
    if (l === null || e(l) != "object" && typeof l != "function") return { default: l };
    var b = n($);
    if (b && b.has(l)) return b.get(l);
    var m = { __proto__: null }, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in l) if (v !== "default" && {}.hasOwnProperty.call(l, v)) {
      var h = f ? Object.getOwnPropertyDescriptor(l, v) : null;
      h && (h.get || h.set) ? Object.defineProperty(m, v, h) : m[v] = l[v];
    }
    return m.default = l, b && b.set(l, m), m;
  }
  function a(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var o = function(l) {
    var $ = l.match(/^(AU)?(\d{11})$/);
    if (!$)
      return !1;
    var b = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
    l = l.replace(/^AU/, "");
    for (var m = (parseInt(l.slice(0, 1), 10) - 1).toString() + l.slice(1), f = 0, v = 0; v < 11; v++)
      f += b[v] * m.charAt(v);
    return f !== 0 && f % 89 === 0;
  }, u = function(l) {
    var $ = function(b) {
      var m = b.pop(), f = [5, 4, 3, 2, 7, 6, 5, 4], v = (11 - b.reduce(function(h, _, O) {
        return h + _ * f[O];
      }, 0) % 11) % 11;
      return m === v;
    };
    return /^(CHE[- ]?)?(\d{9}|(\d{3}\.\d{3}\.\d{3})|(\d{3} \d{3} \d{3})) ?(TVA|MWST|IVA)?$/.test(l) && $(l.match(/\d/g).map(function(b) {
      return +b;
    }));
  }, i = function(l) {
    var $ = l.match(/^(PT)?(\d{9})$/);
    if (!$)
      return !1;
    var b = $[2], m = 11 - r.reverseMultiplyAndSum(b.split("").slice(0, 8).map(function(f) {
      return parseInt(f, 10);
    }), 9) % 11;
    return m > 9 ? parseInt(b[8], 10) === 0 : m === parseInt(b[8], 10);
  }, s = oe.vatMatchers = {
    /**
     * European Union VAT identification numbers
     */
    AT: function(l) {
      return /^(AT)?U\d{8}$/.test(l);
    },
    BE: function(l) {
      return /^(BE)?\d{10}$/.test(l);
    },
    BG: function(l) {
      return /^(BG)?\d{9,10}$/.test(l);
    },
    HR: function(l) {
      return /^(HR)?\d{11}$/.test(l);
    },
    CY: function(l) {
      return /^(CY)?\w{9}$/.test(l);
    },
    CZ: function(l) {
      return /^(CZ)?\d{8,10}$/.test(l);
    },
    DK: function(l) {
      return /^(DK)?\d{8}$/.test(l);
    },
    EE: function(l) {
      return /^(EE)?\d{9}$/.test(l);
    },
    FI: function(l) {
      return /^(FI)?\d{8}$/.test(l);
    },
    FR: function(l) {
      return /^(FR)?\w{2}\d{9}$/.test(l);
    },
    DE: function(l) {
      return /^(DE)?\d{9}$/.test(l);
    },
    EL: function(l) {
      return /^(EL)?\d{9}$/.test(l);
    },
    HU: function(l) {
      return /^(HU)?\d{8}$/.test(l);
    },
    IE: function(l) {
      return /^(IE)?\d{7}\w{1}(W)?$/.test(l);
    },
    IT: function(l) {
      return /^(IT)?\d{11}$/.test(l);
    },
    LV: function(l) {
      return /^(LV)?\d{11}$/.test(l);
    },
    LT: function(l) {
      return /^(LT)?\d{9,12}$/.test(l);
    },
    LU: function(l) {
      return /^(LU)?\d{8}$/.test(l);
    },
    MT: function(l) {
      return /^(MT)?\d{8}$/.test(l);
    },
    NL: function(l) {
      return /^(NL)?\d{9}B\d{2}$/.test(l);
    },
    PL: function(l) {
      return /^(PL)?(\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3}))$/.test(l);
    },
    PT: i,
    RO: function(l) {
      return /^(RO)?\d{2,10}$/.test(l);
    },
    SK: function(l) {
      return /^(SK)?\d{10}$/.test(l);
    },
    SI: function(l) {
      return /^(SI)?\d{8}$/.test(l);
    },
    ES: function(l) {
      return /^(ES)?\w\d{7}[A-Z]$/.test(l);
    },
    SE: function(l) {
      return /^(SE)?\d{12}$/.test(l);
    },
    /**
     * VAT numbers of non-EU countries
     */
    AL: function(l) {
      return /^(AL)?\w{9}[A-Z]$/.test(l);
    },
    MK: function(l) {
      return /^(MK)?\d{13}$/.test(l);
    },
    AU: o,
    BY: function(l) {
      return /^(УНП )?\d{9}$/.test(l);
    },
    CA: function(l) {
      return /^(CA)?\d{9}$/.test(l);
    },
    IS: function(l) {
      return /^(IS)?\d{5,6}$/.test(l);
    },
    IN: function(l) {
      return /^(IN)?\d{15}$/.test(l);
    },
    ID: function(l) {
      return /^(ID)?(\d{15}|(\d{2}.\d{3}.\d{3}.\d{1}-\d{3}.\d{3}))$/.test(l);
    },
    IL: function(l) {
      return /^(IL)?\d{9}$/.test(l);
    },
    KZ: function(l) {
      return /^(KZ)?\d{12}$/.test(l);
    },
    NZ: function(l) {
      return /^(NZ)?\d{9}$/.test(l);
    },
    NG: function(l) {
      return /^(NG)?(\d{12}|(\d{8}-\d{4}))$/.test(l);
    },
    NO: function(l) {
      return /^(NO)?\d{9}MVA$/.test(l);
    },
    PH: function(l) {
      return /^(PH)?(\d{12}|\d{3} \d{3} \d{3} \d{3})$/.test(l);
    },
    RU: function(l) {
      return /^(RU)?(\d{10}|\d{12})$/.test(l);
    },
    SM: function(l) {
      return /^(SM)?\d{5}$/.test(l);
    },
    SA: function(l) {
      return /^(SA)?\d{15}$/.test(l);
    },
    RS: function(l) {
      return /^(RS)?\d{9}$/.test(l);
    },
    CH: u,
    TR: function(l) {
      return /^(TR)?\d{10}$/.test(l);
    },
    UA: function(l) {
      return /^(UA)?\d{12}$/.test(l);
    },
    GB: function(l) {
      return /^GB((\d{3} \d{4} ([0-8][0-9]|9[0-6]))|(\d{9} \d{3})|(((GD[0-4])|(HA[5-9]))[0-9]{2}))$/.test(l);
    },
    UZ: function(l) {
      return /^(UZ)?\d{9}$/.test(l);
    },
    /**
     * VAT numbers of Latin American countries
     */
    AR: function(l) {
      return /^(AR)?\d{11}$/.test(l);
    },
    BO: function(l) {
      return /^(BO)?\d{7}$/.test(l);
    },
    BR: function(l) {
      return /^(BR)?((\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{3}.\d{3}.\d{3}-\d{2}))$/.test(l);
    },
    CL: function(l) {
      return /^(CL)?\d{8}-\d{1}$/.test(l);
    },
    CO: function(l) {
      return /^(CO)?\d{10}$/.test(l);
    },
    CR: function(l) {
      return /^(CR)?\d{9,12}$/.test(l);
    },
    EC: function(l) {
      return /^(EC)?\d{13}$/.test(l);
    },
    SV: function(l) {
      return /^(SV)?\d{4}-\d{6}-\d{3}-\d{1}$/.test(l);
    },
    GT: function(l) {
      return /^(GT)?\d{7}-\d{1}$/.test(l);
    },
    HN: function(l) {
      return /^(HN)?$/.test(l);
    },
    MX: function(l) {
      return /^(MX)?\w{3,4}\d{6}\w{3}$/.test(l);
    },
    NI: function(l) {
      return /^(NI)?\d{3}-\d{6}-\d{4}\w{1}$/.test(l);
    },
    PA: function(l) {
      return /^(PA)?$/.test(l);
    },
    PY: function(l) {
      return /^(PY)?\d{6,8}-\d{1}$/.test(l);
    },
    PE: function(l) {
      return /^(PE)?\d{11}$/.test(l);
    },
    DO: function(l) {
      return /^(DO)?(\d{11}|(\d{3}-\d{7}-\d{1})|[1,4,5]{1}\d{8}|([1,4,5]{1})-\d{2}-\d{5}-\d{1})$/.test(l);
    },
    UY: function(l) {
      return /^(UY)?\d{12}$/.test(l);
    },
    VE: function(l) {
      return /^(VE)?[J,G,V,E]{1}-(\d{9}|(\d{8}-\d{1}))$/.test(l);
    }
  };
  function c(l, $) {
    if ((0, t.default)(l), (0, t.default)($), $ in s)
      return s[$](l);
    throw new Error("Invalid country code: '".concat($, "'"));
  }
  return oe;
}
var u1;
function Ef() {
  return u1 || (u1 = 1, function(e, t) {
    function r(et) {
      "@babel/helpers - typeof";
      return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(yt) {
        return typeof yt;
      } : function(yt) {
        return yt && typeof Symbol == "function" && yt.constructor === Symbol && yt !== Symbol.prototype ? "symbol" : typeof yt;
      }, r(et);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = w(/* @__PURE__ */ vn()), d = w(/* @__PURE__ */ ao()), a = w(/* @__PURE__ */ q6()), o = w(/* @__PURE__ */ tf()), u = w(/* @__PURE__ */ ef()), i = w(/* @__PURE__ */ _o()), s = w(/* @__PURE__ */ bu()), c = w(/* @__PURE__ */ en()), l = w(/* @__PURE__ */ ru()), $ = w(/* @__PURE__ */ p2()), b = w(/* @__PURE__ */ Ie()), m = w(/* @__PURE__ */ rf()), f = w(/* @__PURE__ */ Ve()), v = w(/* @__PURE__ */ qi()), h = w(/* @__PURE__ */ nf()), _ = w(/* @__PURE__ */ Hu()), O = w(/* @__PURE__ */ Oi()), y = w(/* @__PURE__ */ df()), M = Tt(/* @__PURE__ */ Eo()), N = Tt(/* @__PURE__ */ Po()), D = w(/* @__PURE__ */ Wu()), x = Tt(/* @__PURE__ */ ji()), A = w(/* @__PURE__ */ y2()), S = w(/* @__PURE__ */ D2()), P = w(/* @__PURE__ */ lu()), Z = w(/* @__PURE__ */ af()), G = w(/* @__PURE__ */ Bo()), K = w(/* @__PURE__ */ rn()), Y = w(/* @__PURE__ */ nn()), it = w(/* @__PURE__ */ o2()), V = w(/* @__PURE__ */ X2()), At = w(/* @__PURE__ */ Xi()), $t = w(/* @__PURE__ */ q2()), It = w(/* @__PURE__ */ an()), st = Tt(/* @__PURE__ */ no()), Pt = w(/* @__PURE__ */ wo()), ct = w(/* @__PURE__ */ dn()), mt = w(/* @__PURE__ */ Ri()), Ot = w(/* @__PURE__ */ oo()), fe = w(/* @__PURE__ */ s2()), $e = w(/* @__PURE__ */ Wi()), pe = w(/* @__PURE__ */ pi()), ve = w(/* @__PURE__ */ Mi()), Zt = Tt(/* @__PURE__ */ mi()), F = w(/* @__PURE__ */ qu()), k = w(/* @__PURE__ */ of()), z = w(/* @__PURE__ */ Du()), dt = w(/* @__PURE__ */ T2()), Oe = w(/* @__PURE__ */ N2()), Ut = w(/* @__PURE__ */ uf()), Ye = w(/* @__PURE__ */ $u()), p = w(/* @__PURE__ */ tn()), g = w(/* @__PURE__ */ sf()), I = w(/* @__PURE__ */ au()), T = w(/* @__PURE__ */ W2()), R = w(/* @__PURE__ */ lf()), B = w(/* @__PURE__ */ cf()), U = w(/* @__PURE__ */ ff()), H = w(/* @__PURE__ */ Ho()), W = w(/* @__PURE__ */ Vo()), tt = w(/* @__PURE__ */ bi()), Lt = w(/* @__PURE__ */ ii()), _t = w(/* @__PURE__ */ I2()), gt = w(/* @__PURE__ */ _2()), he = w(/* @__PURE__ */ Fu()), xe = w(/* @__PURE__ */ es()), xt = Tt(/* @__PURE__ */ F2()), Gt = w(/* @__PURE__ */ ci()), Ee = w(/* @__PURE__ */ Yo()), zs = w(/* @__PURE__ */ ri()), mn = /* @__PURE__ */ $f(), Xs = w(/* @__PURE__ */ pf()), Qs = w(/* @__PURE__ */ E2()), Js = w(/* @__PURE__ */ Hi()), qs = w(/* @__PURE__ */ vf()), t9 = w(/* @__PURE__ */ un()), e9 = w(/* @__PURE__ */ H2()), r9 = w(/* @__PURE__ */ hf()), n9 = w(/* @__PURE__ */ rs()), d9 = w(/* @__PURE__ */ Xu()), a9 = w(/* @__PURE__ */ ns()), o9 = w(/* @__PURE__ */ q0()), u9 = w(/* @__PURE__ */ ai()), i9 = w(/* @__PURE__ */ Ci()), s9 = w(/* @__PURE__ */ mf()), l9 = w(/* @__PURE__ */ Li()), c9 = w(/* @__PURE__ */ j1()), gn = Tt(/* @__PURE__ */ Ui()), f9 = w(/* @__PURE__ */ as()), $9 = w(/* @__PURE__ */ ds()), p9 = w(/* @__PURE__ */ os()), v9 = w(/* @__PURE__ */ gf()), h9 = w(/* @__PURE__ */ yf()), m9 = w(/* @__PURE__ */ bf()), g9 = w(/* @__PURE__ */ Af()), y9 = w(/* @__PURE__ */ us()), b9 = w(/* @__PURE__ */ _f()), A9 = w(/* @__PURE__ */ Mf()), _9 = w(/* @__PURE__ */ Sf()), M9 = w(/* @__PURE__ */ If()), S9 = w(/* @__PURE__ */ Of()), I9 = w(/* @__PURE__ */ xf());
    function yn(et) {
      if (typeof WeakMap != "function") return null;
      var yt = /* @__PURE__ */ new WeakMap(), wt = /* @__PURE__ */ new WeakMap();
      return (yn = function(Rt) {
        return Rt ? wt : yt;
      })(et);
    }
    function Tt(et, yt) {
      if (et && et.__esModule) return et;
      if (et === null || r(et) != "object" && typeof et != "function") return { default: et };
      var wt = yn(yt);
      if (wt && wt.has(et)) return wt.get(et);
      var Rt = { __proto__: null }, E9 = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var kt in et) if (kt !== "default" && {}.hasOwnProperty.call(et, kt)) {
        var Ce = E9 ? Object.getOwnPropertyDescriptor(et, kt) : null;
        Ce && (Ce.get || Ce.set) ? Object.defineProperty(Rt, kt, Ce) : Rt[kt] = et[kt];
      }
      return Rt.default = et, wt && wt.set(et, Rt), Rt;
    }
    function w(et) {
      return et && et.__esModule ? et : { default: et };
    }
    var O9 = "13.15.0", x9 = {
      version: O9,
      toDate: n.default,
      toFloat: d.default,
      toInt: a.default,
      toBoolean: o.default,
      equals: u.default,
      contains: i.default,
      matches: s.default,
      isEmail: c.default,
      isURL: l.default,
      isMACAddress: $.default,
      isIP: b.default,
      isIPRange: m.default,
      isFQDN: f.default,
      isBoolean: _.default,
      isIBAN: Zt.default,
      isBIC: F.default,
      isAbaRouting: y.default,
      isAlpha: M.default,
      isAlphaLocales: M.locales,
      isAlphanumeric: N.default,
      isAlphanumericLocales: N.locales,
      isNumeric: D.default,
      isPassportNumber: x.default,
      passportNumberLocales: x.locales,
      isPort: A.default,
      isLowercase: S.default,
      isUppercase: P.default,
      isAscii: G.default,
      isFullWidth: K.default,
      isHalfWidth: Y.default,
      isVariableWidth: it.default,
      isMultibyte: V.default,
      isSemVer: At.default,
      isSurrogatePair: $t.default,
      isInt: It.default,
      isIMEI: Z.default,
      isFloat: st.default,
      isFloatLocales: st.locales,
      isDecimal: Pt.default,
      isHexadecimal: ct.default,
      isOctal: mt.default,
      isDivisibleBy: Ot.default,
      isHexColor: fe.default,
      isRgbColor: $e.default,
      isHSL: pe.default,
      isISRC: ve.default,
      isMD5: k.default,
      isHash: z.default,
      isJWT: dt.default,
      isJSON: Oe.default,
      isEmpty: Ut.default,
      isLength: Ye.default,
      isLocale: O.default,
      isByteLength: p.default,
      isULID: g.default,
      isUUID: I.default,
      isMongoId: T.default,
      isAfter: R.default,
      isBefore: B.default,
      isIn: U.default,
      isLuhnNumber: H.default,
      isCreditCard: W.default,
      isIdentityCard: tt.default,
      isEAN: Lt.default,
      isISIN: _t.default,
      isISBN: gt.default,
      isISSN: he.default,
      isMobilePhone: xt.default,
      isMobilePhoneLocales: xt.locales,
      isPostalCode: gn.default,
      isPostalCodeLocales: gn.locales,
      isEthereumAddress: Gt.default,
      isCurrency: Ee.default,
      isBtcAddress: zs.default,
      isISO6346: mn.isISO6346,
      isFreightContainerID: mn.isFreightContainerID,
      isISO6391: Xs.default,
      isISO8601: Qs.default,
      isISO15924: qs.default,
      isRFC3339: Js.default,
      isISO31661Alpha2: t9.default,
      isISO31661Alpha3: e9.default,
      isISO31661Numeric: r9.default,
      isISO4217: n9.default,
      isBase32: d9.default,
      isBase58: a9.default,
      isBase64: o9.default,
      isDataURI: u9.default,
      isMagnetURI: i9.default,
      isMailtoURI: s9.default,
      isMimeType: l9.default,
      isLatLong: c9.default,
      ltrim: f9.default,
      rtrim: $9.default,
      trim: p9.default,
      escape: v9.default,
      unescape: h9.default,
      stripLow: m9.default,
      whitelist: g9.default,
      blacklist: y9.default,
      isWhitelisted: b9.default,
      normalizeEmail: A9.default,
      toString,
      isSlug: _9.default,
      isStrongPassword: S9.default,
      isTaxID: xe.default,
      isDate: v.default,
      isTime: h.default,
      isLicensePlate: M9.default,
      isVAT: I9.default,
      ibanLocales: Zt.locales
    };
    t.default = x9, e.exports = t.default, e.exports.default = t.default;
  }(u0, u0.exports)), u0.exports;
}
var Cf = /* @__PURE__ */ Ef(), is = "isStrongPassword";
function ss(e, t) {
  return typeof e == "string" && Cf.isStrongPassword(e, t);
}
function Nf(e, t) {
  return C({
    name: is,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ss(r, n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property is not strong enough";
      }, t)
    }
  }, t);
}
var ls = "isTimeZone";
function cs(e) {
  try {
    return typeof e != "string" ? !1 : (Intl.DateTimeFormat(void 0, { timeZone: e }), !0);
  } catch {
    return !1;
  }
}
function Pf(e) {
  return C({
    name: ls,
    validator: {
      validate: function(t, r) {
        return cs(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a valid IANA time-zone";
      }, e)
    }
  }, e);
}
var Lf = /* @__PURE__ */ ns();
const Tf = /* @__PURE__ */ j(Lf);
var fs = "isBase58";
function $s(e) {
  return typeof e == "string" && Tf(e);
}
function wf(e) {
  return C({
    name: fs,
    validator: {
      validate: function(t, r) {
        return $s(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be base58 encoded";
      }, e)
    }
  }, e);
}
var Rf = /* @__PURE__ */ es();
const Df = /* @__PURE__ */ j(Rf);
var ps = "isTaxId";
function vs(e, t) {
  return typeof e == "string" && Df(e, t || "en-US");
}
function Bf(e, t) {
  return C({
    name: ps,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return vs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a Tax Identification Number";
      }, t)
    }
  }, t);
}
var jf = /* @__PURE__ */ rs();
const Ff = /* @__PURE__ */ j(jf);
var hs = "isISO4217CurrencyCode";
function ms(e) {
  return typeof e == "string" && Ff(e);
}
function Zf(e) {
  return C({
    name: hs,
    validator: {
      validate: function(t, r) {
        return ms(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a valid ISO4217 currency code";
      }, e)
    }
  }, e);
}
var gs = "isBoolean";
function ys(e) {
  return e instanceof Boolean || typeof e == "boolean";
}
function Uf(e) {
  return C({
    name: gs,
    validator: {
      validate: function(t, r) {
        return ys(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a boolean value";
      }, e)
    }
  }, e);
}
var bs = "isDate";
function As(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
function Gf(e) {
  return C({
    name: bs,
    validator: {
      validate: function(t, r) {
        return As(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a Date instance";
      }, e)
    }
  }, e);
}
var _s = "isNumber";
function Ms(e, t) {
  if (t === void 0 && (t = {}), typeof e != "number")
    return !1;
  if (e === 1 / 0 || e === -1 / 0)
    return !!t.allowInfinity;
  if (Number.isNaN(e))
    return !!t.allowNaN;
  if (t.maxDecimalPlaces !== void 0) {
    var r = 0;
    if (e % 1 !== 0 && (r = e.toString().split(".")[1].length), r > t.maxDecimalPlaces)
      return !1;
  }
  return Number.isFinite(e);
}
function kf(e, t) {
  return e === void 0 && (e = {}), C({
    name: _s,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Ms(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a number conforming to the specified constraints";
      }, t)
    }
  }, t);
}
var i1 = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), d, a = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(d = n.next()).done; ) a.push(d.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      d && !d.done && (r = n.return) && r.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}, Ss = "isEnum";
function Is(e, t) {
  var r = Object.keys(t).map(function(n) {
    return t[n];
  });
  return r.includes(e);
}
function Hf(e) {
  return Object.entries(e).filter(function(t) {
    var r = i1(t, 2), n = r[0];
    return r[1], isNaN(parseInt(n));
  }).map(function(t) {
    var r = i1(t, 2);
    r[0];
    var n = r[1];
    return n;
  });
}
function Vf(e, t) {
  return C({
    name: Ss,
    constraints: [e, Hf(e)],
    validator: {
      validate: function(r, n) {
        return Is(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be one of the following values: $constraint2";
      }, t)
    }
  }, t);
}
var Os = "isInt";
function xs(e) {
  return typeof e == "number" && Number.isInteger(e);
}
function Kf(e) {
  return C({
    name: Os,
    validator: {
      validate: function(t, r) {
        return xs(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an integer number";
      }, e)
    }
  }, e);
}
var Es = "isString";
function Cs(e) {
  return e instanceof String || typeof e == "string";
}
function Wf(e) {
  return C({
    name: Es,
    validator: {
      validate: function(t, r) {
        return Cs(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be a string";
      }, e)
    }
  }, e);
}
var Ns = "isArray";
function Ps(e) {
  return Array.isArray(e);
}
function Yf(e) {
  return C({
    name: Ns,
    validator: {
      validate: function(t, r) {
        return Ps(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an array";
      }, e)
    }
  }, e);
}
var Ls = "isObject";
function hn(e) {
  return e != null && (typeof e == "object" || typeof e == "function") && !Array.isArray(e);
}
function zf(e) {
  return C({
    name: Ls,
    validator: {
      validate: function(t, r) {
        return hn(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property must be an object";
      }, e)
    }
  }, e);
}
var Ts = "arrayContains";
function ws(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) !== -1;
  }) : !1;
}
function Xf(e, t) {
  return C({
    name: Ts,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return ws(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must contain $constraint1 values";
      }, t)
    }
  }, t);
}
var Rs = "arrayNotContains";
function Ds(e, t) {
  return Array.isArray(e) ? t.every(function(r) {
    return e.indexOf(r) === -1;
  }) : !1;
}
function Qf(e, t) {
  return C({
    name: Rs,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Ds(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property should not contain $constraint1 values";
      }, t)
    }
  }, t);
}
var Bs = "arrayNotEmpty";
function js(e) {
  return Array.isArray(e) && e.length > 0;
}
function Jf(e) {
  return C({
    name: Bs,
    validator: {
      validate: function(t, r) {
        return js(t);
      },
      defaultMessage: E(function(t) {
        return t + "$property should not be empty";
      }, e)
    }
  }, e);
}
var Fs = "arrayMinSize";
function Zs(e, t) {
  return Array.isArray(e) && e.length >= t;
}
function qf(e, t) {
  return C({
    name: Fs,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Zs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must contain at least $constraint1 elements";
      }, t)
    }
  }, t);
}
var Us = "arrayMaxSize";
function Gs(e, t) {
  return Array.isArray(e) && e.length <= t;
}
function t5(e, t) {
  return C({
    name: Us,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Gs(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must contain no more than $constraint1 elements";
      }, t)
    }
  }, t);
}
var ks = "arrayUnique";
function Hs(e, t) {
  if (!Array.isArray(e))
    return !1;
  t && (e = e.map(function(n) {
    return n != null ? t(n) : n;
  }));
  var r = e.filter(function(n, d, a) {
    return a.indexOf(n) === d;
  });
  return e.length === r.length;
}
function e5(e, t) {
  var r = typeof e == "function" ? e : void 0, n = typeof e != "function" ? e : t;
  return C({
    name: ks,
    validator: {
      validate: function(d, a) {
        return Hs(d, r);
      },
      defaultMessage: E(function(d) {
        return d + "All $property's elements must be unique";
      }, n)
    }
  }, n);
}
var Vs = "isNotEmptyObject";
function Ks(e, t) {
  if (!hn(e))
    return !1;
  if ((t == null ? void 0 : t.nullable) === !1)
    return !Object.values(e).every(function(n) {
      return n == null;
    });
  for (var r in e)
    if (e.hasOwnProperty(r))
      return !0;
  return !1;
}
function r5(e, t) {
  return C({
    name: Vs,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Ks(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r) {
        return r + "$property must be a non-empty object";
      }, t)
    }
  }, t);
}
var Q0 = "isInstance";
function Ws(e, t) {
  return t && typeof t == "function" && e instanceof t;
}
function n5(e, t) {
  return C({
    name: Q0,
    constraints: [e],
    validator: {
      validate: function(r, n) {
        return Ws(r, n == null ? void 0 : n.constraints[0]);
      },
      defaultMessage: E(function(r, n) {
        return n != null && n.constraints[0] ? r + "$property must be an instance of ".concat(n == null ? void 0 : n.constraints[0].name) : r + "".concat(Q0, " decorator expects and object as value, but got falsy value.");
      }, t)
    }
  }, t);
}
function d5(e, t, r) {
  return typeof e == "string" ? Mt(Ft).validate(e, t, r) : Mt(Ft).validate(e, t);
}
function a5(e, t, r) {
  return typeof e == "string" ? Mt(Ft).validateOrReject(e, t, r) : Mt(Ft).validateOrReject(e, t);
}
function o5(e, t, r) {
  return typeof e == "string" ? Mt(Ft).validateSync(e, t, r) : Mt(Ft).validateSync(e, t);
}
function u5(e) {
  ft().addValidationSchema(e);
}
const i5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARRAY_CONTAINS: Ts,
  ARRAY_MAX_SIZE: Us,
  ARRAY_MIN_SIZE: Fs,
  ARRAY_NOT_CONTAINS: Rs,
  ARRAY_NOT_EMPTY: Bs,
  ARRAY_UNIQUE: ks,
  Allow: n3,
  ArrayContains: Xf,
  ArrayMaxSize: t5,
  ArrayMinSize: qf,
  ArrayNotContains: Qf,
  ArrayNotEmpty: Jf,
  ArrayUnique: e5,
  CONTAINS: So,
  Contains: L3,
  EQUALS: H1,
  Equals: h3,
  IS_ALPHA: Co,
  IS_ALPHANUMERIC: Lo,
  IS_ARRAY: Ns,
  IS_ASCII: jo,
  IS_BASE32: Qu,
  IS_BASE58: fs,
  IS_BASE64: Zo,
  IS_BIC: ti,
  IS_BOOLEAN: gs,
  IS_BOOLEAN_STRING: Vu,
  IS_BTC_ADDRESS: ni,
  IS_BYTE_LENGTH: Go,
  IS_CREDIT_CARD: Ko,
  IS_CURRENCY: zo,
  IS_DATA_URI: oi,
  IS_DATE: bs,
  IS_DATE_STRING: Gu,
  IS_DECIMAL: Ro,
  IS_DEFINED: R1,
  IS_DIVISIBLE_BY: uo,
  IS_EAN: si,
  IS_EMAIL: Jo,
  IS_EMPTY: Y1,
  IS_ENUM: Ss,
  IS_ETHEREUM_ADDRESS: fi,
  IS_FIREBASE_PUSH_ID: iu,
  IS_FQDN: t2,
  IS_FULL_WIDTH: r2,
  IS_HALF_WIDTH: d2,
  IS_HASH: Bu,
  IS_HEXADECIMAL: f2,
  IS_HEX_COLOR: l2,
  IS_HSL: vi,
  IS_IBAN: gi,
  IS_IDENTITY_CARD: Ai,
  IS_IN: J1,
  IS_INSTANCE: Q0,
  IS_INT: Os,
  IS_IP: m2,
  IS_ISBN: M2,
  IS_ISIN: O2,
  IS_ISO31661_ALPHA_2: G2,
  IS_ISO31661_ALPHA_3: V2,
  IS_ISO4217_CURRENCY_CODE: hs,
  IS_ISO8601: C2,
  IS_ISRC: Si,
  IS_ISSN: Zu,
  IS_JSON: P2,
  IS_JWT: w2,
  IS_LATITUDE: Z1,
  IS_LATLONG: F1,
  IS_LENGTH: pu,
  IS_LOCALE: xi,
  IS_LONGITUDE: G1,
  IS_LOWERCASE: B2,
  IS_MAC_ADDRESS: v2,
  IS_MAGNET_URI: Ni,
  IS_MILITARY_TIME: wu,
  IS_MIME_TYPE: Ti,
  IS_MOBILE_PHONE: Z2,
  IS_MONGO_ID: Y2,
  IS_MULTIBYTE: Q2,
  IS_NEGATIVE: co,
  IS_NOT_EMPTY: X1,
  IS_NOT_EMPTY_OBJECT: Vs,
  IS_NOT_IN: to,
  IS_NUMBER: _s,
  IS_NUMBER_STRING: Yu,
  IS_OBJECT: Ls,
  IS_OCTAL: Di,
  IS_OPTIONAL: B1,
  IS_PASSPORT_NUMBER: Fi,
  IS_PHONE_NUMBER: Lu,
  IS_PORT: b2,
  IS_POSITIVE: so,
  IS_POSTAL_CODE: Gi,
  IS_RFC_3339: Vi,
  IS_RGB_COLOR: Yi,
  IS_SEM_VER: Qi,
  IS_STRING: Es,
  IS_STRONG_PASSWORD: is,
  IS_SURROGATE_PAIR: tu,
  IS_TAX_ID: ps,
  IS_TIMEZONE: ls,
  IS_UPPERCASE: cu,
  IS_URL: nu,
  IS_UUID: ou,
  IS_VARIABLE_WIDTH: u2,
  IsAlpha: D3,
  IsAlphanumeric: F3,
  IsArray: Yf,
  IsAscii: K3,
  IsBIC: t6,
  IsBase32: Q8,
  IsBase58: wf,
  IsBase64: z3,
  IsBoolean: Uf,
  IsBooleanString: V8,
  IsBtcAddress: n6,
  IsByteLength: J3,
  IsCreditCard: el,
  IsCurrency: dl,
  IsDataURI: o6,
  IsDate: Gf,
  IsDateString: G8,
  IsDecimal: k3,
  IsDefined: d3,
  IsDivisibleBy: S3,
  IsEAN: s6,
  IsEmail: ul,
  IsEmpty: g3,
  IsEnum: Vf,
  IsEthereumAddress: f6,
  IsFQDN: ll,
  IsFirebasePushId: M4,
  IsFullWidth: $l,
  IsHSL: v6,
  IsHalfWidth: hl,
  IsHash: j8,
  IsHexColor: _l,
  IsHexadecimal: Il,
  IsIBAN: g6,
  IsIP: Pl,
  IsISBN: Bl,
  IsISIN: Zl,
  IsISO31661Alpha2: d4,
  IsISO31661Alpha3: u4,
  IsISO4217CurrencyCode: Zf,
  IsISO8601: kl,
  IsISRC: S6,
  IsISSN: U8,
  IsIdentityCard: A6,
  IsIn: b3,
  IsInstance: n5,
  IsInt: Kf,
  IsJSON: Kl,
  IsJWT: zl,
  IsLatLong: $3,
  IsLatitude: p3,
  IsLocale: x6,
  IsLongitude: v3,
  IsLowercase: Jl,
  IsMACAddress: El,
  IsMagnetURI: N6,
  IsMilitaryTime: R8,
  IsMimeType: T6,
  IsMobilePhone: e4,
  IsMongoId: l4,
  IsMultibyte: $4,
  IsNegative: O3,
  IsNotEmpty: y3,
  IsNotEmptyObject: r5,
  IsNotIn: A3,
  IsNumber: kf,
  IsNumberString: Y8,
  IsObject: zf,
  IsOctal: D6,
  IsOptional: a3,
  IsPassportNumber: F6,
  IsPhoneNumber: w8,
  IsPort: wl,
  IsPositive: I3,
  IsPostalCode: G6,
  IsRFC3339: V6,
  IsRgbColor: Y6,
  IsSemVer: J6,
  IsString: Wf,
  IsStrongPassword: Nf,
  IsSurrogatePair: h4,
  IsTaxId: Bf,
  IsTimeZone: Pf,
  IsUUID: _4,
  IsUppercase: O4,
  IsUrl: y4,
  IsVariableWidth: yl,
  Length: E4,
  MATCHES: _u,
  MAX: $o,
  MAX_DATE: yo,
  MAX_LENGTH: hu,
  MIN: vo,
  MIN_DATE: mo,
  MIN_LENGTH: gu,
  Matches: L4,
  Max: x3,
  MaxDate: N3,
  MaxLength: C4,
  MetadataStorage: J0,
  Min: E3,
  MinDate: C3,
  MinLength: N4,
  NOT_CONTAINS: Oo,
  NOT_EQUALS: K1,
  NotContains: T3,
  NotEquals: m3,
  Validate: u3,
  ValidateBy: C,
  ValidateIf: i3,
  ValidateNested: s3,
  ValidatePromise: l3,
  ValidationError: U0,
  ValidationTypes: nt,
  Validator: Ft,
  ValidatorConstraint: o3,
  arrayContains: ws,
  arrayMaxSize: Gs,
  arrayMinSize: Zs,
  arrayNotContains: Ds,
  arrayNotEmpty: js,
  arrayUnique: Hs,
  buildMessage: E,
  contains: Io,
  equals: V1,
  getFromContainer: Mt,
  getMetadataStorage: ft,
  isAlpha: No,
  isAlphanumeric: To,
  isArray: Ps,
  isAscii: Fo,
  isBIC: ei,
  isBase32: Ju,
  isBase58: $s,
  isBase64: Uo,
  isBoolean: ys,
  isBooleanString: Ku,
  isBtcAddress: di,
  isByteLength: ko,
  isCreditCard: Wo,
  isCurrency: Xo,
  isDataURI: ui,
  isDate: As,
  isDateString: ku,
  isDecimal: Do,
  isDefined: D1,
  isDivisibleBy: io,
  isEAN: li,
  isEmail: qo,
  isEmpty: z1,
  isEnum: Is,
  isEthereumAddress: $i,
  isFQDN: e2,
  isFirebasePushId: su,
  isFullWidth: n2,
  isHSL: hi,
  isHalfWidth: a2,
  isHash: ju,
  isHexColor: c2,
  isHexadecimal: $2,
  isIBAN: yi,
  isIP: g2,
  isISBN: S2,
  isISIN: x2,
  isISO31661Alpha2: k2,
  isISO31661Alpha3: K2,
  isISO4217CurrencyCode: ms,
  isISO8601: on,
  isISRC: Ii,
  isISSN: Uu,
  isIdentityCard: _i,
  isIn: q1,
  isInstance: Ws,
  isInt: xs,
  isJSON: L2,
  isJWT: R2,
  isLatLong: He,
  isLatitude: U1,
  isLocale: Ei,
  isLongitude: k1,
  isLowercase: j2,
  isMACAddress: h2,
  isMagnetURI: Pi,
  isMilitaryTime: Ru,
  isMimeType: wi,
  isMobilePhone: U2,
  isMongoId: z2,
  isMultibyte: J2,
  isNegative: fo,
  isNotEmpty: Q1,
  isNotEmptyObject: Ks,
  isNotIn: eo,
  isNumber: Ms,
  isNumberString: zu,
  isObject: hn,
  isOctal: Bi,
  isPassportNumber: Zi,
  isPhoneNumber: Tu,
  isPort: A2,
  isPositive: lo,
  isPostalCode: ki,
  isRFC3339: Ki,
  isRgbColor: zi,
  isSemVer: Ji,
  isString: Cs,
  isStrongPassword: ss,
  isSurrogatePair: eu,
  isTaxId: vs,
  isTimeZone: cs,
  isURL: du,
  isUUID: uu,
  isUppercase: fu,
  isValidationOptions: H0,
  isVariableWidth: i2,
  length: vu,
  matches: Mu,
  max: po,
  maxDate: bo,
  maxLength: mu,
  min: ho,
  minDate: go,
  minLength: yu,
  notContains: xo,
  notEquals: W1,
  registerDecorator: w1,
  registerSchema: u5,
  useContainer: r3,
  validate: d5,
  validateOrReject: a5,
  validateSync: o5
}, Symbol.toStringTag, { value: "Module" })), s5 = /* @__PURE__ */ j9(i5);
var s1;
function l5() {
  if (s1) return bt;
  s1 = 1;
  var e = bt && bt.__decorate || function(d, a, o, u) {
    var i = arguments.length, s = i < 3 ? a : u === null ? u = Object.getOwnPropertyDescriptor(a, o) : u, c;
    if (typeof Reflect == "object" && typeof Reflect.decorate == "function") s = Reflect.decorate(d, a, o, u);
    else for (var l = d.length - 1; l >= 0; l--) (c = d[l]) && (s = (i < 3 ? c(s) : i > 3 ? c(a, o, s) : c(a, o)) || s);
    return i > 3 && s && Object.defineProperty(a, o, s), s;
  };
  Object.defineProperty(bt, "__esModule", { value: !0 }), bt.MatchConstraint = bt.Match = void 0;
  const t = s5, r = (d, a) => (o, u) => (0, t.registerDecorator)({
    target: o.constructor,
    propertyName: u,
    options: a,
    constraints: [d],
    validator: n
  });
  bt.Match = r;
  let n = class {
    validate(d, a) {
      const [o] = (a == null ? void 0 : a.constraints) || [], u = (a == null ? void 0 : a.object)[o];
      return (0, t.equals)(d, u);
    }
    defaultMessage(d) {
      const [a] = (d == null ? void 0 : d.constraints) || [];
      return `${d == null ? void 0 : d.property} does not match the ${a}`;
    }
  };
  return bt.MatchConstraint = n, bt.MatchConstraint = n = e([
    (0, t.ValidatorConstraint)({ name: "Match" })
  ], n), bt;
}
var l1 = {}, c1;
function c5() {
  return c1 || (c1 = 1, Object.defineProperty(l1, "__esModule", { value: !0 })), l1;
}
var we = {}, f1;
function f5() {
  if (f1) return we;
  f1 = 1, Object.defineProperty(we, "__esModule", { value: !0 }), we.isPlural = r;
  const e = /* @__PURE__ */ new Set([
    "address",
    "athletics",
    "billiards",
    "bowels",
    "business",
    "chaos",
    "chess",
    "crossroads",
    "economics",
    "ethics",
    "gallows",
    "gas",
    "genetics",
    "glass",
    "grass",
    "gymnastics",
    "happiness",
    "kindness",
    "linguistics",
    "loneliness",
    "mathematics",
    "measles",
    "minus",
    "mumps",
    "news",
    "physics",
    "progress",
    "success",
    "tennis",
    "acoustics",
    "aerobics",
    "aerodynamics",
    "aeronautics",
    "classics",
    "electronics",
    "logistics",
    "mechanics",
    "obstetrics",
    "politics",
    "statistics",
    "thermodynamics",
    "bowls",
    "cards",
    "darts",
    "diabetes",
    "rabies",
    "draughts",
    "skittles",
    "rickets",
    "shingles",
    "iris",
    "lens",
    "status"
  ]), t = /* @__PURE__ */ new Set([
    "feet",
    "teeth",
    "geese",
    "men",
    "women",
    "mice",
    "dice",
    "oxen",
    "children",
    "people",
    "pence",
    "foci",
    "radii",
    "fungi",
    "nuclei",
    "cacti",
    "alumni",
    "phenomena",
    "criteria",
    "data",
    "memoranda",
    "bacteria",
    "strata",
    "curricula",
    "media",
    "stadia",
    "syllabi",
    "antennae",
    "lice",
    "genera",
    "stimuli"
  ]);
  function r(n) {
    const d = n.toLowerCase();
    return !e.has(d) && !d.endsWith("itis") && !d.endsWith("osis") && (d.endsWith("s") || t.has(d));
  }
  return we;
}
var Bt = {}, $1;
function $5() {
  if ($1) return Bt;
  $1 = 1, Object.defineProperty(Bt, "__esModule", { value: !0 }), Bt.EnumError = void 0, Bt.createLookup = t, Bt.createValues = r;
  class e extends Error {
    constructor(d) {
      super(d), Object.setPrototypeOf(this, e.prototype);
    }
  }
  Bt.EnumError = e;
  function t(n, d, a) {
    const o = Object.entries(n).reduce((i, [s, c]) => Object.assign(Object.assign({}, i), { [c]: s }), {}), u = Object.values(n).join(", ");
    return (i) => {
      if (i == null)
        return i;
      const s = o[i.trim()];
      if (s === void 0) {
        if (d)
          return d;
        const c = `Enum value ${i.trim()} not found in [${u}].`;
        if (a === !0)
          throw new e(c);
        if (typeof a == "function")
          throw a(c);
      }
      return n[s];
    };
  }
  function r(n) {
    const d = Object.values(n).filter((a) => typeof a != "function");
    return () => d;
  }
  return Bt;
}
var p1 = {}, v1;
function p5() {
  return v1 || (v1 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.env = void 0, e.forEnv = a, e.fromEnv = o;
    const t = P1(), r = ce();
    e.env = {
      serialize: n,
      deserialize: d
    };
    function n(u) {
      const i = {};
      return Object.entries(u).forEach(([s, c]) => {
        c === void 0 ? i[s] = "u:" : c === null ? i[s] = "n:" : typeof c == "string" ? i[s] = `S:${c}` : typeof c == "boolean" ? i[s] = `B:${c}` : typeof c == "number" ? i[s] = `N:${c}` : c instanceof Date ? i[s] = `D:${c.toISOString()}` : i[s] = `X:${(0, r.json)(c, !1)}`;
      }), i;
    }
    function d(u) {
      const i = {};
      return Object.entries(u).forEach(([s, c]) => {
        if (c == null) {
          i[s] = c;
          return;
        }
        const [l, $] = (0, r.split)(c, 2);
        switch (l) {
          case "S:":
            i[s] = $;
            break;
          case "B:":
            i[s] = $ === "true";
            break;
          case "N:":
            i[s] = Number($);
            break;
          case "D:":
            i[s] = new Date($);
            break;
          case "X:":
            i[s] = JSON.parse($);
            break;
          case "u:":
            i[s] = void 0;
            break;
          case "n:":
            i[s] = null;
            break;
          default:
            i[s] = c;
            break;
        }
      }), i;
    }
    function a(u, i, s) {
      return e.env.serialize((0, t.flatten)(u, i, s));
    }
    function o(u, i, s) {
      return (0, t.grow)(e.env.deserialize(u), i, s);
    }
  }(p1)), p1;
}
var be = {}, h1;
function v5() {
  if (h1) return be;
  h1 = 1, Object.defineProperty(be, "__esModule", { value: !0 }), be.noop = e, be.debounce = t;
  function e() {
  }
  function t(r, n) {
    let d = null;
    return function(...a) {
      const o = a;
      d && clearTimeout(d), d = setTimeout(() => {
        r(...o), d = null;
      }, n);
    };
  }
  return be;
}
var pt = {}, m1;
function h5() {
  if (m1) return pt;
  m1 = 1;
  var e = pt && pt.__asyncValues || function(u) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i = u[Symbol.asyncIterator], s;
    return i ? i.call(u) : (u = typeof __values == "function" ? __values(u) : u[Symbol.iterator](), s = {}, c("next"), c("throw"), c("return"), s[Symbol.asyncIterator] = function() {
      return this;
    }, s);
    function c($) {
      s[$] = u[$] && function(b) {
        return new Promise(function(m, f) {
          b = u[$](b), l(m, f, b.done, b.value);
        });
      };
    }
    function l($, b, m, f) {
      Promise.resolve(f).then(function(v) {
        $({ value: v, done: m });
      }, b);
    }
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.readBodyBuffer = t, pt.readBodyData = r, pt.readBodyJson = n, pt.parseUrl = d, pt.urlPathJoin = a, pt.urlQueryJoin = o;
  async function t(u, i) {
    var s, c, l, $;
    i = i ?? u;
    let b = i.bodyBuffer;
    if (b === void 0) {
      if (!u.readableLength)
        return;
      const h = [];
      try {
        for (var m = !0, f = e(u), v; v = await f.next(), s = v.done, !s; m = !0) {
          $ = v.value, m = !1;
          const _ = $;
          h.push(_);
        }
      } catch (_) {
        c = { error: _ };
      } finally {
        try {
          !m && !s && (l = f.return) && await l.call(f);
        } finally {
          if (c) throw c.error;
        }
      }
      b = Buffer.concat(h), i.bodyBuffer = b;
    }
    return b;
  }
  async function r(u, i) {
    i = i ?? u;
    let s = i.bodyData;
    if (s === void 0) {
      if (s = await t(u), !s)
        return;
      s = s.toString(), i.bodyData = s;
    }
    return s;
  }
  async function n(u, i) {
    i = i ?? u;
    let s = i.bodyJson;
    if (s === void 0) {
      const c = await r(u);
      if (c === void 0)
        return;
      s = JSON.parse(c), i.bodyJson = s;
    }
    return s;
  }
  function d(u) {
    const i = u.startsWith("https:") ? "https:" : "http:", s = u.indexOf("?");
    let c = u, l = "";
    s !== -1 && (c = u.substr(0, s), l = u.substr(s + 1));
    let $ = c.indexOf("://");
    $ = $ === -1 ? 0 : $ + 3;
    let b = c.indexOf("/", $);
    b = b !== -1 ? b : void 0;
    const m = c.substring($, b);
    let f = "";
    return b !== void 0 && (f = c.substr(b + 1)), {
      protocol: i,
      base: c,
      host: m,
      path: f,
      query: l
    };
  }
  function a(u, ...i) {
    let s = u;
    for (const c of i)
      s.endsWith("/") && c.startsWith("/") ? s += c.substring(1) : s.endsWith("/") || c.startsWith("/") ? s += c : s += "/" + c;
    return s;
  }
  function o(...u) {
    return u.join("&");
  }
  return pt;
}
var ue = {}, g1;
function m5() {
  if (g1) return ue;
  g1 = 1, Object.defineProperty(ue, "__esModule", { value: !0 }), ue.Interval = void 0, ue.interval = a;
  const e = 1e3, t = 60 * (60 * e), r = 24 * t, n = 7 * r;
  class d {
    constructor(u) {
      this.milliseconds = 0, this.milliseconds = u ?? 0;
    }
    millis(u) {
      return this.milliseconds += u, this;
    }
    sec(u) {
      return this.milliseconds += u * e, this;
    }
    min(u) {
      return this.milliseconds += u * t, this;
    }
    hours(u) {
      return this.milliseconds += u * t, this;
    }
    days(u) {
      return this.milliseconds += u * r, this;
    }
    weeks(u) {
      return this.milliseconds += u * n, this;
    }
    value() {
      return this.milliseconds;
    }
    before(u) {
      var i;
      const s = (i = u == null ? void 0 : u.getDate()) !== null && i !== void 0 ? i : Date.now();
      return new Date(s - this.milliseconds);
    }
    after(u) {
      var i;
      const s = (i = u == null ? void 0 : u.getDate()) !== null && i !== void 0 ? i : Date.now();
      return new Date(s + this.milliseconds);
    }
  }
  ue.Interval = d;
  function a(o) {
    return new d(o);
  }
  return ue;
}
var ie = {}, y1;
function g5() {
  if (y1) return ie;
  y1 = 1, Object.defineProperty(ie, "__esModule", { value: !0 }), ie.flushPromises = e, ie.useFakeTimers = t, ie.advanceTimersByTime = r;
  async function e(n = !1) {
    if (n)
      await new Promise((d) => process.nextTick(d));
    else
      return new Promise(jest.requireActual("timers").setImmediate);
  }
  function t(n = !1) {
    n ? jest.useFakeTimers({ legacyFakeTimers: !0 }) : (jest.useFakeTimers(), jest.setSystemTime(0));
  }
  async function r(n) {
    jest.advanceTimersByTime(n), await e();
  }
  return ie;
}
var Re = {}, b1;
function y5() {
  if (b1) return Re;
  b1 = 1, Object.defineProperty(Re, "__esModule", { value: !0 }), Re.pluralize = e;
  function e(t, r, n, d) {
    d = d || n;
    const a = t % 10, o = t % 100;
    return o >= 11 && o <= 14 || a === 0 ? d : a === 1 ? r : a <= 4 ? n : d;
  }
  return Re;
}
var De = {}, A1;
function b5() {
  if (A1) return De;
  A1 = 1, Object.defineProperty(De, "__esModule", { value: !0 }), De.onProcessExit = e;
  function e(t) {
    process.on("exit", () => console.log("EXIT")), process.on("SIGINT", async () => {
      await t(), process.exit();
    }), process.on("SIGTERM", async () => {
      await t(), process.exit();
    }), process.on("SIGUSR1", async () => {
      await t(), process.exit();
    }), process.on("SIGUSR2", async () => {
      await t(), process.exit();
    }), process.on("SIGQUIT", async () => {
      await t(), process.exit();
    });
  }
  return De;
}
var vt = {}, _1;
function A5() {
  if (_1) return vt;
  _1 = 1, Object.defineProperty(vt, "__esModule", { value: !0 }), vt.Deferred = vt.PromiseStatus = void 0, vt.promiseWithStatus = t, vt.resolveDelayed = r, vt.pause = n, vt.rejectDelayed = d;
  var e;
  (function(u) {
    u.pending = "pending", u.fulfilled = "fulfilled", u.rejected = "rejected";
  })(e || (vt.PromiseStatus = e = {}));
  function t(u) {
    const i = Promise.resolve(u);
    return i.status = e.pending, i.then((s) => (i.status = e.fulfilled, s)).catch(() => {
      i.status = e.rejected;
    }), i;
  }
  function r(u, i) {
    return new Promise((s) => {
      setTimeout(() => {
        s(i);
      }, u);
    });
  }
  function n(u) {
    return r(u);
  }
  function d(u, i) {
    return new Promise((s, c) => {
      setTimeout(() => {
        c(i);
      }, u);
    });
  }
  let a = 1;
  class o {
    constructor() {
      this._settled = !1, this._resolved = !1, this._rejected = !1, this._promise = new Promise((i, s) => {
        this.resolveFn = i, this.rejectFn = s;
      }), this.id = a++;
    }
    resolve(i) {
      this.resolveFn(i), this._resolved = !0, this._settled = !0;
    }
    reject(i) {
      this.rejectFn(i), this._rejected = !0, this._settled = !0;
    }
    get promise() {
      return this._promise;
    }
    get isSettled() {
      return this._settled;
    }
    get isRejected() {
      return this._rejected;
    }
    get isResolved() {
      return this._resolved;
    }
  }
  return vt.Deferred = o, vt;
}
var M1 = {}, S1;
function _5() {
  return S1 || (S1 = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.resolved = void 0, e.processTemplate = r;
    function t() {
      function n(a) {
        return Promise.all(a.map((o) => Array.isArray(o) ? n(o) : o));
      }
      function d(a, ...o) {
        return o.length === 1 && a.length === 2 && a[0] === "" && a[1] === "";
      }
      return async function(a, ...o) {
        return d(a, o) ? o[0] : n(o).then((u) => String.raw({ raw: a }, u));
      };
    }
    e.resolved = t();
    async function r(n, d = {}, a = {}) {
      const o = Object.assign(Object.assign(Object.assign({}, d), a), { resolved: e.resolved }), u = Object.keys(o), i = Object.values(o);
      return new Function(...u, "return resolved`" + n + "`")(...i);
    }
  }(M1)), M1;
}
var I1 = {}, O1;
function M5() {
  return O1 || (O1 = 1, Object.defineProperty(I1, "__esModule", { value: !0 })), I1;
}
var Be = {}, x1;
function S5() {
  if (x1) return Be;
  x1 = 1, Object.defineProperty(Be, "__esModule", { value: !0 }), Be.uuid7 = r;
  let e = 0, t = 0;
  function r() {
    function n() {
      const a = d(), o = Math.random(), u = String(a) + String(~~(o * 9e4) + 1e4), i = u.length;
      return `${u.slice(0, 8)}-${u.slice(8, 12)}-4${u.slice(12, 15)}-${[8, 9, "a", "b"][~~(o * 3)]}${u.slice(15, 18)}-${u.slice(18, 24)}${u.slice(i - 12, i - (30 - i))}`;
    }
    function d() {
      const a = Date.now();
      return a !== e && (e = a, t = 1), BigInt(a) * BigInt(1e6) + BigInt(Math.min(t++, 999999));
    }
    return n();
  }
  return Be;
}
var je = {}, E1;
function I5() {
  if (E1) return je;
  E1 = 1, Object.defineProperty(je, "__esModule", { value: !0 }), je.createEmailAlias = e;
  function e(t, r) {
    const [n, d] = t.split("@");
    return n.includes("+") ? `${n}-${r}@${d}` : `${n}+${r}@${d}`;
  }
  return je;
}
var C1;
function O5() {
  return C1 || (C1 = 1, function(e) {
    var t = Ht && Ht.__createBinding || (Object.create ? function(n, d, a, o) {
      o === void 0 && (o = a);
      var u = Object.getOwnPropertyDescriptor(d, a);
      (!u || ("get" in u ? !d.__esModule : u.writable || u.configurable)) && (u = { enumerable: !0, get: function() {
        return d[a];
      } }), Object.defineProperty(n, o, u);
    } : function(n, d, a, o) {
      o === void 0 && (o = a), n[o] = d[a];
    }), r = Ht && Ht.__exportStar || function(n, d) {
      for (var a in n) a !== "default" && !Object.prototype.hasOwnProperty.call(d, a) && t(d, n, a);
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), r(U9(), e), r(P1(), e), r(G9(), e), r(k9(), e), r(H9(), e), r(V9(), e), r(l5(), e), r(c5(), e), r(L1(), e), r(f5(), e), r($5(), e), r(p5(), e), r(v5(), e), r(h5(), e), r(m5(), e), r(g5(), e), r(y5(), e), r(ke(), e), r(b5(), e), r(A5(), e), r(ce(), e), r(_5(), e), r(M5(), e), r(S5(), e), r(I5(), e);
  }(Ht)), Ht;
}
O5();
function Fe(e, t) {
  if (e.length === 0)
    return {};
  if (!t)
    return {
      "": e
    };
  const r = {};
  return e.forEach((n) => {
    const d = n[t] || "";
    r[d] || (r[d] = []), r[d].push(n);
  }), r;
}
function x5(e, t) {
  const r = JSON.parse(JSON.stringify(e));
  for (const [n, d] of Object.entries(r))
    r[n] = d.filter((a) => !t.find((o) => o.value === a.value));
  return r;
}
function E5(e, t) {
  for (const [, r] of Object.entries(e))
    if (r.some((n) => t.find((d) => d.value === n.value)))
      return !0;
  return !1;
}
const Ys = N1(
  ({ className: e, ...t }, r) => C9((d) => d.filtered.count === 0) ? /* @__PURE__ */ at(
    "div",
    {
      ref: r,
      className: Et("py-6 text-center text-sm", e),
      "cmdk-empty": "",
      role: "presentation",
      ...t
    }
  ) : null
);
Ys.displayName = "CommandEmpty";
const C5 = N1(
  ({
    value: e,
    onChange: t,
    placeholder: r,
    defaultOptions: n = [],
    options: d,
    delay: a,
    onSearch: o,
    onSearchSync: u,
    loadingIndicator: i,
    emptyIndicator: s,
    maxSelected: c = Number.MAX_SAFE_INTEGER,
    onMaxSelected: l,
    hidePlaceholderWhenSelected: $,
    disabled: b,
    groupBy: m,
    className: f,
    badgeClassName: v,
    selectFirstItem: h = !0,
    creatable: _ = !1,
    triggerSearchOnFocus: O = !1,
    commandProps: y,
    inputProps: M,
    hideClearAllButton: N = !1,
    tabIndex: D
  }, x) => {
    const A = bn(null), [S, P] = jt(!1), [Z, G] = jt(!1), [K, Y] = jt(!1), it = bn(null), [V, At] = jt(e || []), [$t, It] = jt(Fe(n, m)), [st, Pt] = jt(""), ct = B9(st, a || 500);
    w9(
      x,
      () => ({
        selectedValue: [...V],
        input: A.current,
        focus: () => {
          var F;
          return (F = A.current) == null ? void 0 : F.focus();
        }
      }),
      [V]
    );
    const mt = (F) => {
      it.current && !it.current.contains(F.target) && A.current && !A.current.contains(F.target) && P(!1);
    }, Ot = Le(
      (F) => {
        const k = V.filter((z) => z.value !== F.value);
        At(k), t == null || t(k);
      },
      [t, V]
    ), fe = Le(
      (F) => {
        const k = A.current;
        k && ((F.key === "Delete" || F.key === "Backspace") && k.value === "" && V.length > 0 && (V[V.length - 1].fixed || Ot(V[V.length - 1])), F.key === "Escape" && k.blur(), F.key === "Enter" && k.focus());
      },
      [Ot, V]
    );
    se(() => (S ? (document.addEventListener("mousedown", mt), document.addEventListener("touchend", mt)) : (document.removeEventListener("mousedown", mt), document.removeEventListener("touchend", mt)), () => {
      document.removeEventListener("mousedown", mt), document.removeEventListener("touchend", mt);
    }), [S]), se(() => {
      e && At(e);
    }, [e]), se(() => {
      if (!d || o)
        return;
      const F = Fe(d || [], m);
      JSON.stringify(F) !== JSON.stringify($t) && It(F);
    }, [n, d, m, o, $t]), se(() => {
      const F = () => {
        const z = u == null ? void 0 : u(ct);
        It(Fe(z || [], m));
      };
      (async () => {
        !u || !S || (O && F(), ct && F());
      })();
    }, [ct, m, S, O]), se(() => {
      const F = async () => {
        Y(!0);
        const z = await (o == null ? void 0 : o(ct));
        It(Fe(z || [], m)), Y(!1);
      };
      (async () => {
        !o || !S || (O && await F(), ct && await F());
      })();
    }, [ct, m, S, O]);
    const $e = () => {
      if (!_ || E5($t, [{ value: st, label: st }]) || V.find((k) => k.value === st))
        return;
      const F = /* @__PURE__ */ at(
        Pe,
        {
          value: st,
          className: "cursor-pointer",
          onMouseDown: (k) => {
            k.preventDefault(), k.stopPropagation();
          },
          onSelect: (k) => {
            if (V.length >= c) {
              l == null || l(V.length);
              return;
            }
            Pt("");
            const z = [...V, { value: k, label: k }];
            At(z), t == null || t(z);
          },
          children: `Create "${st}"`
        }
      );
      if (!o && st.length > 0 || o && ct.length > 0 && !K)
        return F;
    }, pe = Le(() => {
      if (s)
        return o && !_ && Object.keys($t).length === 0 ? /* @__PURE__ */ at(Pe, { value: "-", disabled: !0, children: s }) : /* @__PURE__ */ at(Ys, { children: s });
    }, [_, s, o, $t]), ve = R9(() => x5($t, V), [$t, V]), Zt = Le(() => {
      if (y != null && y.filter)
        return y.filter;
      if (_)
        return (F, k) => F.toLowerCase().includes(k.toLowerCase()) ? 1 : -1;
    }, [_, y == null ? void 0 : y.filter]);
    return /* @__PURE__ */ Ne(
      N9,
      {
        tabIndex: D,
        ref: it,
        ...y,
        onKeyDown: (F) => {
          var k;
          fe(F), (k = y == null ? void 0 : y.onKeyDown) == null || k.call(y, F);
        },
        className: Et(
          "outline-border outline-1 h-auto overflow-visible bg-transparent",
          y == null ? void 0 : y.className
        ),
        shouldFilter: (y == null ? void 0 : y.shouldFilter) !== void 0 ? y.shouldFilter : !o,
        filter: Zt(),
        children: [
          /* @__PURE__ */ at(
            "div",
            {
              className: Et(
                "min-h-10 rounded-md border border-input text-sm ring-offset-background focus-visible:ring-0 focus-within:ring-1 focus-within:ring-ring focus-within:ring-offset-1",
                {
                  "px-3 py-2": V.length !== 0,
                  "cursor-text": !b && V.length !== 0
                },
                f
              ),
              onClick: () => {
                var F;
                b || (F = A.current) == null || F.focus();
              },
              children: /* @__PURE__ */ Ne("div", { className: "relative flex flex-wrap gap-1", children: [
                V.map((F) => /* @__PURE__ */ Ne(
                  D9,
                  {
                    className: Et(
                      "data-[disabled]:bg-muted-foreground data-[disabled]:text-muted data-[disabled]:hover:bg-muted-foreground",
                      "data-[fixed]:bg-muted-foreground data-[fixed]:text-muted data-[fixed]:hover:bg-muted-foreground",
                      v
                    ),
                    "data-fixed": F.fixed,
                    "data-disabled": b || void 0,
                    children: [
                      F.label,
                      /* @__PURE__ */ at(
                        "button",
                        {
                          className: Et(
                            "ml-1 rounded-full outline-none ring-offset-background focus:ring-2 focus:ring-ring focus:ring-offset-2",
                            (b || F.fixed) && "hidden"
                          ),
                          onKeyDown: (k) => {
                            k.key === "Enter" && Ot(F);
                          },
                          onMouseDown: (k) => {
                            k.preventDefault(), k.stopPropagation();
                          },
                          onClick: () => Ot(F),
                          children: /* @__PURE__ */ at(An, { className: "size-3 text-muted-foreground hover:text-foreground" })
                        }
                      )
                    ]
                  },
                  F.value
                )),
                /* @__PURE__ */ at(
                  P9.Input,
                  {
                    ...M,
                    ref: A,
                    value: st,
                    disabled: b,
                    onValueChange: (F) => {
                      var k;
                      Pt(F), (k = M == null ? void 0 : M.onValueChange) == null || k.call(M, F);
                    },
                    onBlur: (F) => {
                      var k;
                      Z || P(!1), (k = M == null ? void 0 : M.onBlur) == null || k.call(M, F);
                    },
                    onFocus: (F) => {
                      var k;
                      P(!0), O && (o == null || o(ct)), (k = M == null ? void 0 : M.onFocus) == null || k.call(M, F);
                    },
                    placeholder: $ && V.length !== 0 ? "" : r,
                    className: Et(
                      "flex-1 bg-transparent outline-none placeholder:text-muted-foreground",
                      {
                        "w-full": $,
                        "px-3 py-2": V.length === 0,
                        "ml-1": V.length !== 0
                      },
                      M == null ? void 0 : M.className
                    )
                  }
                ),
                /* @__PURE__ */ at(
                  "button",
                  {
                    type: "button",
                    onClick: () => {
                      At(V.filter((F) => F.fixed)), t == null || t(V.filter((F) => F.fixed));
                    },
                    className: Et(
                      "absolute right-0 h-6 w-6 p-0",
                      (N || b || V.length < 1 || V.filter((F) => F.fixed).length === V.length) && "hidden"
                    ),
                    children: /* @__PURE__ */ at(An, { className: "size-4 text-muted-foreground hover:text-foreground" })
                  }
                )
              ] })
            }
          ),
          /* @__PURE__ */ at("div", { className: "relative", children: S && /* @__PURE__ */ at(
            L9,
            {
              className: "absolute top-1 z-10 w-full rounded-md border bg-popover text-popover-foreground shadow-md outline-none animate-in",
              onMouseLeave: () => {
                G(!1);
              },
              onMouseEnter: () => {
                G(!0);
              },
              onMouseUp: () => {
                var F;
                (F = A.current) == null || F.focus();
              },
              children: K ? /* @__PURE__ */ at(ze, { children: i }) : /* @__PURE__ */ Ne(ze, { children: [
                pe(),
                $e(),
                !h && /* @__PURE__ */ at(Pe, { value: "-", className: "hidden" }),
                Object.entries(ve).map(([F, k]) => /* @__PURE__ */ at(T9, { heading: F, className: "h-full overflow-auto", children: /* @__PURE__ */ at(ze, { children: k.map((z) => /* @__PURE__ */ at(
                  Pe,
                  {
                    value: z.value,
                    disabled: z.disable,
                    onMouseDown: (dt) => {
                      dt.preventDefault(), dt.stopPropagation();
                    },
                    onSelect: () => {
                      if (V.length >= c) {
                        l == null || l(V.length);
                        return;
                      }
                      Pt("");
                      const dt = [...V, z];
                      At(dt), t == null || t(dt);
                    },
                    className: Et(
                      "cursor-pointer",
                      z.disable && "cursor-default text-muted-foreground"
                    ),
                    children: z.label
                  },
                  z.value
                )) }) }, F))
              ] })
            }
          ) })
        ]
      }
    );
  }
);
C5.displayName = "Multiselect";
export {
  C5 as Multiselect
};
//# sourceMappingURL=multiselect.js.map
